import EventEmitter from 'node_modules/eventemitter3';
import Baobab from 'node_modules/baobab/dist/baobab.js';
import detectBrowser from 'node_modules/detect-browser';
import Tabbable from 'node_modules/tabbable';
import 'node_modules/file-saver/dist/FileSaver.js';
import JSZip from 'node_modules/jszip/dist/jszip.js';
import fetchJsonp from 'node_modules/fetch-jsonp';
import 'node_modules/core-js/client/shim.js';
import 'node_modules/console-shim';
import 'node_modules/gsap/src/uncompressed/TweenLite.js';
import 'node_modules/gsap/src/uncompressed/plugins/ScrollToPlugin.js';
import 'node_modules/gsap/src/uncompressed/easing/EasePack.js';
import 'node_modules/focus-visible';
import 'node_modules/html5shiv';
import 'node_modules/element-qsa-scope';
import 'node_modules/objectFitPolyfill';
import 'node_modules/polyfill-queryselector';
import 'node_modules/whatwg-fetch';
import 'node_modules/formdata-polyfill';

var _classCallCheck = (function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
});

var _possibleConstructorReturn = (function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
});

var _createClass = (function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();

var _inherits = (function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
});

var _defineProperty = (function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
});

var Obj = function (_EventEmitter) {
    _inherits(Obj, _EventEmitter);

    function Obj(opts) {
        _classCallCheck(this, Obj);

        var _this = _possibleConstructorReturn(this, (Obj.__proto__ || Object.getPrototypeOf(Obj)).call(this));

        _this._passiveeventlisteners = false;

        try {
            var testOpts = Object.defineProperty({}, 'passive', {
                get: function get() {
                    _this._passiveeventlisteners = true;
                }
            });

            window.addEventListener('test', testOpts, testOpts);
            window.removeEventListener('test', testOpts, testOpts);
        } catch (err) {
            console.warn('Passive Listening Not Supported');
        }

        if (opts) _this.extend(opts);
        return _this;
    }

    _createClass(Obj, [{
        key: 'extend',
        value: function extend() {
            var _this2 = this;

            var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (typeof obj !== 'object' || Array.isArray(obj)) return this;

            Object.keys(obj).forEach(function (opt) {
                _this2[opt] = obj[opt];
            });

            return this;
        }
    }]);

    return Obj;
}(EventEmitter);

var Component = function (_Obj) {
    _inherits(Component, _Obj);

    function Component() {
        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, Component);

        var _this = _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).call(this, opts));

        _this.state = new Baobab(_this.state || {});

        _this._resizing = false;
        _this._features = {};

        _this.addFeatureTest({
            passiveeventlisteners: _this._passiveeventlisteners,
            touch: function touch() {
                return 'ontouchstart' in window && !window.navigator.userAgent.match(/X11/) || 'DocumentTouch' in window && document instanceof window.DocumentTouch || (window.navigator.maxTouchPoints || 0) > 0;
            }
        });

        delete _this._passiveeventlisteners;

        if (_this.getBrowser('name')) _this.addFeatureTest(_defineProperty({}, _this.getBrowser('name'), true));

        if (!_this.el) return _possibleConstructorReturn(_this);

        _this.el.setAttribute('data-rendered', true);
        _this.addFeaturesToClassName(_this.el, 'touch');

        if (_this.el.nodeType !== 1 || !_this.el.parentElement || !(['MutationObserver'] in window)) return _possibleConstructorReturn(_this);

        var emitResize = function emitResize() {
            _this.emit('resize');

            clearTimeout(_this._onResizeDebounce);

            _this._onResizeDebounce = setTimeout(function () {
                return _this.emit('resize:debounced');
            }, 200);
        };

        window.addEventListener('resize', emitResize, false);

        var observer = new window.MutationObserver(function (mutations) {
            return mutations.filter(function (mutation) {
                return mutation.removedNodes.length;
            }).forEach(function (mutation) {
                for (var i = 0; i < mutation.removedNodes.length; i++) {
                    if (mutation.removedNodes[i] === _this.el) {
                        observer.disconnect();

                        _this.emit('destroy');
                        _this.removeAllListeners();

                        window.removeEventListener('resize', emitResize, false);
                    }
                }
            });
        });

        observer.observe(_this.el.parentElement, { childList: true });
        return _this;
    }

    _createClass(Component, [{
        key: 'addFeatureTest',
        value: function addFeatureTest(obj) {
            var _this2 = this;

            Object.keys(obj).filter(function (key) {
                return (typeof obj[key]).match(/boolean|function/);
            }).forEach(function (key) {
                _this2._features[key] = typeof obj[key] === 'boolean' ? obj[key] : obj[key]();
            });

            return this;
        }
    }, {
        key: 'addFeaturesToClassName',
        value: function addFeaturesToClassName() {
            var _this3 = this;

            var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.el || document.documentElement;
            var feature = arguments[1];

            Object.keys(this.getFeatures()).filter(function (key) {
                return !feature || feature && typeof feature === 'string' && key === feature;
            }).forEach(function (key) {
                return el.classList.add('' + (_this3.getFeatures()[key] ? '' : 'no-') + key);
            });

            return this;
        }
    }, {
        key: 'detectCSSProp',
        value: function detectCSSProp(str) {
            var style = document.createElement('a').style;
            style.cssText = str + ':auto';

            var camelCase = str.toLowerCase().replace(/(-\w{1})/g, function (str) {
                return str.replace(/^-/, '').toUpperCase();
            });

            return style[camelCase] === 'auto';
        }
    }, {
        key: 'getBrowser',
        value: function getBrowser(str) {
            var browser = detectBrowser.detect() || { name: null, version: null };

            return !str || !(str in browser) ? browser : browser[str];
        }
    }, {
        key: 'getFeature',
        value: function getFeature() {
            var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            return typeof str === 'string' && str in this.getFeatures() ? this.getFeatures()[str] : null;
        }
    }, {
        key: 'getFeatures',
        value: function getFeatures() {
            this._features = this._features || {};
            return this._features;
        }
    }, {
        key: 'generateGUID',
        value: function generateGUID() {
            var s4 = function s4() {
                return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
            };

            return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + (s4() + s4() + s4());
        }
    }]);

    return Component;
}(Obj);

var GlobalHeaderComponent = function (_Component) {
    _inherits(GlobalHeaderComponent, _Component);

    _createClass(GlobalHeaderComponent, null, [{
        key: 'selector',
        value: function selector() {
            return '#global-header';
        }
    }]);

    function GlobalHeaderComponent(opts) {
        _classCallCheck(this, GlobalHeaderComponent);

        var _this = _possibleConstructorReturn(this, (GlobalHeaderComponent.__proto__ || Object.getPrototypeOf(GlobalHeaderComponent)).call(this, opts));

        _this.onKeydown = _this.onKeydown.bind(_this);

        _this.onPrimaryMenuSubnavToggleBtnClick = _this.onPrimaryMenuSubnavToggleBtnClick.bind(_this);

        _this.onPrimaryMenuSubnavToggleBtnKeydown = _this.onPrimaryMenuSubnavToggleBtnKeydown.bind(_this);

        _this.onPrimaryMenuToggleBtnClick = _this.onPrimaryMenuToggleBtnClick.bind(_this);

        _this.onPrimaryMenuToggleBtnKeydown = _this.onPrimaryMenuToggleBtnKeydown.bind(_this);

        _this.onScroll = _this.onScroll.bind(_this);

        _this.addFeaturesToClassName();
        _this.render();
        _this.listen();
        return _this;
    }

    _createClass(GlobalHeaderComponent, [{
        key: 'listen',
        value: function listen() {
            var _this2 = this;

            this.getPrimaryMenuToggleBtns().forEach(function (el) {
                el.addEventListener('keydown', _this2.onPrimaryMenuToggleBtnKeydown);

                el.addEventListener('click', _this2.onPrimaryMenuToggleBtnClick);
            });

            this.getPrimaryMenuSubnavToggleBtns().forEach(function (el) {
                el.addEventListener('keydown', _this2.onPrimaryMenuSubnavToggleBtnKeydown);

                el.addEventListener('click', _this2.onPrimaryMenuSubnavToggleBtnClick);
            });

            this.el.addEventListener('keydown', this.onKeydown);

            if ((RootComponent.Scroller || {}).state) RootComponent.Scroller.state.on('update', this.onScroll);

            this.on('resize', function (e) {
                if (!_this2.props.resizing && !(_this2.el.classList.contains('android') && !_this2.isDisabledStickyNavBrowser())) _this2.props.resizing = true;

                _this2.render();
                _this2.onScroll();
            });

            this.on('resize:debounced', function () {
                return _this2.el.removeAttribute('data-resizing');
            });
        }
    }, {
        key: 'onKeydown',
        value: function onKeydown(e) {
            if (!(e.keyIdentifier || e.key || '').match(/tab/i) || !this.isSmallViewport() || !this.isPrimaryMenuExpanded()) return;

            var activeEl = void 0;

            var els = Tabbable(this.el);

            if (e.shiftKey && els.indexOf(e.target) === 0) activeEl = els[els.length - 1];

            if (!e.shiftKey && els.indexOf(e.target) === els.length - 1) activeEl = els[0];

            if (!activeEl) return;

            e.preventDefault();
            e.stopPropagation();

            activeEl.focus();
        }
    }, {
        key: 'onScroll',
        value: function onScroll() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                data: {
                    currentData: (RootComponent.Scroller || {}).state ? RootComponent.Scroller.state.get() : {}
                }
            };

            if (!this.el || this.el.clientWidth <= 320 || this.isShortViewport() || this.isDisabledStickyNavBrowser()) return;

            var data = e.data.currentData;
            var contentTop = this.getRootComponentContentEl() ? this.getRootComponentContentEl().getBoundingClientRect().top || 0 : 0;

            if ((!data.scrollY || contentTop > this.getHeightCollapsed()) && this.props.sticky) {
                this.el.removeAttribute('data-sticky');
                return this.render();
            } else if (data.scrollY && contentTop <= this.getHeightCollapsed() && !this.props.sticky) {
                this.el.setAttribute('data-sticky', true);
                return this.render();
            }
        }
    }, {
        key: 'onPrimaryMenuSubnavToggleBtnClick',
        value: function onPrimaryMenuSubnavToggleBtnClick(e) {
            var target = e.target.getAttribute('aria-controls') ? e.target : e.target.parentNode.getAttribute('aria-controls') ? e.target.parentNode : null;
            var controls = target && target.getAttribute('aria-controls') ? this.el.querySelector('#' + target.getAttribute('aria-controls')) : null;

            if (!controls) return;

            var isExpanded = target.getAttribute('aria-expanded') === 'true';

            target.setAttribute('aria-expanded', !isExpanded);
            controls.classList[isExpanded ? 'remove' : 'add']('active');

            this.renderPrimaryMenuSubnavToggleBtns();
        }
    }, {
        key: 'onPrimaryMenuSubnavToggleBtnKeydown',
        value: function onPrimaryMenuSubnavToggleBtnKeydown(e) {
            if (e.keyCode === 32 || (e.keyIdentifier || e.key || '').match(/^(enter)$/i)) this.onPrimaryMenuSubnavToggleBtnClick(e);
        }
    }, {
        key: 'onPrimaryMenuToggleBtnClick',
        value: function onPrimaryMenuToggleBtnClick(e) {
            this.setPrimaryMenuToggleState(this.isPrimaryMenuExpanded() ? 'collapsed' : 'expanded');

            RootComponent.emit('scroll:' + (this.isPrimaryMenuExpanded() && !this.isShortViewport() ? 'disable' : 'enable'));

            this.el.style.transition = 'none';
            this.render();
        }
    }, {
        key: 'onPrimaryMenuToggleBtnKeydown',
        value: function onPrimaryMenuToggleBtnKeydown(e) {
            if (e.keyCode === 32 || (e.keyIdentifier || e.key || '').match(/^(enter)$/i)) this.onPrimaryMenuToggleBtnClick();
        }
    }, {
        key: 'isPrimaryMenuExpanded',
        value: function isPrimaryMenuExpanded() {
            return this.props.primaryMenuToggleState === 'expanded';
        }
    }, {
        key: 'isPrimaryMenuFullWidth',
        value: function isPrimaryMenuFullWidth() {
            return this.isSmallViewport() && this.getPrimaryMenuToggleTarget().clientHeight > 1;
        }
    }, {
        key: 'isShortViewport',
        value: function isShortViewport() {
            return this.props.shortViewport === 'true';
        }
    }, {
        key: 'isSmallViewport',
        value: function isSmallViewport() {
            return this.getPrimaryMenuToggleTarget() && this.getPrimaryMenuToggleTarget().parentNode && this.getPrimaryMenuToggleTarget().clientWidth === this.getPrimaryMenuToggleTarget().parentNode.clientWidth;
        }
    }, {
        key: 'isDisabledStickyNavBrowser',
        value: function isDisabledStickyNavBrowser() {
            return this.getFeature('touch') && !window.navigator.userAgent.match(/(chrome|iphone|ipad)/i);
        }
    }, {
        key: 'getPrimaryMenuSubnavToggleBtns',
        value: function getPrimaryMenuSubnavToggleBtns() {
            return Array.from(this.el.querySelectorAll('.primary-menu-subnav-toggle-btn'));
        }
    }, {
        key: 'getPrimaryMenuToggleBtns',
        value: function getPrimaryMenuToggleBtns() {
            return Array.from(this.el.querySelectorAll('.primary-menu-toggle-btn'));
        }
    }, {
        key: 'getPrimaryMenuToggleTarget',
        value: function getPrimaryMenuToggleTarget() {
            return this.el.querySelector(this.props.primaryMenuToggleTarget);
        }
    }, {
        key: 'getRootComponentContentEl',
        value: function getRootComponentContentEl() {
            return RootComponent && RootComponent.el ? RootComponent.el.querySelector('main') : null;
        }
    }, {
        key: 'getHeightCollapsed',
        value: function getHeightCollapsed() {
            var navHeight = ((this.el.querySelector('nav.primary') || {}).clientHeight || 0) + ((this.el.querySelector('nav.secondary') || {}).clientHeight || 0) - 1;

            if (this.isPrimaryMenuFullWidth()) navHeight = navHeight - this.getPrimaryMenuToggleTarget().clientHeight;

            return navHeight;
        }
    }, {
        key: 'getHeightExpanded',
        value: function getHeightExpanded() {
            return this.getHeightCollapsed() + this.getHeadingHeight();
        }
    }, {
        key: 'getHeadingHeight',
        value: function getHeadingHeight() {
            return (this.el.querySelector('h1') || {}).clientHeight || 0;
        }
    }, {
        key: 'setPrimaryMenuToggleState',
        value: function setPrimaryMenuToggleState(state) {
            this.el.setAttribute('data-primary-menu-toggle-state', state.match(/^(collapsed|expanded)$/) ? state : 'collapsed');
        }
    }, {
        key: 'setSiblingAriaHiddenAttr',
        value: function setSiblingAriaHiddenAttr() {
            var _this3 = this;

            if (this.el.getAttribute('aria-hidden') === 'true') return;

            Array.from((RootComponent.el || {}).children).filter(function (el) {
                return !el.tagName.match(/script/i) && el !== _this3.el;
            }).forEach(function (el) {
                if (el.getAttribute('aria-hidden') && (!_this3.isSmallViewport() || _this3.isSmallViewport() && !_this3.isPrimaryMenuExpanded())) return el.id !== 'modal' ? el.removeAttribute('aria-hidden') : null;

                if (_this3.isPrimaryMenuExpanded() && _this3.isSmallViewport() && el.getAttribute('aria-hidden') !== 'true') el.setAttribute('aria-hidden', true);
            });
        }
    }, {
        key: 'renderHeading',
        value: function renderHeading() {
            var heading = this.el.querySelector('h1');
            var content = this.getRootComponentContentEl();

            if (!heading || !content || content.querySelector('h1[data-clone]') || this.el.querySelector('nav.secondary')) return;

            var clone = heading.cloneNode(true);

            clone.setAttribute('data-clone', true);
            clone.classList.add('display-none-lg-up');

            !content.children.length ? content.appendChild(clone) : content.insertBefore(clone, content.children[0]);
        }
    }, {
        key: 'renderPrimaryMenuSubnavToggleBtns',
        value: function renderPrimaryMenuSubnavToggleBtns() {
            this.getPrimaryMenuSubnavToggleBtns().forEach(function (el) {
                if (!el.getAttribute('tabindex')) el.setAttribute('tabindex', 0);

                var isExpanded = Boolean(el.getAttribute('aria-expanded'));

                var label = void 0;

                if (el.getAttribute('data-aria-label-collapsed') && !isExpanded) label = el.getAttribute('data-aria-label-collapsed');else if (el.getAttribute('data-aria-label-expanded') && isExpanded) label = el.getAttribute('data-aria-label-expanded');

                if (label) el.setAttribute('aria-label', label);
            });
        }
    }, {
        key: 'renderPrimaryMenuToggleBtns',
        value: function renderPrimaryMenuToggleBtns() {
            var _this4 = this;

            if (!this.getPrimaryMenuToggleTarget()) return;

            this.getPrimaryMenuToggleBtns().forEach(function (el) {
                if (!el.getAttribute('tabindex')) el.setAttribute('tabindex', 0);

                if (el.getAttribute('aria-controls') !== _this4.props.primaryMenuToggleTarget.replace(/^#/, '')) el.setAttribute('aria-controls', _this4.props.primaryMenuToggleTarget.replace(/^#/, ''));

                if (el.getAttribute('aria-expanded') !== String(_this4.isPrimaryMenuExpanded())) el.setAttribute('aria-expanded', _this4.isPrimaryMenuExpanded());

                var label = void 0;

                if (el.getAttribute('data-aria-label-collapsed') && !_this4.isPrimaryMenuExpanded()) label = el.getAttribute('data-aria-label-collapsed');else if (el.getAttribute('data-aria-label-expanded') && _this4.isPrimaryMenuExpanded()) label = el.getAttribute('data-aria-label-expanded');

                if (label) el.setAttribute('aria-label', label);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            if (window.navigator.userAgent.match(/android/i) && !this.el.classList.contains('android')) this.el.classList.add('android');

            this.props.shortViewport = window.innerHeight < 325;

            if (this.props.stickyOffset !== String(this.getHeightCollapsed())) this.props.stickyOffset = this.getHeightCollapsed();

            if (this.isDisabledStickyNavBrowser() && !this.props.stickyDisabled) this.props.stickyDisabled = true;

            if (this.el.querySelector('nav.secondary') && !this.props.hasNavSecondary) this.props.hasNavSecondary = true;

            this.renderHeading();
            this.renderPrimaryMenuToggleBtns();
            this.renderPrimaryMenuSubnavToggleBtns();
            this.setSiblingAriaHiddenAttr();

            if (this.isPrimaryMenuFullWidth() && !this.isShortViewport() && !document.documentElement.classList.contains('overflow-hidden')) RootComponent.emit('scroll:disable');else if (document.documentElement.classList.contains('overflow-hidden') && !RootComponent.el.querySelector('#modal[aria-hidden="false"]')) RootComponent.emit('scroll:enable');

            var navs = this.el.querySelector('#global-header-navs');
            var navSecondary = this.el.querySelector('.global-header-navs-secondary');

            if (!this.el.getAttribute('style')) {
                this.el.style.transition = 'none';

                if (navSecondary) navSecondary.setAttribute('data-transition-none', true);
            }

            if (this.el.style.paddingBottom !== this.getHeightExpanded() + 'px') this.el.style.paddingBottom = this.getHeightExpanded() + 'px';

            if (navs && navSecondary && this.props.sticky) {
                if (navs.clientHeight !== this.getHeightCollapsed()) navs.style.height = this.getHeightCollapsed() + 'px';

                var translateY = Number((navSecondary.getAttribute('style') || '').replace(/(.+\()([-|\d]*)(.+)/, '$2') || 0);

                if (translateY !== this.getHeadingHeight() * -1) navSecondary.setAttribute('style', 'transform: translateY(' + this.getHeadingHeight() * -1 + 'px)');
            } else if (navs && navSecondary && !this.props.sticky && !this.stickyDisabled && navs.getAttribute('style')) {
                navs.removeAttribute('style');
                navSecondary.removeAttribute('style');
            }

            if (this.el.style.transition.match(/^none/)) setTimeout(function () {
                _this5.el.style.transition = '';

                if (navSecondary) navSecondary.removeAttribute('data-transition-none');
            }, 50);
        }
    }]);

    return GlobalHeaderComponent;
}(Component);

var GlobalFooterComponent = function (_Component) {
    _inherits(GlobalFooterComponent, _Component);

    _createClass(GlobalFooterComponent, null, [{
        key: 'selector',
        value: function selector() {
            return '#global-footer';
        }
    }]);

    function GlobalFooterComponent(opts) {
        _classCallCheck(this, GlobalFooterComponent);

        var _this = _possibleConstructorReturn(this, (GlobalFooterComponent.__proto__ || Object.getPrototypeOf(GlobalFooterComponent)).call(this, opts));

        _this.render();
        _this.listen();
        return _this;
    }

    _createClass(GlobalFooterComponent, [{
        key: 'listen',
        value: function listen() {
            this.on('resize', this.render.bind(this));
            this.on('resize:debounced', this.render.bind(this));
        }
    }, {
        key: 'isSizeContactsItemsHeadings',
        value: function isSizeContactsItemsHeadings() {
            if (this.getContactsItems().length < 2) return false;

            var contacts = this.el.querySelector('.global-footer-contacts');

            return contacts.clientWidth !== this.getContactsItems()[0].clientWidth;
        }
    }, {
        key: 'getContactsItems',
        value: function getContactsItems() {
            return Array.from(this.el.querySelectorAll('.global-footer-contacts-item'));
        }
    }, {
        key: 'getContactsItemsHeadings',
        value: function getContactsItemsHeadings() {
            return this.getContactsItems().map(function (el) {
                return el.querySelector('h2');
            }).filter(function (el) {
                return el;
            });
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.getContactsItemsHeadings().length) return;

            this.getContactsItemsHeadings().filter(function (el) {
                return el.getAttribute('style');
            }).forEach(function (el) {
                return el.removeAttribute('style');
            });

            if (!this.isSizeContactsItemsHeadings()) return;

            var minHeight = this.getContactsItemsHeadings().map(function (el) {
                return el.clientHeight;
            }).sort(function (a, b) {
                return b - a;
            })[0] + 1 + 'px';

            this.getContactsItemsHeadings().filter(function (el) {
                return el.style.minHeight !== minHeight;
            }).forEach(function (el) {
                return el.setAttribute('style', 'min-height: ' + minHeight);
            });
        }
    }]);

    return GlobalFooterComponent;
}(Component);

var CastMembersComponent = function (_Component) {
    _inherits(CastMembersComponent, _Component);

    _createClass(CastMembersComponent, null, [{
        key: 'selector',
        value: function selector() {
            return '.cast-members';
        }
    }]);

    function CastMembersComponent(opts) {
        _classCallCheck(this, CastMembersComponent);

        var _this = _possibleConstructorReturn(this, (CastMembersComponent.__proto__ || Object.getPrototypeOf(CastMembersComponent)).call(this, opts));

        if (window.location.href.match(/(\/page\/*\d*\/*)(?:[#|?].*)*$/)) window.location = window.location.href.replace(/(.+)(\/page\/*\d*\/*)(?:[#|?].*)*$/, '$1');

        _this.addFeaturesToClassName();

        if (window.navigator.userAgent.match(/ios|ipad/i) && !_this.el.classList.contains('ios')) _this.el.classList.add('ios');

        _this.onScroll = _this.onScroll.bind(_this);
        _this.onCastMembersNavItemsClick = _this.onCastMembersNavItemsClick.bind(_this);

        _this.observePaginationFetcher();
        _this.observePaginationFetcherCta();
        return _this;
    }

    _createClass(CastMembersComponent, [{
        key: 'listen',
        value: function listen() {
            var _this2 = this;

            this.getCastMembersNavItems().forEach(function (el) {
                return el.addEventListener('click', _this2.onCastMembersNavItemsClick);
            });

            if ((RootComponent.Scroller || {}).state) RootComponent.Scroller.state.on('update', this.onScroll);

            this.on('resize', function () {
                if (_this2.getFeature('touch')) return;

                _this2.render();
                _this2.onScroll();
            });

            this.on('resize:debounced', function () {
                _this2.render();
                _this2.onScroll();
            });

            if (RootComponent.Scroller) RootComponent.Scroller.on('scrollingTo:complete', function () {
                return _this2.setCastMembersNavActiveItem(_this2.forceActiveItem);
            });
        }
    }, {
        key: 'onScroll',
        value: function onScroll() {
            var _this3 = this;

            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                data: {
                    currentData: (RootComponent.Scroller || {}).state ? RootComponent.Scroller.state.get() : {}
                }
            };

            if (!this.el || this.el.clientWidth <= 320 || this.isShortViewport() || this.isDisabledStickyNavBrowser() || !this.getCastMembersNav() || !this.getCastMembersNavWrapper() || !this.isGlobalHeaderNavsSticky()) return;

            var data = e.data.currentData;
            var top = (this.getCastMembersNavWrapper().getBoundingClientRect().top || 0) - this.getGlobalHeaderNavsHeight();
            var stickyOffset = (this.getCastMembersNavWrapper().getBoundingClientRect().bottom || 0) - this.getGlobalHeaderStickyOffset();
            var navItems = this.getCastMembersNavItems().filter(function (el) {
                return !el.getAttribute('aria-disabled');
            });

            if (!data.scrollY || top > 0) {
                if (this.props.sticky && stickyOffset > 0) {
                    this.el.removeAttribute('data-sticky');
                    this.getCastMembersNav().removeAttribute('style');
                    return this.render();
                }

                return !this.getCastMembersNavActiveItem() ? this.setCastMembersNavActiveItem(navItems[0]) : null;
            }

            var bottom = this.el.getBoundingClientRect().top + this.el.clientHeight - (this.getGlobalHeaderNavsHeight() + this.getCastMembersNav().clientHeight);

            if (data.scrollY && top <= 0) {
                if (!this.props.sticky && stickyOffset <= 0) {
                    this.el.setAttribute('data-sticky-init', true);
                    this.el.setAttribute('data-sticky', true);
                    this.render();
                }

                if (bottom >= 0 && this.props.stickyHidden) this.el.removeAttribute('data-sticky-hidden');else if (bottom < 0 && !this.props.stickyHidden) this.props.stickyHidden = true;
            }

            if (RootComponent.Scroller.scrollingTo) return;

            if (this.forceActiveItem) {
                this.forceActiveItem = null;
                return;
            }

            var navItemsMap = navItems.map(function (el) {
                return {
                    el: el,
                    id: el.getAttribute('href').replace(/(.+)(#[A-Z])(.*)/, '$2')
                };
            }).map(function (obj) {
                return Object.assign(obj, {
                    item: _this3.el.querySelector(obj.id)
                });
            });

            var isItemActive = function isItemActive(obj, idx) {
                var itemBounds = obj.item.getBoundingClientRect();
                var itemTop = itemBounds.top - (_this3.getGlobalHeaderStickyOffset() + _this3.getCastMembersNav().clientHeight);
                var itemBottom = navItemsMap[idx + 1] ? navItemsMap[idx + 1].item.getBoundingClientRect().top - (_this3.getGlobalHeaderStickyOffset() + _this3.getCastMembersNav().clientHeight) : bottom;

                return itemTop <= 0 && itemBottom > 0 || idx === 0 && itemTop > 0;
            };

            var activeIdx = this.getCastMembersNavActiveItem() ? navItems.indexOf(this.getCastMembersNavActiveItem()) : -1;

            if (activeIdx >= 0 && isItemActive(navItemsMap[activeIdx], activeIdx)) return;

            console.groupCollapsed('NavItems');

            navItemsMap.some(function (obj, idx) {
                console.log(obj.item.id);

                if (!isItemActive(obj, idx)) return false;

                return obj.el !== _this3.getCastMembersNavActiveItem() ? _this3.setCastMembersNavActiveItem(obj.el) : true;
            });

            console.groupEnd();
        }
    }, {
        key: 'onCastMembersNavItemsClick',
        value: function onCastMembersNavItemsClick(e) {
            this.forceActiveItem = e.target;
        }
    }, {
        key: 'isShortViewport',
        value: function isShortViewport() {
            return this.props.shortViewport === 'true';
        }
    }, {
        key: 'isDisabledStickyNavBrowser',
        value: function isDisabledStickyNavBrowser() {
            return this.getFeature('touch') && !window.navigator.userAgent.match(/(chrome|iphone|ipad)/i);
        }
    }, {
        key: 'isGlobalHeaderNavsSticky',
        value: function isGlobalHeaderNavsSticky() {
            return this.getGlobalHeaderNavs() ? window.getComputedStyle(this.getGlobalHeaderNavs()).position === 'fixed' : false;
        }
    }, {
        key: 'getGlobalHeader',
        value: function getGlobalHeader() {
            return RootComponent.el.querySelector('#global-header');
        }
    }, {
        key: 'getGlobalHeaderNavs',
        value: function getGlobalHeaderNavs() {
            return RootComponent.el.querySelector('#global-header-navs');
        }
    }, {
        key: 'getGlobalHeaderNavsHeight',
        value: function getGlobalHeaderNavsHeight() {
            return this.getGlobalHeaderNavs().clientHeight - 1;
        }
    }, {
        key: 'getGlobalHeaderStickyOffset',
        value: function getGlobalHeaderStickyOffset() {
            if (!this.getGlobalHeader()) return 0;

            var height = RootComponent.el.clientWidth <= 320 || this.getGlobalHeader().getAttribute('data-short-viewport') === 'true' ? 0 : Number((this.getGlobalHeader() || {}).getAttribute('data-sticky-offset')) || 0;

            return !height ? height : height - 1;
        }
    }, {
        key: 'getPaginationFetcher',
        value: function getPaginationFetcher() {
            return this.el.querySelector('.pagination-fetcher');
        }
    }, {
        key: 'getPaginationFetcherCta',
        value: function getPaginationFetcherCta() {
            return this.el.querySelector('[data-pagination-fetcher-cta]');
        }
    }, {
        key: 'getCastMembersNav',
        value: function getCastMembersNav() {
            return this.el.querySelector('.cast-members-nav');
        }
    }, {
        key: 'getCastMembersNavWrapper',
        value: function getCastMembersNavWrapper() {
            return this.el.querySelector('.cast-members-nav-wrapper');
        }
    }, {
        key: 'getCastMembersNavItems',
        value: function getCastMembersNavItems() {
            return Array.from(this.getCastMembersNav().querySelectorAll('a'));
        }
    }, {
        key: 'getCastMembersNavActiveItem',
        value: function getCastMembersNavActiveItem() {
            return this.getCastMembersNav().querySelector('[aria-current="true"]');
        }
    }, {
        key: 'setCastMembersNavActiveItem',
        value: function setCastMembersNavActiveItem(item) {
            this.getCastMembersNavItems().forEach(function (el) {
                return el.setAttribute('aria-current', el === item);
            });
        }
    }, {
        key: 'observePaginationFetcher',
        value: function observePaginationFetcher() {
            var _this4 = this;

            if (!(['MutationObserver'] in window) || !this.getPaginationFetcher()) return;

            var observer = new window.MutationObserver(function (mutations) {
                return mutations.forEach(function (mutation) {
                    if (mutation.attributeName !== 'data-rendered') return;

                    observer.disconnect();

                    if (_this4.getPaginationFetcherCta()) _this4.getPaginationFetcherCta().click();
                });
            });

            observer.observe(this.getPaginationFetcher(), {
                attributes: true
            });
        }
    }, {
        key: 'observePaginationFetcherCta',
        value: function observePaginationFetcherCta() {
            var _this5 = this;

            if (!(['MutationObserver'] in window) || !this.getPaginationFetcherCta()) return;

            var fetching = null;
            var disconnect = false;

            var observer = new window.MutationObserver(function (mutations) {
                return mutations.filter(function (mutation) {
                    var isLoading = mutation.target.classList.contains('loading');

                    if (isLoading && fetching !== null) fetching = false;

                    return !isLoading;
                }).forEach(function (mutation) {
                    if (mutation.target.className.match(/\s*(done|error)\s*/) && !disconnect) {
                        disconnect = true;
                        observer.disconnect();

                        _this5.render();
                        _this5.listen();

                        _this5.setActiveModalItemFromLocation();

                        return _this5.onScroll();
                    }

                    if (fetching) return;

                    fetching = true;

                    mutation.target.click();
                });
            });

            observer.observe(this.getPaginationFetcherCta(), {
                attributes: true
            });
        }
    }, {
        key: 'setActiveModalItemFromLocation',
        value: function setActiveModalItemFromLocation() {
            var activeModalItem = RootComponent.el.querySelector('[data-modal=true][href="' + window.location.href + '"]');

            if (!activeModalItem || document.documentElement.getAttribute('data-modal-active')) return;

            this.scrollTo(activeModalItem.parentNode).then(function () {
                return activeModalItem.click();
            });
        }
    }, {
        key: 'scrollTo',
        value: function scrollTo(el) {
            if (!el) return;

            var scrollY = RootComponent.Scroller.state.get('scrollY') || 0;
            var top = el.getBoundingClientRect().top + scrollY - this.getGlobalHeaderStickyOffset(el);

            return top >= 0 && top <= scrollY + window.innerHeight ? Promise.resolve(true) : Promise.resolve(this.getBrowser('name') === 'ios' ? window.scrollTo(0, top) : RootComponent.Scroller.scrollTo({ y: top })).then(function () {
                el.focus();

                if (el.getAttribute('tabindex') === '-1') el.blur();
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this6 = this;

            if (!this.getCastMembersNav()) return;

            if (!this.props.shortViewport) this.getCastMembersNavItems().filter(function (el) {
                return !_this6.el.querySelector('#' + el.innerText);
            }).forEach(function (el) {
                return el.setAttribute('aria-disabled', true);
            });

            this.props.shortViewport = window.innerHeight < 325;

            if (this.isDisabledStickyNavBrowser() && !this.props.stickyDisabled) this.props.stickyDisabled = true;

            if (this.props.sticky && Number(this.getCastMembersNav().style.top.replace(/\d/g, '')) !== this.getGlobalHeaderNavsHeight()) {
                this.getCastMembersNav().style.top = this.getGlobalHeaderNavsHeight() + 'px';
                if (this.el.getAttribute('data-sticky-init')) this.el.removeAttribute('data-sticky-init');
            } else if (this.getCastMembersNav().getAttribute('style')) this.getCastMembersNav().removeAttribute('style');
        }
    }]);

    return CastMembersComponent;
}(Component);

var BtnJSZipComponent = function (_Component) {
    _inherits(BtnJSZipComponent, _Component);

    _createClass(BtnJSZipComponent, null, [{
        key: 'selector',
        value: function selector() {
            return '.btn-jszip';
        }
    }]);

    function BtnJSZipComponent(opts) {
        _classCallCheck(this, BtnJSZipComponent);

        var _this = _possibleConstructorReturn(this, (BtnJSZipComponent.__proto__ || Object.getPrototypeOf(BtnJSZipComponent)).call(this, opts));

        _this.onBtnClick = _this.onBtnClick.bind(_this);
        _this.onBtnKeydown = _this.onBtnKeydown.bind(_this);
        _this.onProgress = _this.onProgress.bind(_this);

        _this.files = [];

        try {
            _this.files = JSON.parse(_this.props.files);
        } catch (e) {
            console.warn(e);
        }

        if (!_this.files.length) {
            _this.props.rendered = false;
            return _possibleConstructorReturn(_this);
        }

        _this.listen();
        return _this;
    }

    _createClass(BtnJSZipComponent, [{
        key: 'listen',
        value: function listen() {
            this.el.addEventListener('click', this.onBtnClick);
            this.el.addEventListener('keydown', this.onBtnKeydown);

            if (this.getBrowser('name') === 'ios') return;

            this.on('progress', this.onProgress);
        }
    }, {
        key: 'onBtnClick',
        value: function onBtnClick(e) {
            var _this2 = this;

            e.preventDefault();
            e.stopPropagation();

            if (this.el.classList.contains('loading')) return;

            this.el.style.minWidth = this.el.clientWidth + 'px';
            this.el.classList.add('loading');

            if (this.getBrowser('name') !== 'ios') this.el.classList.add('progress');

            this.render().then(function () {
                return _this2.el.classList.remove('loading');
            });
        }
    }, {
        key: 'onBtnKeydown',
        value: function onBtnKeydown(e) {
            if (e.keyCode === 32 || (e.keyIdentifier || e.key || '').match(/^(enter)$/i)) return this.onBtnClick(e);
        }
    }, {
        key: 'onProgress',
        value: function onProgress() {
            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { currentFile: null, percent: 0 };

            var indicator = this.el.querySelector('.btn-transactional-progress-indicator');

            if (!indicator) return;

            indicator.style.width = Math.round(e.percent) + '%';

            if (e.percent !== 100) return;

            if (this.el.classList.contains('progress')) this.el.classList.remove('progress');

            indicator.style.width = '0';
        }
    }, {
        key: 'getFileName',
        value: function getFileName(path) {
            return path.replace(/^(?:.+\/)+(.+)$/, '$1');
        }
    }, {
        key: 'getFileContents',
        value: function getFileContents(path) {
            var xhr = void 0;

            if (window.XMLHttpRequest) xhr = new window.XMLHttpRequest();else if (window.ActiveXObject) xhr = new window.ActiveXObject('Microsoft.XMLHTTP');

            xhr.open('GET', path, true);
            xhr.responseType = 'arraybuffer';

            // Resolve the file to a promise using the jszip utils
            return new Promise(function (resolve, reject) {
                xhr.onload = function (e) {
                    return resolve(xhr.response);
                };
                xhr.send();
            });
        }
    }, {
        key: 'renderFallbackZip',
        value: function renderFallbackZip() {
            var form = document.createElement('form');
            form.action = '/archiver/index.php';
            form.method = 'POST';

            var inputFilename = document.createElement('input');
            inputFilename.name = 'filename';
            inputFilename.type = 'hidden';
            inputFilename.value = this.props.name + '.zip';

            var inputFileslist = document.createElement('input');
            inputFileslist.name = 'fileslist';
            inputFileslist.type = 'hidden';
            inputFileslist.value = this.props.files;

            form.appendChild(inputFilename);
            form.appendChild(inputFileslist);

            this.el.parentNode.appendChild(form);

            return new Promise(function (resolve, reject) {
                form.submit();
                resolve(form.remove());
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            if (this.getBrowser('name') === 'ios') return this.renderFallbackZip();

            this.zip = new JSZip();

            this.files.forEach(function (path) {
                return _this3.zip.file(_this3.getFileName(path), _this3.getFileContents(path), {
                    binary: true });
            });

            return this.zip.generateAsync({ type: 'arraybuffer' }, function (metadata) {
                return _this3.emit('progress', metadata);
            }).then(function (binary) {
                return window.saveAs(new window.Blob([binary]), _this3.props.name + '.zip');
            }, function (err) {
                console.warn(err);
                _this3.el.classList.remove('loading');
                _this3.el.classList.add('error');
            });
        }
    }]);

    return BtnJSZipComponent;
}(Component);

var HashAnchorComponent = function (_Component) {
    _inherits(HashAnchorComponent, _Component);

    _createClass(HashAnchorComponent, null, [{
        key: 'selector',
        value: function selector() {
            return 'a[href^="#"], a[href^="' + window.location.href.replace(window.location.hash, '').replace(window.location.search, '') + '#"]';
        }
    }]);

    function HashAnchorComponent(opts) {
        _classCallCheck(this, HashAnchorComponent);

        var _this = _possibleConstructorReturn(this, (HashAnchorComponent.__proto__ || Object.getPrototypeOf(HashAnchorComponent)).call(this, opts));

        _this.onHashAnchorClick = _this.onHashAnchorClick.bind(_this);
        _this.onHashAnchorKeydown = _this.onHashAnchorKeydown.bind(_this);

        _this.listen();
        return _this;
    }

    _createClass(HashAnchorComponent, [{
        key: 'listen',
        value: function listen() {
            this.el.addEventListener('click', this.onHashAnchorClick);
            this.el.addEventListener('keydown', this.onHashAnchorKeydown);
        }
    }, {
        key: 'onHashAnchorClick',
        value: function onHashAnchorClick(e) {
            var _this2 = this;

            e.preventDefault();
            e.stopPropagation();

            var targetId = this.el.getAttribute('href').replace(/(.+)(#.+)/, '$2');

            var target = targetId ? document.querySelector(targetId) : null;

            if (!target || !RootComponent.Scroller || RootComponent.Scroller.scrollingTo) return;

            this.el.blur();

            var scrollToTarget = function scrollToTarget() {
                var top = target.getBoundingClientRect().top + (RootComponent.Scroller.state.get('scrollY') || 0) - _this2.getGlobalHeaderStickyOffset(target);

                Promise.resolve(_this2.getBrowser('name') === 'ios' ? window.scrollTo(0, top) : RootComponent.Scroller.scrollTo({ y: top })).then(function () {
                    target.focus();

                    if (target.getAttribute('tabindex') === '-1') target.blur();
                });
            };

            if (!document.querySelector('[data-projects-menu-topics-state="expanded"]') || !this.getProjectsTopicsToggleBtn()) return scrollToTarget();

            this.getProjectsTopicsToggleBtn().click();

            this.getProjectsTopicsToggleBtn().blur();

            setTimeout(function () {
                return scrollToTarget();
            }, 1);
        }
    }, {
        key: 'onHashAnchorKeydown',
        value: function onHashAnchorKeydown(e) {
            if (e.keyCode === 32 || (e.keyIdentifier || e.key || '').match(/^(enter)$/i)) return this.onHashAnchorClick(e);
        }
    }, {
        key: 'getCastMembersNav',
        value: function getCastMembersNav() {
            return RootComponent.el.querySelector('.cast-members-nav');
        }
    }, {
        key: 'getProjectsTopicsToggleBtn',
        value: function getProjectsTopicsToggleBtn() {
            return RootComponent.el.querySelector('.projects-menu-topics-toggle-btn');
        }
    }, {
        key: 'getGlobalHeader',
        value: function getGlobalHeader() {
            return RootComponent.el.querySelector('#global-header');
        }
    }, {
        key: 'getGlobalHeaderStickyOffset',
        value: function getGlobalHeaderStickyOffset(target) {
            if (!this.getGlobalHeader() || !target) return 0;

            var stickyOffset = Number((this.getGlobalHeader() || {}).getAttribute('data-sticky-offset')) || 0;

            var height = RootComponent.el.clientWidth <= 320 || this.getGlobalHeader().getAttribute('data-short-viewport') === 'true' ? 0 : stickyOffset;

            if (this.getCastMembersNav() && target.getBoundingClientRect().top + (RootComponent.Scroller.state.get('scrollY') || 0) > stickyOffset && target.id !== 'content') height += this.getCastMembersNav().clientHeight;

            if (this.getProjectsTopicsToggleBtn() && target.getBoundingClientRect().top + (RootComponent.Scroller.state.get('scrollY') || 0) > stickyOffset && target.id !== 'content') height += this.getProjectsTopicsToggleBtn().clientHeight - 2;

            return !height ? height : height - 1;
        }
    }]);

    return HashAnchorComponent;
}(Component);

var HeroComponent = function (_Component) {
    _inherits(HeroComponent, _Component);

    _createClass(HeroComponent, null, [{
        key: 'selector',
        value: function selector() {
            return '.hero';
        }
    }]);

    function HeroComponent(opts) {
        _classCallCheck(this, HeroComponent);

        var _this = _possibleConstructorReturn(this, (HeroComponent.__proto__ || Object.getPrototypeOf(HeroComponent)).call(this, opts));

        _this.browserInnerHeight = _this.getFeature('touch') ? window.innerHeight : null;

        _this.render();
        _this.listen();
        return _this;
    }

    _createClass(HeroComponent, [{
        key: 'listen',
        value: function listen() {
            var _this2 = this;

            this.on('resize', function () {
                return _this2.render();
            });
            this.on('resize:debounced', function () {
                return _this2.render();
            });
        }
    }, {
        key: 'getGlobalHeaderNavHeight',
        value: function getGlobalHeaderNavHeight() {
            return (document.querySelector('#global-header nav.primary') || {}).clientHeight || 0;
        }
    }, {
        key: 'getScreenHeight',
        value: function getScreenHeight() {
            return this.browserInnerHeight && window.outerHeight - Number(this.browserInnerHeight || 0) < 100 ? this.browserInnerHeight : window.innerHeight;
        }
    }, {
        key: 'getMinHeight',
        value: function getMinHeight() {
            return this.getScreenHeight() - this.getGlobalHeaderNavHeight();
        }
    }, {
        key: 'renderHeadingLine',
        value: function renderHeadingLine() {
            var headingLine = this.el.querySelector('.heading-1-line');

            if (!headingLine) return;

            var heroContent = this.el.querySelector('.hero-content');

            var heroContentPadding = heroContent ? Number(window.getComputedStyle(heroContent).paddingRight.replace(/\D*$/, '')) : 0;

            if (heroContentPadding < 30) return headingLine.removeAttribute('style');

            var heroContentBounds = heroContent.getBoundingClientRect();
            var headingLineBounds = headingLine.getBoundingClientRect();

            headingLine.style.maxWidth = heroContentBounds.right - (headingLineBounds.left + heroContentPadding) + 'px';
        }
    }, {
        key: 'renderScrollCta',
        value: function renderScrollCta() {
            var cta = this.el.querySelector('.hero-scroll-cta');

            if (!cta) return;

            var ctaTransformEl = cta.querySelector('[data-transform-rotate]');

            var disableTransform = function disableTransform() {
                return [cta, ctaTransformEl].filter(function (el) {
                    return el;
                }).forEach(function (el) {
                    return el.setAttribute('data-transform-rotate-disabled', true);
                });
            };

            var enableTransform = function enableTransform() {
                return [cta, ctaTransformEl].filter(function (el) {
                    return el;
                }).forEach(function (el) {
                    return el.removeAttribute('data-transform-rotate-disabled');
                });
            };

            var heroContent = this.el.querySelector('.hero-content');
            var copy = this.el.querySelector('.hero-copy');
            var heading = this.el.querySelector('.hero-heading');
            var desc = this.el.querySelector('.hero-description');

            if (!ctaTransformEl || !heroContent || !copy || !heading || !desc) return disableTransform();

            var isDisabled = cta.getAttribute('data-transform-rotate-disabled');

            var ctaTextTransformHeight = isDisabled ? ctaTransformEl.clientWidth : ctaTransformEl.clientHeight;

            var ctaBtnHeight = (cta.querySelector('.btn') || {}).clientHeight || 0;

            var getComputedStyleInt = function getComputedStyleInt(el, prop) {
                return Number(window.getComputedStyle(el)[prop].replace(/\D*$/, '') || 0);
            };

            var heroContentPadding = getComputedStyleInt(heroContent, 'paddingTop') + getComputedStyleInt(heroContent, 'paddingBottom');

            var ctaTransformMinHeight = ctaTextTransformHeight + ctaBtnHeight + heroContentPadding;

            var copyHeight = copy.clientHeight - getComputedStyleInt(copy, 'paddingBottom');

            var availOffset = (this.el.clientHeight - copyHeight) * 0.625;

            if (!isDisabled && ctaTransformMinHeight > availOffset) disableTransform();else if (isDisabled && ctaTransformMinHeight <= availOffset) enableTransform();

            var ctaHeight = this.el.querySelector('.hero-scroll').clientHeight - getComputedStyleInt(heroContent, 'paddingBottom');

            var isPad = copy.getBoundingClientRect().bottom > this.el.querySelector('.hero-scroll').getBoundingClientRect().top;

            if (isPad && getComputedStyleInt(copy, 'paddingBottom') !== ctaHeight) copy.style.paddingBottom = ctaHeight + 'px';else if (!isPad && getComputedStyleInt(copy, 'paddingBottom')) copy.style.paddingBottom = 0;
        }
    }, {
        key: 'render',
        value: function render() {
            this.el.style.minHeight = this.getMinHeight() + 'px';

            this.renderHeadingLine();
            this.renderScrollCta();
        }
    }]);

    return HeroComponent;
}(Component);

var HighlightsComponent = function (_Component) {
    _inherits(HighlightsComponent, _Component);

    _createClass(HighlightsComponent, null, [{
        key: 'selector',
        value: function selector() {
            return '.highlights';
        }
    }]);

    function HighlightsComponent(opts) {
        _classCallCheck(this, HighlightsComponent);

        var _this = _possibleConstructorReturn(this, (HighlightsComponent.__proto__ || Object.getPrototypeOf(HighlightsComponent)).call(this, opts));

        _this.state.set({
            index: _this.getActiveItemIndex()
        });

        _this.onChange = _this.onChange.bind(_this);
        _this.onBtnClick = _this.onBtnClick.bind(_this);
        _this.onThumbNavItemsClick = _this.onThumbNavItemsClick.bind(_this);

        _this.listen();
        return _this;
    }

    _createClass(HighlightsComponent, [{
        key: 'listen',
        value: function listen() {
            var _this2 = this;

            this.state.on('update', this.onChange);

            this.getBtns().forEach(function (el) {
                el.addEventListener('click', _this2.onBtnClick, false);
            });

            this.getThumbNavItems().forEach(function (el) {
                el.addEventListener('click', _this2.onThumbNavItemsClick, false);
            });

            this.on('resize', function () {
                _this2.onResize();
                window.objectFitPolyfill();
            });

            this.on('resize:debounced', function () {
                _this2.onResize();
                window.objectFitPolyfill();
            });

            window.objectFitPolyfill();
        }
    }, {
        key: 'onChange',
        value: function onChange(e) {
            var idx = e.data.currentData.index;

            var item = this.el.querySelector('.highlights-item[data-idx="' + idx + '"]');

            var thumbNavItem = this.el.querySelector('.highlights-stage-nav a[data-idx="' + idx + '"]');

            var stageMedia = this.el.querySelector('.highlights-stage-media');

            var setLazyIframeSrc = function setLazyIframeSrc(el) {
                var active = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                var iframe = el ? el.querySelector('iframe[data-video-embed-src-lazy^="data:image"]') : null;

                if (!iframe) return;

                iframe.src = iframe.getAttribute(active ? 'data-video-embed-src' : 'data-video-embed-src-lazy');
            };

            if (this.getActiveItem()) {
                this.getActiveItem().classList.remove('active');
                setLazyIframeSrc(this.getActiveItem(), false);
            }

            if (item) {
                setLazyIframeSrc(item, true);
                item.classList.add('active');
            }

            if (this.getActiveThumbNavItem()) this.getActiveThumbNavItem().classList.remove('active');

            if (thumbNavItem) thumbNavItem.classList.add('active');

            if (item && thumbNavItem) this.el.querySelector('.highlights-text-index').innerText = idx;

            if (!stageMedia || !item.querySelector('.highlights-item-media')) return;

            var getStageMediaFromIdx = function getStageMediaFromIdx() {
                return stageMedia.querySelector('.highlights-item-media[data-idx="' + idx + '"]');
            };

            if (!getStageMediaFromIdx()) {
                var stageMediaItem = item.querySelector('.highlights-item-media').cloneNode(true);

                stageMediaItem.setAttribute('data-idx', idx);
                stageMedia.appendChild(stageMediaItem);
            }

            if (stageMedia.querySelector('.highlights-item-media.active')) {
                stageMedia.querySelector('.highlights-item-media.active').classList.remove('active');

                setLazyIframeSrc(stageMedia.querySelector('.highlights-item-media.active'), false);
            }

            if (getStageMediaFromIdx()) {
                setLazyIframeSrc(getStageMediaFromIdx(), true);
                getStageMediaFromIdx().classList.add('active');
            }

            window.objectFitPolyfill();
        }
    }, {
        key: 'onBtnClick',
        value: function onBtnClick(e) {
            var target = e.target.getAttribute('role') === 'button' ? e.target : e.target.parentNode;

            if (!target.getAttribute('role') === 'button' || !this.getActiveItem()) return;

            var item = void 0;

            if (target.classList.contains('highlights-btn-prev')) item = this.getActiveItem().previousElementSibling ? this.getActiveItem().previousElementSibling : this.getItems()[this.getItems().length - 1];else if (target.classList.contains('highlights-btn-next')) item = this.getActiveItem().nextElementSibling ? this.getActiveItem().nextElementSibling : this.getItems()[0];

            if (item && item.getAttribute('data-idx')) this.state.set({
                index: Number(item.getAttribute('data-idx'))
            });
        }
    }, {
        key: 'onThumbNavItemsClick',
        value: function onThumbNavItemsClick(e) {
            var target = e.target.parentNode.getAttribute('role') === 'button' ? e.target.parentNode : e.target.parentNode.parentNode;

            if (!target.getAttribute('role') === 'button' || target.classList.contains('active')) return;

            this.state.set({
                index: Number(target.getAttribute('data-idx'))
            });
        }
    }, {
        key: 'onResize',
        value: function onResize() {
            Array.from(this.el.querySelectorAll('.active iframe[data-video-embed-src]')).forEach(function (el) {
                var isHidden = window.getComputedStyle(el).display === 'none' || window.getComputedStyle(el.parentElement).display === 'none' || window.getComputedStyle(el.parentElement.parentElement).display === 'none' || window.getComputedStyle(el.parentElement.parentElement.parentElement).display === 'none';

                var isVideoSrc = el.getAttribute('data-video-embed-src') === el.src;

                if (isHidden && isVideoSrc) {
                    el.src = el.getAttribute('data-video-embed-src-lazy');
                    return;
                }

                if (!isHidden && !isVideoSrc) el.src = el.getAttribute('data-video-embed-src');
            });
        }
    }, {
        key: 'getBtns',
        value: function getBtns() {
            return Array.from(this.el.querySelectorAll('.highlights-btn'));
        }
    }, {
        key: 'getThumbNavItems',
        value: function getThumbNavItems() {
            return Array.from(this.el.querySelectorAll('.highlights-stage-nav a'));
        }
    }, {
        key: 'getItems',
        value: function getItems() {
            return Array.from(this.el.querySelectorAll('.highlights-item'));
        }
    }, {
        key: 'getActiveItem',
        value: function getActiveItem() {
            return this.el.querySelector('.highlights-item.active');
        }
    }, {
        key: 'getActiveItemIndex',
        value: function getActiveItemIndex() {
            return this.getActiveItem() && this.getActiveItem().getAttribute('data-idx') ? Number(this.getActiveItem().getAttribute('data-idx')) : 1;
        }
    }, {
        key: 'getActiveThumbNavItem',
        value: function getActiveThumbNavItem() {
            return this.el.querySelector('.highlights-stage-nav a.active');
        }
    }]);

    return HighlightsComponent;
}(Component);

var _toConsumableArray = (function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
});

var MailchimpFormComponent = function (_Component) {
    _inherits(MailchimpFormComponent, _Component);

    _createClass(MailchimpFormComponent, null, [{
        key: 'selector',
        value: function selector() {
            return '.mailchimp-form';
        }
    }]);

    function MailchimpFormComponent(opts) {
        _classCallCheck(this, MailchimpFormComponent);

        var _this = _possibleConstructorReturn(this, (MailchimpFormComponent.__proto__ || Object.getPrototypeOf(MailchimpFormComponent)).call(this, opts));

        if (!_this.el || !_this.getForm()) return _possibleConstructorReturn(_this);

        window.fetchJsonp = fetchJsonp;

        _this.addFeatureTest({
            csspointerevents: function csspointerevents() {
                return _this.detectCSSProp('pointer-events');
            }
        });

        _this.addFeaturesToClassName();

        _this.render();
        _this.listen();
        return _this;
    }

    _createClass(MailchimpFormComponent, [{
        key: 'listen',
        value: function listen() {
            var _this2 = this;

            this.getForm().onvalid = function (e) {
                return _this2.onFormValid(e);
            };

            this.getForm().oninvalid = function (e) {
                return _this2.onFormInvalid(e);
            };

            this.getInputsPattern().forEach(function (input) {
                input.oninvalid = function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    _this2.onForceDirty();
                };

                input.onfocus = function (e) {
                    return _this2.onFormReset(e);
                };

                input.onblur = function (e) {
                    return _this2.onDirty(e);
                };

                input.onkeyup = function () {
                    return _this2.getForm().classList.contains('dirty') ? _this2.onDirty() : null;
                };
            });

            this.getSubmitButton().onfocus = function () {
                return _this2.onDirty();
            };

            this.getSubmitButton().onclick = function () {
                return _this2.onForceDirty();
            };

            this.getForm().onsubmit = function (e) {
                return _this2.onSubmit(e);
            };
        }
    }, {
        key: 'onFormValid',
        value: function onFormValid(e) {
            if (this.getForm().classList.contains('invalid')) this.getForm().classList.remove('invalid');
        }
    }, {
        key: 'onFormInvalid',
        value: function onFormInvalid(e) {
            e.preventDefault();
            e.stopPropagation();

            if (this.getBrowser('name').match(/(ie|edge)/)) this.getForm().classList.add('invalid');
        }
    }, {
        key: 'onForceDirty',
        value: function onForceDirty() {
            this.getInputsPattern().forEach(function (input) {
                return input.classList.add('dirty');
            });

            this.onDirty();
        }
    }, {
        key: 'onDirty',
        value: function onDirty(e) {
            this.getForm().classList.add('dirty');

            if (!this.isFormValid() && this.getBrowser('name').match(/(ie|edge)/)) this.getForm().classList.add('invalid');

            if (e && e.target) e.target.classList.add('dirty');

            this.getInputsPattern().forEach(function (input) {
                input.classList[input.validity.valid ? 'remove' : 'add']('invalid');
            });
        }
    }, {
        key: 'onFormReset',
        value: function onFormReset(e) {
            if (!(this.getForm().classList.contains('success') || this.getForm().classList.contains('error'))) return;

            this.getForm().classList.remove('success');
            this.getForm().classList.remove('error');

            this.getInputs().filter(function (el) {
                return el.type !== 'hidden';
            }).forEach(function (el) {
                if (el.checked) el.checked = false;

                if (el.value) el.value = '';

                if (el.classList.contains('dirty')) el.classList.remove('dirty');

                if (el.classList.contains('invalid')) el.classList.remove('invalid');
            });
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(e) {
            var _this3 = this;

            e.preventDefault();
            e.stopPropagation();

            if (this.getForm().classList.contains('success')) return;

            var isValid = this.isFormValid();

            if (isValid && this.getForm().classList.contains('invalid')) this.getForm().classList.remove('invalid');

            if (!isValid && this.getBrowser('name').match(/(ie|edge)/)) this.els.mailchimpForm.classList.add('invalid');

            if (!isValid) return this.onForceDirty();

            if (this.getForm().classList.contains('submitting')) return;

            this.getForm().classList.add('submitting');

            this.getSubmitButton().classList.add('loading'

            // Update form state
            );this.onDirty();

            var epoch = new Date().getTime();

            var queryString = [].concat(_toConsumableArray(new window.FormData(this.getForm()).entries())).map(function (entry) {
                return entry.map(encodeURIComponent).join('=');
            }).join('&');

            var url = this.getForm().getAttribute('action') + '/form-post-json?' + queryString + '&_=' + epoch + '&c=jsonp_cb_' + epoch;

            window.fetchJsonp(url, {
                jsonpCallbackFunction: 'jsonp_cb_' + epoch
            }).then(function (res) {
                return res.json();
            }).then(function (json) {
                return {
                    msg: json.msg || 'An unknown error has occurred',
                    result: json.result || 'error'
                };
            }).then(function (json) {
                var alertsEl = _this3.getForm().querySelector('.mailchimp-form-res-alerts');

                if (alertsEl) alertsEl.focus();

                var responseTextEl = alertsEl ? alertsEl.querySelector('.' + json.result + ' .msg') : null;

                if (responseTextEl) {
                    responseTextEl.innerHTML = json.msg;

                    Array.from(responseTextEl.querySelectorAll('a')).forEach(function (el) {
                        el.target = '_blank';
                        el.title = 'Opens in New Tab';
                        el.rel = 'noopener noreferrer';
                    });
                }

                _this3.getForm().classList.remove('submitting');

                _this3.getSubmitButton().classList.remove('loading');

                _this3.getForm().classList.add(json.result);
            });
        }
    }, {
        key: 'getForm',
        value: function getForm() {
            return this.el.querySelector('form');
        }
    }, {
        key: 'getInputs',
        value: function getInputs() {
            return Array.from(this.el.querySelectorAll('input'));
        }
    }, {
        key: 'getInputsPattern',
        value: function getInputsPattern() {
            return Array.from(this.el.querySelectorAll('input[pattern]'));
        }
    }, {
        key: 'getInputsRequired',
        value: function getInputsRequired() {
            return Array.from(this.el.querySelectorAll('input[required]'));
        }
    }, {
        key: 'getSubmitButton',
        value: function getSubmitButton() {
            return this.el.querySelector('[type="submit"]');
        }
    }, {
        key: 'isFormValid',
        value: function isFormValid() {
            var isValid = true;

            this.getInputsPattern().forEach(function (input) {
                if (!input.validity.valid) isValid = false;
            });

            return isValid;
        }
    }, {
        key: 'render',
        value: function render() {
            Array.from(this.getInputs()).filter(function (input) {
                return input.type !== 'hidden';
            }).forEach(function (input) {
                if ('autocapitalize' in input && input.type !== 'text') input.setAttribute('autocapitalize', 'none');

                if ('autocomplete' in input) input.setAttribute('autocomplete', input.type);
            });
        }
    }]);

    return MailchimpFormComponent;
}(Component);

var ProjectsComponent = function (_Component) {
    _inherits(ProjectsComponent, _Component);

    _createClass(ProjectsComponent, null, [{
        key: 'selector',
        value: function selector() {
            return '#modal';
        }
    }]);

    function ProjectsComponent(opts) {
        _classCallCheck(this, ProjectsComponent);

        var _this = _possibleConstructorReturn(this, (ProjectsComponent.__proto__ || Object.getPrototypeOf(ProjectsComponent)).call(this, opts));

        _this.onKeydown = _this.onKeydown.bind(_this);

        _this.onModalBtnClick = _this.onModalBtnClick.bind(_this);
        _this.onModalBtnKeydown = _this.onModalBtnKeydown.bind(_this);

        _this.onModalCloseBtnClick = _this.onModalCloseBtnClick.bind(_this);
        _this.onModalCloseBtnKeydown = _this.onModalCloseBtnKeydown.bind(_this);

        _this.onModalPopstate = _this.onModalPopstate.bind(_this);

        _this.addFeaturesToClassName();
        _this.listen();
        _this.setActiveModalItemFromLocation(true);
        return _this;
    }

    _createClass(ProjectsComponent, [{
        key: 'listen',
        value: function listen() {
            var _this2 = this;

            this.el.addEventListener('keydown', this.onKeydown);

            this.modalBtnsListener();

            this.getModalCloseBtns().forEach(function (el) {
                if (!el.getAttribute('tabindex')) el.setAttribute('tabindex', 0);

                el.addEventListener('click', _this2.onModalCloseBtnClick);
                el.addEventListener('keydown', _this2.onModalCloseBtnKeydown);
            });

            if ('onpopstate' in window) window.addEventListener('popstate', this.onModalPopstate);

            if (!(['MutationObserver'] in window)) return;

            var observer = new window.MutationObserver(function (mutations) {
                return mutations.filter(function (mutation) {
                    return mutation.addedNodes.length;
                }).forEach(function (mutation) {
                    return _this2.modalBtnsListener();
                });
            });

            observer.observe(RootComponent.el, {
                childList: true,
                subtree: true
            });
        }
    }, {
        key: 'modalBtnsListener',
        value: function modalBtnsListener() {
            var _this3 = this;

            this.getModalBtns().forEach(function (el) {
                if (el.getAttribute('data-modal-listener')) return;

                el.setAttribute('data-modal-listener', true);

                if (!el.getAttribute('tabindex')) el.setAttribute('tabindex', 0);

                el.addEventListener('click', _this3.onModalBtnClick);
                el.addEventListener('keydown', _this3.onModalBtnKeydown);
            });
        }
    }, {
        key: 'onKeydown',
        value: function onKeydown(e) {
            if (this.isModalActive() && (e.keyIdentifier || e.key || '').match(/escape/i)) return this.onModalCloseBtnClick();

            if (!this.isModalActive() || !(e.keyIdentifier || e.key || '').match(/tab/i)) return;

            var activeEl = void 0;

            var els = Tabbable(this.el);

            if (e.shiftKey && els.indexOf(e.target) === 0) activeEl = els[els.length - 1];

            if (!e.shiftKey && els.indexOf(e.target) === els.length - 1) activeEl = els[0];

            if (!activeEl) return;

            e.preventDefault();
            e.stopPropagation();

            activeEl.focus();
        }
    }, {
        key: 'onModalBtnClick',
        value: function onModalBtnClick(e) {
            var ytEmbedId = e.target.getAttribute('data-modal-youtube-id');
            var vimeoEmbedId = e.target.getAttribute('data-modal-vimeo-id');

            var content = e.target.getAttribute('data-modal-content') ? RootComponent.el.querySelector('#' + e.target.getAttribute('data-modal-content')) : null;

            if (!content && !ytEmbedId && !vimeoEmbedId || !this.getModalContent()) return;

            e.preventDefault();
            e.stopPropagation();

            if (e.target.href && window.location.href !== e.target.getAttribute('href') && 'history' in window) window.history.pushState(null, '' + (e.target.getAttribute('data-modal-title') ? e.target.getAttribute('data-modal-title') + ' | ' : '') + document.title, e.target.getAttribute('href'));

            e.target.setAttribute('data-modal-refocus', true);

            var src = ytEmbedId ? 'https://www.youtube.com/embed/' + ytEmbedId + '?playsinline=1&autoplay=1&rel=0' : null;

            if (vimeoEmbedId) src = 'https://player.vimeo.com/video/' + vimeoEmbedId;

            if (src) {
                this.props.embed = true;

                content = document.createElement('div');
                content.className = 'ratio-wide black-bg';

                var iframe = document.createElement('iframe');

                iframe.className = 'position-absolute';
                iframe.src = src;

                iframe.setAttribute('allowfullscreen', true);
                iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');

                content.appendChild(iframe);
            } else {
                content = content.cloneNode(true);
                content.id = content.id + '-modal-clone';
            }

            if (!document.documentElement.classList.contains('overflow-hidden')) {
                document.documentElement.setAttribute('data-modal-active', true);
                RootComponent.emit('scroll:disable');
            }

            this.getModalContent().appendChild(content);

            this.el.setAttribute('aria-hidden', 'false');

            this.el.focus();
            this.el.blur();

            this.setSiblingAriaHiddenAttr();
            window.objectFitPolyfill();
        }
    }, {
        key: 'onModalBtnKeydown',
        value: function onModalBtnKeydown(e) {
            if (e.keyCode === 32 || (e.keyIdentifier || e.key || '').match(/^(enter)$/i)) this.onModalBtnClick(e);
        }
    }, {
        key: 'onModalCloseBtnClick',
        value: function onModalCloseBtnClick(e) {
            this.el.setAttribute('aria-hidden', 'true');
            this.el.removeAttribute('data-embed');

            this.getModalContent().innerHTML = '';
            this.setSiblingAriaHiddenAttr();

            document.documentElement.removeAttribute('data-modal-active');

            if (document.documentElement.classList.contains('overflow-hidden')) RootComponent.emit('scroll:enable');

            var refocusEl = this.getModalRefocusElement();

            if (!refocusEl) return;

            if (window.location.href === refocusEl.getAttribute('href')) this.resetHistoryState();

            refocusEl.focus();
            refocusEl.removeAttribute('data-modal-refocus');
        }
    }, {
        key: 'onModalCloseBtnKeydown',
        value: function onModalCloseBtnKeydown(e) {
            if (e.keyCode === 32 || (e.keyIdentifier || e.key || '').match(/^(enter)$/i)) this.onModalCloseBtnClick(e);
        }
    }, {
        key: 'onModalPopstate',
        value: function onModalPopstate(e) {
            if (this.isModalActive() && this.getModalRefocusElement() && (this.getModalRefocusElement().getAttribute('href') || '').match(/\?.+$/)) return this.onModalCloseBtnClick();

            this.setActiveModalItemFromLocation();
        }
    }, {
        key: 'isModalActive',
        value: function isModalActive() {
            return this.el.getAttribute('aria-hidden') === 'false';
        }
    }, {
        key: 'getModalBtns',
        value: function getModalBtns() {
            return Array.from(document.querySelectorAll('[data-modal]:not([data-modal-listener])'));
        }
    }, {
        key: 'getModalCloseBtns',
        value: function getModalCloseBtns() {
            return Array.from(document.querySelectorAll('[data-modal-close]'));
        }
    }, {
        key: 'getModalContent',
        value: function getModalContent() {
            return this.el.querySelector('.modal-content');
        }
    }, {
        key: 'getModalRefocusElement',
        value: function getModalRefocusElement() {
            return RootComponent.el.querySelector('[data-modal-refocus]');
        }
    }, {
        key: 'getCastMembersNav',
        value: function getCastMembersNav() {
            return RootComponent.el.querySelector('.cast-members-nav');
        }
    }, {
        key: 'getGlobalHeader',
        value: function getGlobalHeader() {
            return RootComponent.el.querySelector('#global-header');
        }
    }, {
        key: 'getGlobalHeaderStickyOffset',
        value: function getGlobalHeaderStickyOffset(target) {
            if (!this.getGlobalHeader() || !target) return 0;

            var stickyOffset = Number((this.getGlobalHeader() || {}).getAttribute('data-sticky-offset')) || 0;

            var height = RootComponent.el.clientWidth <= 320 || this.getGlobalHeader().getAttribute('data-short-viewport') === 'true' ? 0 : stickyOffset;

            if (this.getCastMembersNav() && target.getBoundingClientRect().top + (RootComponent.Scroller.state.get('scrollY') || 0) > stickyOffset && target.id !== 'content') height += this.getCastMembersNav().clientHeight;

            return !height ? height : height - 1;
        }
    }, {
        key: 'setSiblingAriaHiddenAttr',
        value: function setSiblingAriaHiddenAttr() {
            var _this4 = this;

            Array.from((RootComponent.el || {}).children).filter(function (el) {
                return !el.tagName.match(/script/i) && el !== _this4.el;
            }).forEach(function (el) {
                if (!_this4.isModalActive() && el.getAttribute('aria-hidden')) return el.removeAttribute('aria-hidden');

                if (_this4.isModalActive() && el.getAttribute('aria-hidden') !== 'true') el.setAttribute('aria-hidden', true);
            });
        }
    }, {
        key: 'setActiveModalItemFromLocation',
        value: function setActiveModalItemFromLocation(init) {
            var activeModalItem = RootComponent.el.querySelector('[data-modal=true][href="' + window.location.href + '"]');

            if (init && !activeModalItem && !this.getCastMembersNav()) return !(document.body.id || '').match(/^entry-schedule/) ? this.resetHistoryState() : null;

            if (!activeModalItem || init && activeModalItem.parentNode.classList.contains('cast-members-item')) return;

            var isPersonsOrCastMembersModal = activeModalItem.parentNode.classList.contains('members-item') || activeModalItem.parentNode.classList.contains('cast-members-item');

            this.scrollTo(isPersonsOrCastMembersModal ? activeModalItem.parentNode : activeModalItem).then(function () {
                return activeModalItem.click();
            });
        }
    }, {
        key: 'resetHistoryState',
        value: function resetHistoryState() {
            if (!('history' in window)) return;

            window.history.pushState(null, document.title, window.location.href.replace(/\?.+$/, ''));

            var title = document.querySelector('title');

            if (title && title.getAttribute('data-page-title') && title.getAttribute('data-page-title') !== document.title) document.title = title.getAttribute('data-page-title');
        }
    }, {
        key: 'scrollTo',
        value: function scrollTo(el) {
            if (!el) return;

            var scrollY = RootComponent.Scroller.state.get('scrollY') || 0;
            var top = el.getBoundingClientRect().top + scrollY - this.getGlobalHeaderStickyOffset(el);

            return top >= 0 && top <= scrollY + window.innerHeight ? Promise.resolve(true) : Promise.resolve(this.getBrowser('name') === 'ios' ? window.scrollTo(0, top) : RootComponent.Scroller.scrollTo({ y: top })).then(function () {
                el.focus();

                if (el.getAttribute('tabindex') === '-1') el.blur();
            });
        }
    }]);

    return ProjectsComponent;
}(Component);

var PaginationFetcherComponent = function (_Component) {
    _inherits(PaginationFetcherComponent, _Component);

    _createClass(PaginationFetcherComponent, null, [{
        key: 'selector',
        value: function selector() {
            return '.pagination-fetcher';
        }
    }]);

    function PaginationFetcherComponent(opts) {
        var _ret;

        _classCallCheck(this, PaginationFetcherComponent);

        var _this = _possibleConstructorReturn(this, (PaginationFetcherComponent.__proto__ || Object.getPrototypeOf(PaginationFetcherComponent)).call(this, opts));

        if (!_this.el) return _possibleConstructorReturn(_this);

        _this.Parser = 'DOMParser' in window ? new window.DOMParser() : null;

        _this.render();

        if (!_this.getItemsContainer() || !_this.getCta() || !_this.getPaginationTargetBtn() || !_this.Parser) return _ret = _this.el.setAttribute('data-rendered', 'false'), _possibleConstructorReturn(_this, _ret);

        _this.onCtaClick = _this.onCtaClick.bind(_this);
        _this.listen();
        return _this;
    }

    _createClass(PaginationFetcherComponent, [{
        key: 'listen',
        value: function listen() {
            this.getCta().addEventListener('click', this.onCtaClick, false);
        }
    }, {
        key: 'onCtaClick',
        value: function onCtaClick(e) {
            var _this2 = this;

            if (!this.getPaginationTargetBtn() || !this.getPaginationTargetBtn().href || this.getPaginationTargetBtn().classList.contains('done')) return this.setCtaState('done');

            this.setCtaState('loading');

            window.fetch(this.getPaginationTargetBtn().href).then(function (res) {
                if (String(res.status).match(/^[2|3]/)) return res.text();

                _this2.setCtaState('error');
                return false;
            }).then(function (res) {
                return res ? _this2.parseFetchedItems(res, _this2.getPaginationTargetBtn().href) : null;
            });
        }
    }, {
        key: 'getItemsContainer',
        value: function getItemsContainer() {
            return this.el.querySelector('[data-pagination-fetcher-items-container]');
        }
    }, {
        key: 'getCta',
        value: function getCta() {
            return this.el.querySelector('[data-pagination-fetcher-cta]');
        }
    }, {
        key: 'getPaginationTargetBtn',
        value: function getPaginationTargetBtn() {
            return this.el.querySelector('[data-pagination-fetcher-target]');
        }
    }, {
        key: 'parseFetchedItems',
        value: function parseFetchedItems(str, href) {
            var _this3 = this;

            if (!str || !str.match(/<html/)) return null;

            var doc = this.Parser.parseFromString(str, 'text/html');

            var newItemsContainer = doc ? doc.querySelector('.pagination-fetcher [data-pagination-fetcher-items-container]') : null;

            var newTarget = doc ? doc.querySelector('.pagination-fetcher [data-pagination-fetcher-target]') : null;

            if (!newItemsContainer || !newItemsContainer.children) return null;

            if (newTarget) this.render(newTarget);

            Array.from(newItemsContainer.children).forEach(function (node) {
                if (href) node.setAttribute('data-pagination-fetcher-page-href', href);

                if (_this3.props.disableImgLoading && _this3.getItemsContainer()) return _this3.getItemsContainer().appendChild(node);

                node.classList.add('onload');

                var images = Array.from(node.querySelectorAll('img[data-object-fit]'));

                images.forEach(function (img) {
                    img.classList.add('onload');
                    img.addEventListener('load', function () {
                        img.classList.remove('onload');
                        window.objectFitPolyfill();
                    }, false);
                });

                if (_this3.getItemsContainer()) _this3.getItemsContainer().appendChild(node);

                setTimeout(function () {
                    return node.classList.remove('onload');
                }, 10);
            });

            return true;
        }
    }, {
        key: 'setCtaState',
        value: function setCtaState() {
            var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'reset';

            var cta = this.getCta();

            if (!cta) return;

            if (state === 'reset') {
                cta.classList.remove('loading');
                cta.classList.remove('done');
                cta.classList.remove('error');
            }

            if (state === 'loading') {
                cta.classList.remove('done');
                cta.classList.remove('error');
                cta.classList.add('loading');
            }

            if (state === 'done') {
                cta.classList.remove('loading');
                cta.classList.remove('error');
                cta.classList.add('done');
            }

            if (state === 'error') {
                cta.classList.remove('loading');
                cta.classList.remove('done');
                cta.classList.add('error');
            }
        }
    }, {
        key: 'render',
        value: function render(target) {
            var pagination = this.el.querySelector('.pagination');

            if (!pagination) return;

            if (target) {
                pagination.innerHTML = '';
                pagination.appendChild(target.cloneNode(true));
            }

            this.setCtaState(this.getPaginationTargetBtn().classList.contains('done') || !this.getPaginationTargetBtn().href ? 'done' : 'reset');
        }
    }]);

    return PaginationFetcherComponent;
}(Component);

var PressCoverageFormComponent = function (_Component) {
    _inherits(PressCoverageFormComponent, _Component);

    _createClass(PressCoverageFormComponent, null, [{
        key: 'selector',
        value: function selector() {
            return '.press-coverage-form';
        }
    }]);

    function PressCoverageFormComponent(opts) {
        _classCallCheck(this, PressCoverageFormComponent);

        var _this = _possibleConstructorReturn(this, (PressCoverageFormComponent.__proto__ || Object.getPrototypeOf(PressCoverageFormComponent)).call(this, opts));

        _this.render();
        return _this;
    }

    _createClass(PressCoverageFormComponent, [{
        key: 'getGlobalHeader',
        value: function getGlobalHeader() {
            return RootComponent.el.querySelector('#global-header');
        }
    }, {
        key: 'getGlobalHeaderStickyOffset',
        value: function getGlobalHeaderStickyOffset() {
            if (!this.getGlobalHeader()) return 0;

            var height = RootComponent.el.clientWidth <= 320 || this.getGlobalHeader().getAttribute('data-short-viewport') === 'true' ? 0 : Number((this.getGlobalHeader() || {}).getAttribute('data-sticky-offset')) || 0;

            return !height ? height : height - 1;
        }
    }, {
        key: 'scrollTo',
        value: function scrollTo(el) {
            if (!el) return;

            var scrollY = RootComponent.Scroller.state.get('scrollY') || 0;
            var top = el.getBoundingClientRect().top + scrollY - this.getGlobalHeaderStickyOffset(el);

            return top >= 0 && top <= scrollY + window.innerHeight ? Promise.resolve(true) : Promise.resolve(this.getBrowser('name') === 'ios' ? window.scrollTo(0, top) : RootComponent.Scroller.scrollTo({ y: top })).then(function () {
                el.focus();

                if (el.getAttribute('tabindex') === '-1') el.blur();
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var isSearch = (window.location.search || '').match(/(special-initiative|year|project)=/g);

            if (!isSearch) return;

            this.scrollTo(this.el);
        }
    }]);

    return PressCoverageFormComponent;
}(Component);

var ProjectsComponent$1 = function (_Component) {
    _inherits(ProjectsComponent, _Component);

    _createClass(ProjectsComponent, null, [{
        key: 'selector',
        value: function selector() {
            return '.projects';
        }
    }]);

    function ProjectsComponent(opts) {
        _classCallCheck(this, ProjectsComponent);

        var _this = _possibleConstructorReturn(this, (ProjectsComponent.__proto__ || Object.getPrototypeOf(ProjectsComponent)).call(this, opts));

        _this.state.set({
            view: 'full',
            projectsMenuTopicsState: 'collapsed'
        });

        _this.onChange = _this.onChange.bind(_this);
        _this.onScroll = _this.onScroll.bind(_this);

        _this.onProjectsMenuTopicsToggleBtnClick = _this.onProjectsMenuTopicsToggleBtnClick.bind(_this);

        _this.onProjectsMenuTopicsToggleBtnKeydown = _this.onProjectsMenuTopicsToggleBtnKeydown.bind(_this);

        _this.onProjectsMenuViewBtnClick = _this.onProjectsMenuViewBtnClick.bind(_this);

        _this.onProjectsMenuViewBtnKeydown = _this.onProjectsMenuViewBtnKeydown.bind(_this);

        _this.onProjectsMenuTopicsListAnchorClick = _this.onProjectsMenuTopicsListAnchorClick.bind(_this);

        _this.onProjectsMenuTopicsListAnchorKeydown = _this.onProjectsMenuTopicsListAnchorKeydown.bind(_this);

        _this.listen();
        return _this;
    }

    _createClass(ProjectsComponent, [{
        key: 'listen',
        value: function listen() {
            var _this2 = this;

            this.state.on('update', this.onChange);

            this.getProjectsMenuTopicsToggleBtns().forEach(function (el) {
                el.addEventListener('click', _this2.onProjectsMenuTopicsToggleBtnClick);
                el.addEventListener('keydown', _this2.onProjectsMenuTopicsToggleBtnKeydown);
            });

            this.getProjectsMenuViewBtns().forEach(function (el) {
                el.addEventListener('click', _this2.onProjectsMenuViewBtnClick);
                el.addEventListener('keydown', _this2.onProjectsMenuViewBtnKeydown);
            });

            this.getProjectsMenuTopicsListAnchors().forEach(function (el) {
                el.addEventListener('click', _this2.onProjectsMenuTopicsListAnchorClick);
                el.addEventListener('keydown', _this2.onProjectsMenuTopicsListAnchorKeydown);
            });

            if ((RootComponent.Scroller || {}).state) RootComponent.Scroller.state.on('update', this.onScroll);

            this.on('resize', function () {
                if (_this2.getFeature('touch')) return;

                _this2.render();
                _this2.onScroll();
            });

            this.on('resize:debounced', function () {
                _this2.render();
                _this2.onScroll();
            });
        }
    }, {
        key: 'onScroll',
        value: function onScroll() {
            var _this3 = this;

            var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                data: {
                    currentData: (RootComponent.Scroller || {}).state ? RootComponent.Scroller.state.get() : {}
                }
            };

            if (!this.el || !RootComponent.Scroller || RootComponent.Scroller.scrollingTo || this.el.clientWidth <= 320 || this.props.view !== 'full' || this.isShortViewport() || this.isDisabledStickyNavBrowser() || !this.getProjectsMenuTopics()) return;

            var data = e.data.currentData;

            var top = (this.getProjectsMenu().getBoundingClientRect().top || 0) - this.getGlobalHeaderNavsHeight();

            var stickyOffset = (this.getProjectsMenuTopics().getBoundingClientRect().bottom || 0) - this.getGlobalHeaderStickyOffset();

            var resetActive = function resetActive() {
                return _this3.el.querySelector('#projects-menu-topics-list a.active') ? _this3.el.querySelector('#projects-menu-topics-list a.active').classList.remove('active') : null;
            };

            if (!data.scrollY || top > 0) {
                resetActive();

                if (this.props.sticky && stickyOffset) {
                    this.el.removeAttribute('data-sticky');

                    this.getProjectsMenu().removeAttribute('style');
                }

                return this.render();
            }

            var bottom = this.el.getBoundingClientRect().top + this.el.clientHeight - this.getGlobalHeaderNavsHeight();

            if (data.scrollY && top <= 0) {
                if (!this.props.sticky && stickyOffset <= 0) {
                    if (this.props.projectsMenuTopicsState === 'expanded') this.state.set('projectsMenuTopicsState', 'collapsed');

                    this.el.setAttribute('data-sticky-init', true);
                    this.el.setAttribute('data-sticky', true);

                    this.render();
                }

                if (bottom >= 0 && this.props.stickyHidden) this.el.removeAttribute('data-sticky-hidden');else if (bottom < 0 && !this.props.stickyHidden) {
                    if (this.props.projectsMenuTopicsState === 'expanded') this.state.set('projectsMenuTopicsState', 'collapsed');

                    this.props.stickyHidden = true;

                    resetActive();
                }
            }

            var toggleBtnHeight = (this.getProjectsMenuTopics().querySelector('a[role="button"]') || {}).clientHeight || 0;

            var projectItems = Array.from(this.el.querySelectorAll('.projects-item')).filter(function (el) {
                return el.id;
            });

            projectItems.some(function (el, idx) {
                var anchor = _this3.el.querySelector('a[href$="#' + el.id + '"]');

                var elTop = el.getBoundingClientRect().top - (_this3.getGlobalHeaderStickyOffset() + toggleBtnHeight);

                var elBottom = !el.nextElementSibling || idx + 1 === projectItems.length ? bottom : el.nextElementSibling.getBoundingClientRect().top - (_this3.getGlobalHeaderStickyOffset() + toggleBtnHeight);

                return anchor && elTop <= 0 && elBottom > 0 ? _this3.setProjectsMenuTopicsListActiveAnchor(anchor) : false;
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(e) {
            var isViewChange = false;

            if (this.props.view !== e.data.currentData.view) {
                this.props.view = e.data.currentData.view;
                isViewChange = true;
            }

            if (this.props.projectsMenuTopicsState !== e.data.currentData.projectsMenuTopicsState) this.props.projectsMenuTopicsState = e.data.currentData.projectsMenuTopicsState;

            this.render();

            if (isViewChange && this.props.view === 'full') this.onScroll();
        }
    }, {
        key: 'onProjectsMenuTopicsToggleBtnClick',
        value: function onProjectsMenuTopicsToggleBtnClick(e) {
            var target = e.target.getAttribute('aria-controls') ? e.target : e.target.parentNode.getAttribute('aria-controls') ? e.target.parentNode : e.target.parentNode.parentNode.getAttribute('aria-controls') ? e.target.parentNode.parentNode : e.target.parentNode.parentNode.parentNode;

            if (!target.getAttribute('aria-controls')) return console.log(e.target);

            this.state.set('projectsMenuTopicsState', this.props.projectsMenuTopicsState === 'expanded' ? 'collapsed' : 'expanded');
        }
    }, {
        key: 'onProjectsMenuTopicsToggleBtnKeydown',
        value: function onProjectsMenuTopicsToggleBtnKeydown(e) {
            if (e.keyCode === 32 || (e.keyIdentifier || e.key || '').match(/^(enter)$/i)) this.onProjectsMenuTopicsToggleBtnClick(e);
        }
    }, {
        key: 'onProjectsMenuViewBtnClick',
        value: function onProjectsMenuViewBtnClick(e) {
            this.state.set('view', e.target.getAttribute('data-view'));
        }
    }, {
        key: 'onProjectsMenuViewBtnKeydown',
        value: function onProjectsMenuViewBtnKeydown(e) {
            if (e.keyCode === 32 || (e.keyIdentifier || e.key || '').match(/^(enter)$/i)) this.onProjectsMenuViewBtnClick(e);
        }
    }, {
        key: 'onProjectsMenuTopicsListAnchorClick',
        value: function onProjectsMenuTopicsListAnchorClick(e) {
            this.setProjectsMenuTopicsListActiveAnchor(e.target);
        }
    }, {
        key: 'onProjectsMenuTopicsListAnchorKeydown',
        value: function onProjectsMenuTopicsListAnchorKeydown(e) {
            if (e.keyCode === 32 || (e.keyIdentifier || e.key || '').match(/^(enter)$/i)) this.onProjectsMenuTopicsListAnchorClick(e);
        }
    }, {
        key: 'getProjectsMenuTopicsToggleBtns',
        value: function getProjectsMenuTopicsToggleBtns() {
            return Array.from(this.el.querySelectorAll('.projects-menu-topics-toggle-btn'));
        }
    }, {
        key: 'getProjectsMenuViewBtns',
        value: function getProjectsMenuViewBtns() {
            return Array.from(this.el.querySelectorAll('.projects-menu-view a[data-view]'));
        }
    }, {
        key: 'getProjectsMenu',
        value: function getProjectsMenu() {
            return this.el.querySelector('.projects-menu');
        }
    }, {
        key: 'getProjectsMenuTopics',
        value: function getProjectsMenuTopics() {
            return this.el.querySelector('.projects-menu-topics');
        }
    }, {
        key: 'getProjectsMenuTopicsListAnchors',
        value: function getProjectsMenuTopicsListAnchors() {
            return Array.from(this.el.querySelectorAll('#projects-menu-topics-list a'));
        }
    }, {
        key: 'getProjectsList',
        value: function getProjectsList() {
            this.el.querySelectorAll('.projects-list');
        }
    }, {
        key: 'getGlobalHeader',
        value: function getGlobalHeader() {
            return RootComponent.el.querySelector('#global-header');
        }
    }, {
        key: 'getGlobalHeaderNavs',
        value: function getGlobalHeaderNavs() {
            return RootComponent.el.querySelector('#global-header-navs');
        }
    }, {
        key: 'getGlobalHeaderNavsHeight',
        value: function getGlobalHeaderNavsHeight() {
            return this.getGlobalHeaderNavs().clientHeight - 1;
        }
    }, {
        key: 'getGlobalHeaderStickyOffset',
        value: function getGlobalHeaderStickyOffset() {
            if (!this.getGlobalHeader()) return 0;

            var height = RootComponent.el.clientWidth <= 320 || this.getGlobalHeader().getAttribute('data-short-viewport') === 'true' ? 0 : Number((this.getGlobalHeader() || {}).getAttribute('data-sticky-offset')) || 0;

            return !height ? height : height - 1;
        }
    }, {
        key: 'setProjectsMenuTopicsListActiveAnchor',
        value: function setProjectsMenuTopicsListActiveAnchor(el) {
            if (!el || el.classList.contains('active')) return el;

            this.getProjectsMenuTopicsListAnchors().forEach(function (item) {
                return item.classList[item === el ? 'add' : 'remove']('active');
            });
        }
    }, {
        key: 'isShortViewport',
        value: function isShortViewport() {
            return this.props.shortViewport === 'true';
        }
    }, {
        key: 'isDisabledStickyNavBrowser',
        value: function isDisabledStickyNavBrowser() {
            return this.getFeature('touch') && !window.navigator.userAgent.match(/(chrome|iphone|ipad)/i);
        }
    }, {
        key: 'isGlobalHeaderNavsSticky',
        value: function isGlobalHeaderNavsSticky() {
            return this.getGlobalHeaderNavs() ? window.getComputedStyle(this.getGlobalHeaderNavs()).position === 'fixed' : false;
        }
    }, {
        key: 'renderProjectsMenuBtns',
        value: function renderProjectsMenuBtns() {
            var _this4 = this;

            this.getProjectsMenuTopicsToggleBtns().forEach(function (el) {
                if (!el.getAttribute('tabindex')) el.setAttribute('tabindex', 0);

                var isExpanded = _this4.state.get('projectsMenuTopicsState') === 'expanded';

                var label = void 0;

                if (el.getAttribute('data-aria-label-collapsed') && !isExpanded) label = el.getAttribute('data-aria-label-collapsed');else if (el.getAttribute('data-aria-label-expanded') && isExpanded) label = el.getAttribute('data-aria-label-expanded');

                if (label) el.setAttribute('aria-label', label);
            });

            this.getProjectsMenuViewBtns().forEach(function (el) {
                if (!el.getAttribute('tabindex')) el.setAttribute('tabindex', 0);

                el.setAttribute('aria-current', el.getAttribute('data-view') === _this4.state.get('view'));
            });
        }
    }, {
        key: 'render',
        value: function render() {
            this.renderProjectsMenuBtns();

            if (window.innerHeight < 325) this.props.shortViewport = true;else if (this.el.getAttribute('data-short-viewport')) this.el.removeAttribute('data-short-viewport');

            if (this.isDisabledStickyNavBrowser() && !this.props.stickyDisabled) this.props.stickyDisabled = true;else if (!this.isDisabledStickyNavBrowser()) this.el.removeAttribute('data-sticky-disabled');

            if (!this.getProjectsMenu() || !this.getProjectsMenuTopics() || !this.getProjectsMenuTopics().querySelector('a[role=button]')) return;

            if (this.props.sticky) {
                var maxHeight = 'calc(100vh - ' + this.getGlobalHeaderNavsHeight() + 'px)';

                if (this.getProjectsMenuTopics().style.maxHeight !== maxHeight) this.getProjectsMenuTopics().style.maxHeight = maxHeight;

                if (Number(this.getProjectsMenuTopics().style.top.replace(/\d/g, '')) !== this.getGlobalHeaderNavsHeight()) {
                    this.getProjectsMenuTopics().style.top = this.getGlobalHeaderNavsHeight() + 'px';

                    if (this.el.getAttribute('data-sticky-init')) this.el.removeAttribute('data-sticky-init');
                }

                if (this.getGlobalHeaderNavs() && !this.getGlobalHeaderNavs().classList.contains('no-box-shadow')) this.getGlobalHeaderNavs().classList.add('no-box-shadow');
            } else {
                if (this.getProjectsMenuTopics().getAttribute('style')) this.getProjectsMenuTopics().removeAttribute('style');

                if (this.getGlobalHeaderNavs() && this.getGlobalHeaderNavs().classList.contains('no-box-shadow')) this.getGlobalHeaderNavs().classList.remove('no-box-shadow');
            }

            if (!window.location.search && !window.location.hash) return;

            var activeTopic = (window.location.search || '').match(/topic=.+/) ? window.location.search.replace(/.+topic=([^&]+).*/, '$1') : window.location.hash.replace('#', '');

            if ('history' in window) window.history.replaceState(null, null, window.location.pathname);

            var activeAnchor = this.el.querySelector('#projects-menu-topics-list a[href$="' + activeTopic + '"]');

            if (!activeAnchor) return;

            activeAnchor.click();
        }
    }]);

    return ProjectsComponent;
}(Component);

var win = window;

var raf = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.msRequestAnimationFrame || function (cb) {
  return setTimeout(cb, 16);
};

var win$1 = window;

var caf = win$1.cancelAnimationFrame || win$1.mozCancelAnimationFrame || function (id) {
  clearTimeout(id);
};

function extend() {
  var obj,
      name,
      copy,
      target = arguments[0] || {},
      i = 1,
      length = arguments.length;

  for (; i < length; i++) {
    if ((obj = arguments[i]) !== null) {
      for (name in obj) {
        copy = obj[name];

        if (target === copy) {
          continue;
        } else if (copy !== undefined) {
          target[name] = copy;
        }
      }
    }
  }
  return target;
}

function checkStorageValue(value) {
  return ['true', 'false'].indexOf(value) >= 0 ? JSON.parse(value) : value;
}

function setLocalStorage(storage, key, value, access) {
  if (access) {
    storage.setItem(key, value);
  }
  return value;
}

function getSlideId() {
  var id = window.tnsId;
  window.tnsId = !id ? 1 : id + 1;

  return 'tns' + window.tnsId;
}

function getBody() {
  var doc = document,
      body = doc.body;

  if (!body) {
    body = doc.createElement('body');
    body.fake = true;
  }

  return body;
}

var docElement = document.documentElement;

function setFakeBody(body) {
  var docOverflow = '';
  if (body.fake) {
    docOverflow = docElement.style.overflow;
    //avoid crashing IE8, if background image is used
    body.style.background = '';
    //Safari 5.13/5.1.4 OSX stops loading if ::-webkit-scrollbar is used and scrollbars are visible
    body.style.overflow = docElement.style.overflow = 'hidden';
    docElement.appendChild(body);
  }

  return docOverflow;
}

function resetFakeBody(body, docOverflow) {
  if (body.fake) {
    body.remove();
    docElement.style.overflow = docOverflow;
    // Trigger layout so kinetic scrolling isn't disabled in iOS6+
    // eslint-disable-next-line
    docElement.offsetHeight;
  }
}

// get css-calc 

function calc() {
  var doc = document,
      body = getBody(),
      docOverflow = setFakeBody(body),
      div = doc.createElement('div'),
      result = false;

  body.appendChild(div);
  try {
    var str = '(10px * 10)',
        vals = ['calc' + str, '-moz-calc' + str, '-webkit-calc' + str],
        val;
    for (var i = 0; i < 3; i++) {
      val = vals[i];
      div.style.width = val;
      if (div.offsetWidth === 100) {
        result = val.replace(str, '');
        break;
      }
    }
  } catch (e) {}

  body.fake ? resetFakeBody(body, docOverflow) : div.remove();

  return result;
}

// get subpixel support value

function percentageLayout() {
  // check subpixel layout supporting
  var doc = document,
      body = getBody(),
      docOverflow = setFakeBody(body),
      wrapper = doc.createElement('div'),
      outer = doc.createElement('div'),
      str = '',
      count = 70,
      perPage = 3,
      supported = false;

  wrapper.className = "tns-t-subp2";
  outer.className = "tns-t-ct";

  for (var i = 0; i < count; i++) {
    str += '<div></div>';
  }

  outer.innerHTML = str;
  wrapper.appendChild(outer);
  body.appendChild(wrapper);

  supported = Math.abs(wrapper.getBoundingClientRect().left - outer.children[count - perPage].getBoundingClientRect().left) < 2;

  body.fake ? resetFakeBody(body, docOverflow) : wrapper.remove();

  return supported;
}

function mediaquerySupport() {
  var doc = document,
      body = getBody(),
      docOverflow = setFakeBody(body),
      div = doc.createElement('div'),
      style = doc.createElement('style'),
      rule = '@media all and (min-width:1px){.tns-mq-test{position:absolute}}',
      position;

  style.type = 'text/css';
  div.className = 'tns-mq-test';

  body.appendChild(style);
  body.appendChild(div);

  if (style.styleSheet) {
    style.styleSheet.cssText = rule;
  } else {
    style.appendChild(doc.createTextNode(rule));
  }

  position = window.getComputedStyle ? window.getComputedStyle(div).position : div.currentStyle['position'];

  body.fake ? resetFakeBody(body, docOverflow) : div.remove();

  return position === "absolute";
}

// create and append style sheet
function createStyleSheet(media) {
  // Create the <style> tag
  var style = document.createElement("style");
  // style.setAttribute("type", "text/css");

  // Add a media (and/or media query) here if you'd like!
  // style.setAttribute("media", "screen")
  // style.setAttribute("media", "only screen and (max-width : 1024px)")
  if (media) {
    style.setAttribute("media", media);
  }

  // WebKit hack :(
  // style.appendChild(document.createTextNode(""));

  // Add the <style> element to the page
  document.querySelector('head').appendChild(style);

  return style.sheet ? style.sheet : style.styleSheet;
}

// cross browsers addRule method
function addCSSRule(sheet, selector, rules, index) {
  // return raf(function() {
  'insertRule' in sheet ? sheet.insertRule(selector + '{' + rules + '}', index) : sheet.addRule(selector, rules, index);
  // });
}

// cross browsers addRule method
function removeCSSRule(sheet, index) {
  // return raf(function() {
  'deleteRule' in sheet ? sheet.deleteRule(index) : sheet.removeRule(index);
  // });
}

function getCssRulesLength(sheet) {
  var rule = 'insertRule' in sheet ? sheet.cssRules : sheet.rules;
  return rule.length;
}

function toDegree(y, x) {
  return Math.atan2(y, x) * (180 / Math.PI);
}

function getTouchDirection(angle, range) {
  var direction = false,
      gap = Math.abs(90 - Math.abs(angle));

  if (gap >= 90 - range) {
    direction = 'horizontal';
  } else if (gap <= range) {
    direction = 'vertical';
  }

  return direction;
}

// https://toddmotto.com/ditch-the-array-foreach-call-nodelist-hack/
function forEachNodeList(arr, callback, scope) {
  for (var i = 0, l = arr.length; i < l; i++) {
    callback.call(scope, arr[i], i);
  }
}

var classListSupport = 'classList' in document.createElement('_');

var hasClass = classListSupport ? function (el, str) {
    return el.classList.contains(str);
} : function (el, str) {
    return el.className.indexOf(str) >= 0;
};

var addClass = classListSupport ? function (el, str) {
  if (!hasClass(el, str)) {
    el.classList.add(str);
  }
} : function (el, str) {
  if (!hasClass(el, str)) {
    el.className += ' ' + str;
  }
};

var removeClass = classListSupport ? function (el, str) {
  if (hasClass(el, str)) {
    el.classList.remove(str);
  }
} : function (el, str) {
  if (hasClass(el, str)) {
    el.className = el.className.replace(str, '');
  }
};

function hasAttr(el, attr) {
  return el.hasAttribute(attr);
}

function getAttr(el, attr) {
  return el.getAttribute(attr);
}

function isNodeList(el) {
  // Only NodeList has the "item()" function
  return typeof el.item !== "undefined";
}

function setAttrs(els, attrs) {
  els = isNodeList(els) || els instanceof Array ? els : [els];
  if (Object.prototype.toString.call(attrs) !== '[object Object]') {
    return;
  }

  for (var i = els.length; i--;) {
    for (var key in attrs) {
      els[i].setAttribute(key, attrs[key]);
    }
  }
}

function removeAttrs(els, attrs) {
  els = isNodeList(els) || els instanceof Array ? els : [els];
  attrs = attrs instanceof Array ? attrs : [attrs];

  var attrLength = attrs.length;
  for (var i = els.length; i--;) {
    for (var j = attrLength; j--;) {
      els[i].removeAttribute(attrs[j]);
    }
  }
}

function arrayFromNodeList(nl) {
  var arr = [];
  for (var i = 0, l = nl.length; i < l; i++) {
    arr.push(nl[i]);
  }
  return arr;
}

function hideElement(el, forceHide) {
  if (el.style.display !== 'none') {
    el.style.display = 'none';
  }
}

function showElement(el, forceHide) {
  if (el.style.display === 'none') {
    el.style.display = '';
  }
}

function isVisible(el) {
  return el.offsetWidth > 0 && el.offsetHeight > 0;
}

function whichProperty(props) {
  if (typeof props === 'string') {
    var arr = [props],
        Props = props.charAt(0).toUpperCase() + props.substr(1),
        prefixes = ['Webkit', 'Moz', 'ms', 'O'];

    prefixes.forEach(function (prefix) {
      if (prefix !== 'ms' || props === 'transform') {
        arr.push(prefix + Props);
      }
    });

    props = arr;
  }

  var el = document.createElement('fakeelement'),
      len = props.length;
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    if (el.style[prop] !== undefined) {
      return prop;
    }
  }

  return false; // explicit for ie9-
}

function has3DTransforms(tf) {
    if (!tf) {
        return false;
    }
    if (!window.getComputedStyle) {
        return false;
    }

    var doc = document,
        body = getBody(),
        docOverflow = setFakeBody(body),
        el = doc.createElement('p'),
        has3d,
        cssTF = tf.length > 9 ? '-' + tf.slice(0, -9).toLowerCase() + '-' : '';

    cssTF += 'transform';

    // Add it to the body to get the computed style
    body.insertBefore(el, null);

    el.style[tf] = 'translate3d(1px,1px,1px)';
    has3d = window.getComputedStyle(el).getPropertyValue(cssTF);

    body.fake ? resetFakeBody(body, docOverflow) : el.remove();

    return has3d !== undefined && has3d.length > 0 && has3d !== "none";
}

// get transitionend, animationend based on transitionDuration
// @propin: string
// @propOut: string, first-letter uppercase
// Usage: getEndProperty('WebkitTransitionDuration', 'Transition') => webkitTransitionEnd
function getEndProperty(propIn, propOut) {
  var endProp = false;
  if (/^Webkit/.test(propIn)) {
    endProp = 'webkit' + propOut + 'End';
  } else if (/^O/.test(propIn)) {
    endProp = 'o' + propOut + 'End';
  } else if (propIn) {
    endProp = propOut.toLowerCase() + 'end';
  }
  return endProp;
}

// Test via a getter in the options object to see if the passive property is accessed
var supportsPassive = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      supportsPassive = true;
    }
  });
  window.addEventListener("test", null, opts);
} catch (e) {}
var passiveOption = supportsPassive ? { passive: true } : false;

function addEvents(el, obj) {
  for (var prop in obj) {
    var option = prop === 'touchstart' || prop === 'touchmove' ? passiveOption : false;
    el.addEventListener(prop, obj[prop], option);
  }
}

function removeEvents(el, obj) {
  for (var prop in obj) {
    var option = ['touchstart', 'touchmove'].indexOf(prop) >= 0 ? passiveOption : false;
    el.removeEventListener(prop, obj[prop], option);
  }
}

function Events() {
  return {
    topics: {},
    on: function on(eventName, fn) {
      this.topics[eventName] = this.topics[eventName] || [];
      this.topics[eventName].push(fn);
    },
    off: function off(eventName, fn) {
      if (this.topics[eventName]) {
        for (var i = 0; i < this.topics[eventName].length; i++) {
          if (this.topics[eventName][i] === fn) {
            this.topics[eventName].splice(i, 1);
            break;
          }
        }
      }
    },
    emit: function emit(eventName, data) {
      if (this.topics[eventName]) {
        this.topics[eventName].forEach(function (fn) {
          fn(data);
        });
      }
    }
  };
}

function jsTransform(element, attr, prefix, postfix, to, duration, callback) {
  var tick = Math.min(duration, 10),
      unit = to.indexOf('%') >= 0 ? '%' : 'px',
      to = to.replace(unit, ''),
      from = Number(element.style[attr].replace(prefix, '').replace(postfix, '').replace(unit, '')),
      positionTick = (to - from) / duration * tick;

  setTimeout(moveElement, tick);
  function moveElement() {
    duration -= tick;
    from += positionTick;
    element.style[attr] = prefix + from + unit + postfix;
    if (duration > 0) {
      setTimeout(moveElement, tick);
    } else {
      callback();
    }
  }
}

// helper functions
if (!Object.keys) {
  Object.keys = function (object) {
    var keys = [];
    for (var name in object) {
      if (Object.prototype.hasOwnProperty.call(object, name)) {
        keys.push(name);
      }
    }
    return keys;
  };
}
if (!("remove" in Element.prototype)) {
  Element.prototype.remove = function () {
    if (this.parentNode) {
      this.parentNode.removeChild(this);
    }
  };
}

var tns = function tns(options) {
  options = extend({
    container: '.slider',
    mode: 'carousel',
    axis: 'horizontal',
    items: 1,
    gutter: 0,
    edgePadding: 0,
    fixedWidth: false,
    autoWidth: false,
    viewportMax: false,
    slideBy: 1,
    controls: true,
    controlsText: ['prev', 'next'],
    controlsContainer: false,
    prevButton: false,
    nextButton: false,
    nav: true,
    navContainer: false,
    navAsThumbnails: false,
    arrowKeys: false,
    speed: 300,
    autoplay: false,
    autoplayTimeout: 5000,
    autoplayDirection: 'forward',
    autoplayText: ['start', 'stop'],
    autoplayHoverPause: false,
    autoplayButton: false,
    autoplayButtonOutput: true,
    autoplayResetOnVisibility: true,
    animateIn: 'tns-fadeIn',
    animateOut: 'tns-fadeOut',
    animateNormal: 'tns-normal',
    animateDelay: false,
    loop: true,
    rewind: false,
    autoHeight: false,
    responsive: false,
    lazyload: false,
    touch: true,
    mouseDrag: false,
    swipeAngle: 15,
    nested: false,
    freezable: true,
    onInit: false,
    useLocalStorage: true
  }, options || {});

  var doc = document,
      win = window,
      KEYS = {
    ENTER: 13,
    SPACE: 32,
    PAGEUP: 33,
    PAGEDOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40
  },
      tnsStorage = {},
      localStorageAccess = options.useLocalStorage;

  if (localStorageAccess) {
    // check browser version and local storage access
    var browserInfo = navigator.userAgent;
    var uid = new Date();

    try {
      tnsStorage = win.localStorage;
      if (tnsStorage) {
        tnsStorage.setItem(uid, uid);
        localStorageAccess = tnsStorage.getItem(uid) == uid;
        tnsStorage.removeItem(uid);
      } else {
        localStorageAccess = false;
      }
      if (!localStorageAccess) {
        tnsStorage = {};
      }
    } catch (e) {
      localStorageAccess = false;
    }

    if (localStorageAccess) {
      // remove storage when browser version changes
      if (tnsStorage['tnsApp'] && tnsStorage['tnsApp'] !== browserInfo) {
        ['tC', 'tPL', 'tMQ', 'tTf', 't3D', 'tTDu', 'tTDe', 'tADu', 'tADe', 'tTE', 'tAE'].forEach(function (item) {
          tnsStorage.removeItem(item);
        });
      }
      // update browserInfo
      localStorage['tnsApp'] = browserInfo;
    }
  }

  var CALC = tnsStorage['tC'] ? checkStorageValue(tnsStorage['tC']) : setLocalStorage(tnsStorage, 'tC', calc(), localStorageAccess),
      PERCENTAGELAYOUT = tnsStorage['tPL'] ? checkStorageValue(tnsStorage['tPL']) : setLocalStorage(tnsStorage, 'tPL', percentageLayout(), localStorageAccess),
      CSSMQ = tnsStorage['tMQ'] ? checkStorageValue(tnsStorage['tMQ']) : setLocalStorage(tnsStorage, 'tMQ', mediaquerySupport(), localStorageAccess),
      TRANSFORM = tnsStorage['tTf'] ? checkStorageValue(tnsStorage['tTf']) : setLocalStorage(tnsStorage, 'tTf', whichProperty('transform'), localStorageAccess),
      HAS3DTRANSFORMS = tnsStorage['t3D'] ? checkStorageValue(tnsStorage['t3D']) : setLocalStorage(tnsStorage, 't3D', has3DTransforms(TRANSFORM), localStorageAccess),
      TRANSITIONDURATION = tnsStorage['tTDu'] ? checkStorageValue(tnsStorage['tTDu']) : setLocalStorage(tnsStorage, 'tTDu', whichProperty('transitionDuration'), localStorageAccess),
      TRANSITIONDELAY = tnsStorage['tTDe'] ? checkStorageValue(tnsStorage['tTDe']) : setLocalStorage(tnsStorage, 'tTDe', whichProperty('transitionDelay'), localStorageAccess),
      ANIMATIONDURATION = tnsStorage['tADu'] ? checkStorageValue(tnsStorage['tADu']) : setLocalStorage(tnsStorage, 'tADu', whichProperty('animationDuration'), localStorageAccess),
      ANIMATIONDELAY = tnsStorage['tADe'] ? checkStorageValue(tnsStorage['tADe']) : setLocalStorage(tnsStorage, 'tADe', whichProperty('animationDelay'), localStorageAccess),
      TRANSITIONEND = tnsStorage['tTE'] ? checkStorageValue(tnsStorage['tTE']) : setLocalStorage(tnsStorage, 'tTE', getEndProperty(TRANSITIONDURATION, 'Transition'), localStorageAccess),
      ANIMATIONEND = tnsStorage['tAE'] ? checkStorageValue(tnsStorage['tAE']) : setLocalStorage(tnsStorage, 'tAE', getEndProperty(ANIMATIONDURATION, 'Animation'), localStorageAccess);

  // get element nodes from selectors
  var supportConsoleWarn = win.console && typeof win.console.warn === "function",
      tnsList = ['container', 'controlsContainer', 'prevButton', 'nextButton', 'navContainer', 'autoplayButton'],
      optionsElements = {};
  for (var i = tnsList.length; i--;) {
    var item = tnsList[i];
    if (typeof options[item] === 'string') {
      var str = options[item],
          el = doc.querySelector(str);
      optionsElements[item] = str;

      if (el && el.nodeName) {
        options[item] = el;
      } else {
        if (supportConsoleWarn) {
          console.warn('Can\'t find', options[item]);
        }
        return;
      }
    }
  }

  // make sure at least 1 slide
  if (options.container.children.length < 1) {
    if (supportConsoleWarn) {
      console.warn('No slides found in', options.container);
    }
    return;
  }

  // update options
  var responsive = options.responsive,
      nested = options.nested,
      carousel = options.mode === 'carousel' ? true : false;

  if (responsive) {
    // apply responsive[0] to options and remove it
    if (0 in responsive) {
      options = extend(options, responsive[0]);
      delete responsive[0];
    }

    var responsiveTem = {};
    for (var key in responsive) {
      var val = responsive[key];
      // update responsive
      // from: 300: 2
      // to: 
      //   300: { 
      //     items: 2 
      //   } 
      val = typeof val === 'number' ? { items: val } : val;
      responsiveTem[key] = val;
    }
    responsive = responsiveTem;
    responsiveTem = null;
  }

  // update options
  function updateOptions(obj) {
    for (var key in obj) {
      if (!carousel) {
        if (key === 'slideBy') {
          obj[key] = 'page';
        }
        if (key === 'edgePadding') {
          obj[key] = false;
        }
        if (key === 'autoHeight') {
          obj[key] = false;
        }
      }
      if (nested === 'outer' && key === 'autoHeight') {
        obj[key] = true;
      }

      // update responsive options
      if (key === 'responsive') {
        updateOptions(obj[key]);
      }
    }
  }
  if (!carousel || nested === 'outer') {
    updateOptions(options);
  }

  // === define and set variables ===
  if (!carousel) {
    options.axis = 'horizontal';
    options.slideBy = 'page';
    options.edgePadding = false;

    var animateIn = options.animateIn,
        animateOut = options.animateOut,
        animateDelay = options.animateDelay,
        animateNormal = options.animateNormal;
  }

  var horizontal = options.axis === 'horizontal' ? true : false,
      outerWrapper = doc.createElement('div'),
      innerWrapper = doc.createElement('div'),
      container = options.container,
      containerParent = container.parentNode,
      containerHTML = container.outerHTML,
      slideItems = container.children,
      slideCount = slideItems.length,
      breakpointZone,
      windowWidth = getWindowWidth(),
      isOn = true;
  if (responsive) {
    setBreakpointZone();
  }

  // fixedWidth: viewport > rightBoundary > indexMax
  var autoWidth = options.autoWidth,
      fixedWidth = getOption('fixedWidth'),
      edgePadding = getOption('edgePadding'),
      gutter = getOption('gutter'),
      viewport = getViewportWidth(),
      items = !autoWidth ? Math.floor(getOption('items')) : 1,
      slideBy = getOption('slideBy'),
      viewportMax = options.viewportMax || options.fixedWidthViewportWidth,
      arrowKeys = getOption('arrowKeys'),
      speed = getOption('speed'),
      rewind = options.rewind,
      loop = rewind ? false : options.loop,
      autoHeight = getOption('autoHeight'),
      controls = getOption('controls'),
      controlsText = getOption('controlsText'),
      nav = getOption('nav'),
      touch = getOption('touch'),
      mouseDrag = getOption('mouseDrag'),
      autoplay = getOption('autoplay'),
      autoplayTimeout = getOption('autoplayTimeout'),
      autoplayText = getOption('autoplayText'),
      autoplayHoverPause = getOption('autoplayHoverPause'),
      autoplayResetOnVisibility = getOption('autoplayResetOnVisibility'),
      sheet = createStyleSheet(),
      lazyload = options.lazyload,
      slidePositions,
      // collection of slide positions
  slideItemsOut = [],
      cloneCount = loop ? getCloneCountForLoop() : 0,
      slideCountNew = !carousel ? slideCount + cloneCount : slideCount + cloneCount * 2,
      hasRightDeadZone = (fixedWidth || autoWidth) && !loop ? true : false,
      rightBoundary = fixedWidth ? getRightBoundary() : null,
      updateIndexBeforeTransform = !carousel || !loop ? true : false,

  // transform
  transformAttr = horizontal ? 'left' : 'top',
      transformPrefix = '',
      transformPostfix = '',

  // index
  getIndexMax = function () {
    if (fixedWidth) {
      return function () {
        return Math.floor(-rightBoundary / (fixedWidth + gutter)) + 1;
      };
    } else if (autoWidth) {
      return function () {
        for (var i = slideCountNew, result = i - 1; i--;) {
          if (slidePositions[i] > -rightBoundary) {
            result = i;
          }
        }
        return result;
      };
    } else {
      return function () {
        return loop || carousel ? Math.max(0, slideCountNew - Math.ceil(items)) : slideCountNew - 1;
      };
    }
  }(),
      index = getStartIndex(getOption('startIndex')),
      indexCached = index,
      indexMin = 0,
      indexMax = !autoWidth ? getIndexMax() : null,

  // resize
  resizeTimer,
      swipeAngle = options.swipeAngle,
      moveDirectionExpected = swipeAngle ? '?' : true,
      running = false,
      onInit = options.onInit,
      events = new Events(),

  // id, class
  newContainerClasses = ' tns-slider tns-' + options.mode,
      slideId = container.id || getSlideId(),
      disable = getOption('disable'),
      disabled = false,
      freezable = options.freezable,
      freeze = freezable && !autoWidth ? getFreeze() : false,
      frozen = false,
      controlsEvents = {
    'click': onControlsClick,
    'keydown': onControlsKeydown
  },
      navEvents = {
    'click': onNavClick,
    'keydown': onNavKeydown
  },
      hoverEvents = {
    'mouseover': mouseoverPause,
    'mouseout': mouseoutRestart
  },
      visibilityEvent = { 'visibilitychange': onVisibilityChange },
      docmentKeydownEvent = { 'keydown': onDocumentKeydown },
      touchEvents = {
    'touchstart': onPanStart,
    'touchmove': onPanMove,
    'touchend': onPanEnd,
    'touchcancel': onPanEnd
  },
      dragEvents = {
    'mousedown': onPanStart,
    'mousemove': onPanMove,
    'mouseup': onPanEnd,
    'mouseleave': onPanEnd
  },
      hasControls = hasOption('controls'),
      hasNav = hasOption('nav'),
      navAsThumbnails = autoWidth ? true : options.navAsThumbnails,
      hasAutoplay = hasOption('autoplay'),
      hasTouch = hasOption('touch'),
      hasMouseDrag = hasOption('mouseDrag'),
      slideActiveClass = 'tns-slide-active',
      imgCompleteClass = 'tns-complete',
      imgEvents = {
    'load': imgLoadedOrError,
    'error': imgLoadedOrError
  },
      imgsComplete;

  // controls
  if (hasControls) {
    var controlsContainer = options.controlsContainer,
        controlsContainerHTML = options.controlsContainer ? options.controlsContainer.outerHTML : '',
        prevButton = options.prevButton,
        nextButton = options.nextButton,
        prevButtonHTML = options.prevButton ? options.prevButton.outerHTML : '',
        nextButtonHTML = options.nextButton ? options.nextButton.outerHTML : '',
        prevIsButton,
        nextIsButton;
  }

  // nav
  if (hasNav) {
    var navContainer = options.navContainer,
        navContainerHTML = options.navContainer ? options.navContainer.outerHTML : '',
        navItems,
        visibleNavIndexes = [],
        visibleNavIndexesCached = visibleNavIndexes,
        navClicked = -1,
        navCurrentIndex = getAbsIndex(),
        navCurrentIndexCached = navCurrentIndex,
        navActiveClass = 'tns-nav-active';
  }

  // autoplay
  if (hasAutoplay) {
    var autoplayDirection = options.autoplayDirection === 'forward' ? 1 : -1,
        autoplayButton = options.autoplayButton,
        autoplayButtonHTML = options.autoplayButton ? options.autoplayButton.outerHTML : '',
        autoplayHtmlStrings = ['<span class=\'tns-visually-hidden\'>', ' animation</span>'],
        autoplayTimer,
        animating,
        autoplayHoverPaused,
        autoplayUserPaused,
        autoplayVisibilityPaused;
  }

  if (hasTouch || hasMouseDrag) {
    var initPosition = {},
        lastPosition = {},
        translateInit,
        disX,
        disY,
        panStart = false,
        rafIndex = 0,
        getDist = horizontal ? function (a, b) {
      return a.x - b.x;
    } : function (a, b) {
      return a.y - b.y;
    };
  }

  // disable slider when slidecount <= items
  if (!autoWidth) {
    resetVariblesWhenDisable(disable || freeze);
  }

  if (TRANSFORM) {
    transformAttr = TRANSFORM;
    transformPrefix = 'translate';

    if (HAS3DTRANSFORMS) {
      transformPrefix += horizontal ? '3d(' : '3d(0px, ';
      transformPostfix = horizontal ? ', 0px, 0px)' : ', 0px)';
    } else {
      transformPrefix += horizontal ? 'X(' : 'Y(';
      transformPostfix = ')';
    }
  }

  sliderInit();

  // === COMMON FUNCTIONS === //
  function resetVariblesWhenDisable(condition) {
    if (condition) {
      controls = nav = touch = mouseDrag = arrowKeys = autoplay = autoplayHoverPause = autoplayResetOnVisibility = false;
    }
  }

  function getStartIndex(ind) {
    ind = ind ? Math.max(0, Math.min(loop ? slideCount - 1 : slideCount - items, ind)) : 0;
    return carousel ? ind + cloneCount : ind;
  }

  function getAbsIndex(i) {
    if (i == null) {
      i = index;
    }

    if (carousel) {
      i -= cloneCount;
    }
    while (i < 0) {
      i += slideCount;
    }

    return Math.floor(i % slideCount);
  }

  function getItemsMax() {
    // fixedWidth or autoWidth while viewportMax is not available
    if (autoWidth || fixedWidth && !viewportMax) {
      return slideCount - 1;
      // most cases
    } else {
      var str = fixedWidth ? 'fixedWidth' : 'items',
          arr = [];

      if (fixedWidth || options[str] < slideCount) {
        arr.push(options[str]);
      }

      if (responsive) {
        for (var bp in responsive) {
          var tem = responsive[bp][str];
          if (tem && (fixedWidth || tem < slideCount)) {
            arr.push(tem);
          }
        }
      }

      if (!arr.length) {
        arr.push(0);
      }

      return Math.ceil(fixedWidth ? viewportMax / Math.min.apply(null, arr) : Math.max.apply(null, arr));
    }
  }

  function getCloneCountForLoop() {
    var itemsMax = getItemsMax(),
        result = carousel ? Math.ceil((itemsMax * 5 - slideCount) / 2) : itemsMax * 4 - slideCount;
    result = Math.max(itemsMax, result);

    return hasOption('edgePadding') ? result + 1 : result;
  }

  function getWindowWidth() {
    return win.innerWidth || doc.documentElement.clientWidth || doc.body.clientWidth;
  }

  function getClientWidth(el) {
    return el.clientWidth || getClientWidth(el.parentNode);
  }

  function getViewportWidth() {
    return getClientWidth(containerParent) - (edgePadding * 2 - gutter);
  }

  function hasOption(item) {
    if (options[item]) {
      return true;
    } else {
      if (responsive) {
        for (var bp in responsive) {
          if (responsive[bp][item]) {
            return true;
          }
        }
      }
      return false;
    }
  }

  // get option:
  // fixed width: viewport, fixedWidth, gutter => items
  // others: window width => all variables
  // all: items => slideBy
  function getOption(item, ww) {
    if (ww == null) {
      ww = windowWidth;
    }

    if (item === 'items' && fixedWidth) {
      return Math.floor(viewport / (fixedWidth + gutter)) || 1;
    } else {
      var result = options[item];

      if (responsive) {
        for (var bp in responsive) {
          // bp: convert string to number
          if (ww >= parseInt(bp)) {
            if (item in responsive[bp]) {
              result = responsive[bp][item];
            }
          }
        }
      }

      if (item === 'slideBy' && result === 'page') {
        result = getOption('items');
      }
      if (!carousel && (item === 'slideBy' || item === 'items')) {
        result = Math.floor(result);
      }

      return result;
    }
  }

  function getSlideMarginLeft(i) {
    return CALC ? CALC + '(' + i * 100 + '% / ' + slideCountNew + ')' : i * 100 / slideCountNew + '%';
  }

  function getInnerWrapperStyles(edgePaddingTem, gutterTem, fixedWidthTem, speedTem) {
    var str = '';

    if (edgePaddingTem) {
      var gap = edgePaddingTem;
      if (gutterTem) {
        gap -= gutterTem;
      }
      str = horizontal ? 'margin: 0 ' + gap + 'px 0 ' + edgePaddingTem + 'px;' : 'margin: ' + edgePaddingTem + 'px 0 ' + gap + 'px 0;';
    } else if (gutterTem && !fixedWidthTem) {
      var gutterTemUnit = '-' + gutterTem + 'px',
          dir = horizontal ? gutterTemUnit + ' 0 0' : '0 ' + gutterTemUnit + ' 0';
      str = 'margin: 0 ' + dir + ';';
    }

    if (TRANSITIONDURATION && speedTem) {
      str += getTrsnsitionDurationStyle(speedTem);
    }

    return str;
  }

  function getContainerWidth(fixedWidthTem, gutterTem, itemsTem) {
    if (fixedWidthTem) {
      return (fixedWidthTem + gutterTem) * slideCountNew + 'px';
    } else {
      return CALC ? CALC + '(' + slideCountNew * 100 + '% / ' + itemsTem + ')' : slideCountNew * 100 / itemsTem + '%';
    }
  }

  function getSlideWidthStyle(fixedWidthTem, gutterTem, itemsTem) {
    var width;

    if (fixedWidthTem) {
      width = fixedWidthTem + gutterTem + 'px';
    } else {
      if (!carousel) {
        itemsTem = Math.floor(itemsTem);
      }
      var dividend = carousel ? slideCountNew : itemsTem;
      width = CALC ? CALC + '(100% / ' + dividend + ')' : 100 / dividend + '%';
    }

    width = 'width:' + width;

    // inner slider: overwrite outer slider styles
    return nested !== 'inner' ? width + ';' : width + ' !important;';
  }

  function getSlideGutterStyle(gutterTem) {
    var str = '';

    // gutter maybe interger || 0
    // so can't use 'if (gutter)'
    if (gutterTem !== false) {
      var prop = horizontal ? 'padding-' : 'margin-',
          dir = horizontal ? 'right' : 'bottom';
      str = prop + dir + ': ' + gutterTem + 'px;';
    }

    return str;
  }

  function getCSSPrefix(name, num) {
    var prefix = name.substring(0, name.length - num).toLowerCase();
    if (prefix) {
      prefix = '-' + prefix + '-';
    }

    return prefix;
  }

  function getTrsnsitionDurationStyle(speed) {
    return getCSSPrefix(TRANSITIONDURATION, 18) + 'transition-duration:' + speed / 1000 + 's;';
  }

  function getAnimationDurationStyle(speed) {
    return getCSSPrefix(ANIMATIONDURATION, 17) + 'animation-duration:' + speed / 1000 + 's;';
  }

  function sliderInit() {
    if (responsive) {
      setBreakpointZone();
    }
    initStructure();

    // add id, class, aria attributes 
    // before clone slides
    for (var x = 0; x < slideCount; x++) {
      var item = slideItems[x];
      if (!item.id) {
        item.id = slideId + '-item' + x;
      }
      addClass(item, 'tns-item');
      if (!carousel && animateNormal) {
        addClass(item, animateNormal);
      }
      setAttrs(item, {
        'aria-hidden': 'true',
        'tabindex': '-1'
      });
    }

    // ## clone slides
    // carousel: n + slides + n
    // gallery:      slides + n
    if (cloneCount) {
      var fragmentBefore = doc.createDocumentFragment(),
          fragmentAfter = doc.createDocumentFragment();

      for (var j = cloneCount; j--;) {
        var num = j % slideCount,
            cloneFirst = slideItems[num].cloneNode(true);
        removeAttrs(cloneFirst, 'id');
        fragmentAfter.insertBefore(cloneFirst, fragmentAfter.firstChild);

        if (carousel) {
          var cloneLast = slideItems[slideCount - 1 - num].cloneNode(true);
          removeAttrs(cloneLast, 'id');
          fragmentBefore.appendChild(cloneLast);
        }
      }

      container.insertBefore(fragmentBefore, container.firstChild);
      container.appendChild(fragmentAfter);
      slideItems = container.children;
    }

    initSheet();
    initSliderTransform();
  }

  function initStructure() {
    var classOuter = 'tns-outer',
        classInner = 'tns-inner',
        hasGutter = hasOption('gutter');

    outerWrapper.className = classOuter;
    innerWrapper.className = classInner;
    outerWrapper.id = slideId + '-ow';
    innerWrapper.id = slideId + '-iw';
    if (autoHeight) {
      innerWrapper.className += ' tns-ah';
    }

    // set container properties
    if (container.id === '') {
      container.id = slideId;
    }
    newContainerClasses += PERCENTAGELAYOUT || autoWidth ? ' tns-subpixel' : ' tns-no-subpixel';
    newContainerClasses += CALC ? ' tns-calc' : ' tns-no-calc';
    // if (carousel) { newContainerClasses += ' tns-' + options.axis; }
    newContainerClasses += ' tns-' + options.axis;
    container.className += newContainerClasses;

    // add constrain layer for carousel
    if (carousel) {
      var middleWrapper = doc.createElement('div');
      middleWrapper.className = 'tns-ovh';

      outerWrapper.appendChild(middleWrapper);
      middleWrapper.appendChild(innerWrapper);
    } else {
      outerWrapper.appendChild(innerWrapper);
    }

    containerParent.insertBefore(outerWrapper, container);
    innerWrapper.appendChild(container);
  }

  function initSliderTransform() {
    // ## images loaded/failed
    if (hasOption('autoHeight') || autoWidth || !horizontal) {
      var imgs = container.querySelectorAll('img');

      // add complete class if all images are loaded/failed
      forEachNodeList(imgs, function (img) {
        var src = img.src;

        if (src.indexOf('data:image') < 0) {
          addEvents(img, imgEvents);
          img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
          img.src = src;
        } else {
          addClass(img, imgCompleteClass);
        }
      });

      raf(function () {
        imageLoaded(arrayFromNodeList(imgs), function () {
          // set imgsComplete to true
          imgsComplete = true;

          if (autoWidth) {
            // check styles application
            var num = loop ? index : slideCount - 1;
            (function checkStylesApplication() {
              slideItems[num - 1].getBoundingClientRect().right.toFixed(2) === slideItems[num].getBoundingClientRect().left.toFixed(2) ? temp() : setTimeout(function () {
                checkStylesApplication();
              }, 16);
            })();
          } else {
            temp();
          }

          function temp() {
            // run Fn()s which are rely on image loading
            if (!horizontal || autoWidth) {
              getSlidePositions();

              if (autoWidth) {
                rightBoundary = getRightBoundary();
                if (freezable) {
                  freeze = getFreeze();
                }
                indexMax = getIndexMax(); // <= slidePositions, rightBoundary <=
                resetVariblesWhenDisable(disable || freeze);
              } else {
                updateContentWrapperHeight();
              }
            }

            // set container transform property
            if (carousel) {
              doContainerTransformSilent();
            }

            // update slider tools and events
            initTools();
            initEvents();
          }
        });
      });
    } else {
      // set container transform property
      if (carousel) {
        doContainerTransformSilent();
      }

      // update slider tools and events
      initTools();
      initEvents();
    }
  }

  function initSheet() {
    // activate visible slides
    // add aria attrs
    // set animation classes and left value for gallery slider
    // use slide count when slides are fewer than items
    for (var i = index, l = index + Math.min(slideCount, items); i < l; i++) {
      var item = slideItems[i];
      setAttrs(item, { 'aria-hidden': 'false' });
      removeAttrs(item, ['tabindex']);
      addClass(item, slideActiveClass);

      if (!carousel) {
        item.style.left = (i - index) * 100 / items + '%';
        addClass(item, animateIn);
        removeClass(item, animateNormal);
      }
    }

    // #### LAYOUT

    // ## INLINE-BLOCK VS FLOAT

    // ## PercentageLayout:
    // slides: inline-block
    // remove blank space between slides by set font-size: 0

    // ## Non PercentageLayout:
    // slides: float
    //         margin-right: -100%
    //         margin-left: ~

    // Resource: https://docs.google.com/spreadsheets/d/147up245wwTXeQYve3BRSAD4oVcvQmuGsFteJOeA5xNQ/edit?usp=sharing
    // if (carousel && horizontal) {
    if (horizontal) {
      if (PERCENTAGELAYOUT || autoWidth) {
        addCSSRule(sheet, '#' + slideId + ' > .tns-item', 'font-size:' + win.getComputedStyle(slideItems[0]).fontSize + ';', getCssRulesLength(sheet));
        addCSSRule(sheet, '#' + slideId, 'font-size:0;', getCssRulesLength(sheet));
      } else {
        forEachNodeList(slideItems, function (slide, i) {
          slide.style.marginLeft = getSlideMarginLeft(i);
        });
      }
    }

    // ## BASIC STYLES
    if (CSSMQ) {
      // inner wrapper styles
      var str = getInnerWrapperStyles(options.edgePadding, options.gutter, options.fixedWidth, options.speed);
      addCSSRule(sheet, '#' + slideId + '-iw', str, getCssRulesLength(sheet));

      // container styles
      if (carousel) {
        str = horizontal && !autoWidth ? 'width:' + getContainerWidth(options.fixedWidth, options.gutter, options.items) + ';' : '';
        if (TRANSITIONDURATION) {
          str += getTrsnsitionDurationStyle(speed);
        }
        addCSSRule(sheet, '#' + slideId, str, getCssRulesLength(sheet));
      }

      // slide styles
      str = horizontal && !autoWidth ? getSlideWidthStyle(options.fixedWidth, options.gutter, options.items) : '';
      if (options.gutter) {
        str += getSlideGutterStyle(options.gutter);
      }
      // set gallery items transition-duration
      if (!carousel) {
        if (TRANSITIONDURATION) {
          str += getTrsnsitionDurationStyle(speed);
        }
        if (ANIMATIONDURATION) {
          str += getAnimationDurationStyle(speed);
        }
      }
      if (str) {
        addCSSRule(sheet, '#' + slideId + ' > .tns-item', str, getCssRulesLength(sheet));
      }

      // non CSS mediaqueries: IE8
      // ## update inner wrapper, container, slides if needed
      // set inline styles for inner wrapper & container
      // insert stylesheet (one line) for slides only (since slides are many)
    } else {
      // inner wrapper styles
      innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth);

      // container styles
      if (carousel && horizontal && !autoWidth) {
        container.style.width = getContainerWidth(fixedWidth, gutter, items);
      }

      // slide styles
      var str = horizontal && !autoWidth ? getSlideWidthStyle(fixedWidth, gutter, items) : '';
      if (gutter) {
        str += getSlideGutterStyle(gutter);
      }

      // append to the last line
      if (str) {
        addCSSRule(sheet, '#' + slideId + ' > .tns-item', str, getCssRulesLength(sheet));
      }
    }

    // ## MEDIAQUERIES
    if (responsive && CSSMQ) {
      for (var bp in responsive) {
        // bp: convert string to number
        bp = parseInt(bp);

        var opts = responsive[bp],
            str = '',
            innerWrapperStr = '',
            containerStr = '',
            slideStr = '',
            itemsBP = !autoWidth ? getOption('items', bp) : null,
            fixedWidthBP = getOption('fixedWidth', bp),
            speedBP = getOption('speed', bp),
            edgePaddingBP = getOption('edgePadding', bp),
            gutterBP = getOption('gutter', bp);

        // inner wrapper string
        if ('edgePadding' in opts || 'gutter' in opts) {
          innerWrapperStr = '#' + slideId + '-iw{' + getInnerWrapperStyles(edgePaddingBP, gutterBP, fixedWidthBP, speedBP) + '}';
        }

        // container string
        if (carousel && horizontal && !autoWidth && ('fixedWidth' in opts || 'items' in opts || fixedWidth && 'gutter' in opts)) {
          containerStr = 'width:' + getContainerWidth(fixedWidthBP, gutterBP, itemsBP) + ';';
        }
        if (TRANSITIONDURATION && 'speed' in opts) {
          containerStr += getTrsnsitionDurationStyle(speedBP);
        }
        if (containerStr) {
          containerStr = '#' + slideId + '{' + containerStr + '}';
        }

        // slide string
        if ('fixedWidth' in opts || fixedWidth && 'gutter' in opts || !carousel && 'items' in opts) {
          slideStr += getSlideWidthStyle(fixedWidthBP, gutterBP, itemsBP);
        }
        if ('gutter' in opts) {
          slideStr += getSlideGutterStyle(gutterBP);
        }
        // set gallery items transition-duration
        if (!carousel && 'speed' in opts) {
          if (TRANSITIONDURATION) {
            slideStr += getTrsnsitionDurationStyle(speedBP);
          }
          if (ANIMATIONDURATION) {
            slideStr += getAnimationDurationStyle(speedBP);
          }
        }
        if (slideStr) {
          slideStr = '#' + slideId + ' > .tns-item{' + slideStr + '}';
        }

        // add up
        str = innerWrapperStr + containerStr + slideStr;

        if (str) {
          sheet.insertRule('@media (min-width: ' + bp / 16 + 'em) {' + str + '}', sheet.cssRules.length);
        }
      }
    }
  }

  function initTools() {
    // == autoplayInit ==
    if (hasAutoplay) {
      var txt = autoplay ? 'stop' : 'start';
      if (autoplayButton) {
        setAttrs(autoplayButton, { 'data-action': txt });
      } else if (options.autoplayButtonOutput) {
        outerWrapper.insertAdjacentHTML('afterbegin', '<button data-action="' + txt + '" type="button">' + autoplayHtmlStrings[0] + txt + autoplayHtmlStrings[1] + autoplayText[0] + '</button>');
        autoplayButton = outerWrapper.querySelector('[data-action]');
      }

      // add event
      if (autoplayButton) {
        addEvents(autoplayButton, { 'click': toggleAutoplay });
      }

      if (autoplay) {
        startAutoplay();
        if (autoplayHoverPause) {
          addEvents(container, hoverEvents);
        }
        if (autoplayResetOnVisibility) {
          addEvents(container, visibilityEvent);
        }
      }
    }

    // == navInit ==
    if (hasNav) {
      var initIndex = !carousel ? 0 : cloneCount;
      // customized nav
      // will not hide the navs in case they're thumbnails
      if (navContainer) {
        setAttrs(navContainer, { 'aria-label': 'Carousel Pagination' });
        navItems = navContainer.children;
        for (var i = 0; i < slideCount; i++) {
          var item = navItems[i];
          if (item) {
            setAttrs(item, {
              'data-nav': i,
              'tabindex': '-1',
              'aria-selected': 'false',
              'aria-controls': slideItems[initIndex + i].id
            });
          }
        }

        // generated nav 
      } else {
        var navHtml = '',
            hiddenStr = navAsThumbnails ? '' : 'style="display:none"';
        for (var i = 0; i < slideCount; i++) {
          // hide nav items by default
          navHtml += '<button data-nav="' + i + '" tabindex="-1" aria-selected="false" aria-controls="' + slideItems[initIndex + i].id + '" ' + hiddenStr + ' type="button"></button>';
        }
        navHtml = '<div class="tns-nav" aria-label="Carousel Pagination">' + navHtml + '</div>';
        outerWrapper.insertAdjacentHTML('afterbegin', navHtml);

        navContainer = outerWrapper.querySelector('.tns-nav');
        navItems = navContainer.children;
      }

      updateNavVisibility();

      // add transition
      if (TRANSITIONDURATION) {
        var prefix = TRANSITIONDURATION.substring(0, TRANSITIONDURATION.length - 18).toLowerCase(),
            str = 'transition: all ' + speed / 1000 + 's';

        if (prefix) {
          str = '-' + prefix + '-' + str;
        }

        addCSSRule(sheet, '[aria-controls^=' + slideId + '-item]', str, getCssRulesLength(sheet));
      }

      setAttrs(navItems[navCurrentIndex], { 'tabindex': '0', 'aria-selected': 'true' });
      addClass(navItems[navCurrentIndex], navActiveClass);

      // add events
      addEvents(navContainer, navEvents);
    }

    // == controlsInit ==
    if (hasControls) {
      if (controlsContainer || prevButton && nextButton) {
        if (controlsContainer) {
          prevButton = controlsContainer.children[0];
          nextButton = controlsContainer.children[1];
          setAttrs(controlsContainer, {
            'aria-label': 'Carousel Navigation',
            'tabindex': '0'
          });
          setAttrs(controlsContainer.children, {
            'aria-controls': slideId,
            'tabindex': '-1'
          });
        }

        setAttrs(prevButton, { 'data-controls': 'prev' });
        setAttrs(nextButton, { 'data-controls': 'next' });
      } else {
        outerWrapper.insertAdjacentHTML('afterbegin', '<div class="tns-controls" aria-label="Carousel Navigation" tabindex="0"><button data-controls="prev" tabindex="-1" aria-controls="' + slideId + '" type="button">' + controlsText[0] + '</button><button data-controls="next" tabindex="-1" aria-controls="' + slideId + '" type="button">' + controlsText[1] + '</button></div>');

        controlsContainer = outerWrapper.querySelector('.tns-controls');
        prevButton = controlsContainer.children[0];
        nextButton = controlsContainer.children[1];
      }

      prevIsButton = isButton(prevButton);
      nextIsButton = isButton(nextButton);

      updateControlsStatus();

      // add events
      if (controlsContainer) {
        addEvents(controlsContainer, controlsEvents);
      } else {
        addEvents(prevButton, controlsEvents);
        addEvents(nextButton, controlsEvents);
      }
    }

    // hide tools if needed
    disableUI();
  }

  function initEvents() {
    // add events
    if (carousel && TRANSITIONEND) {
      var eve = {};
      eve[TRANSITIONEND] = onTransitionEnd;
      addEvents(container, eve);
    }

    if (touch) {
      addEvents(container, touchEvents);
    }
    if (mouseDrag) {
      addEvents(container, dragEvents);
    }
    if (arrowKeys) {
      addEvents(doc, docmentKeydownEvent);
    }

    if (nested === 'inner') {
      events.on('outerResized', function () {
        resizeTasks();
        events.emit('innerLoaded', info());
      });
    } else if (responsive || fixedWidth || autoWidth || autoHeight || !horizontal) {
      addEvents(win, { 'resize': onResize });
    }

    if (nested === 'outer') {
      events.on('innerLoaded', runAutoHeight);
    } else if (autoHeight && !disable) {
      runAutoHeight();
    }

    lazyLoad();
    if (disable) {
      disableSlider();
    } else if (freeze) {
      freezeSlider();
    }

    events.on('indexChanged', additionalUpdates);
    if (typeof onInit === 'function') {
      onInit(info());
    }
    if (nested === 'inner') {
      events.emit('innerLoaded', info());
    }
  }

  function destroy() {
    // sheet
    sheet.disabled = true;
    if (sheet.ownerNode) {
      sheet.ownerNode.remove();
    }

    // remove win event listeners
    removeEvents(win, { 'resize': onResize });

    // arrowKeys, controls, nav
    if (arrowKeys) {
      removeEvents(doc, docmentKeydownEvent);
    }
    if (controlsContainer) {
      removeEvents(controlsContainer, controlsEvents);
    }
    if (navContainer) {
      removeEvents(navContainer, navEvents);
    }

    // autoplay
    removeEvents(container, hoverEvents);
    removeEvents(container, visibilityEvent);
    if (autoplayButton) {
      removeEvents(autoplayButton, { 'click': toggleAutoplay });
    }
    if (autoplay) {
      clearInterval(autoplayTimer);
    }

    // container
    if (carousel && TRANSITIONEND) {
      var eve = {};
      eve[TRANSITIONEND] = onTransitionEnd;
      removeEvents(container, eve);
    }
    if (touch) {
      removeEvents(container, touchEvents);
    }
    if (mouseDrag) {
      removeEvents(container, dragEvents);
    }

    // cache Object values in options && reset HTML
    var htmlList = [containerHTML, controlsContainerHTML, prevButtonHTML, nextButtonHTML, navContainerHTML, autoplayButtonHTML];

    tnsList.forEach(function (item, i) {
      var el = item === 'container' ? outerWrapper : options[item];

      if (typeof el === 'object') {
        var prevEl = el.previousElementSibling ? el.previousElementSibling : false,
            parentEl = el.parentNode;
        el.outerHTML = htmlList[i];
        options[item] = prevEl ? prevEl.nextElementSibling : parentEl.firstElementChild;
      }
    });

    // reset variables
    tnsList = animateIn = animateOut = animateDelay = animateNormal = horizontal = outerWrapper = innerWrapper = container = containerParent = containerHTML = slideItems = slideCount = breakpointZone = windowWidth = autoWidth = fixedWidth = edgePadding = gutter = viewport = items = slideBy = viewportMax = arrowKeys = speed = rewind = loop = autoHeight = sheet = lazyload = slidePositions = slideItemsOut = cloneCount = slideCountNew = hasRightDeadZone = rightBoundary = updateIndexBeforeTransform = transformAttr = transformPrefix = transformPostfix = getIndexMax = index = indexCached = indexMin = indexMax = resizeTimer = swipeAngle = moveDirectionExpected = running = onInit = events = newContainerClasses = slideId = disable = disabled = freezable = freeze = frozen = controlsEvents = navEvents = hoverEvents = visibilityEvent = docmentKeydownEvent = touchEvents = dragEvents = hasControls = hasNav = navAsThumbnails = hasAutoplay = hasTouch = hasMouseDrag = slideActiveClass = imgCompleteClass = imgEvents = imgsComplete = controls = controlsText = controlsContainer = controlsContainerHTML = prevButton = nextButton = prevIsButton = nextIsButton = nav = navContainer = navContainerHTML = navItems = visibleNavIndexes = visibleNavIndexesCached = navClicked = navCurrentIndex = navCurrentIndexCached = navActiveClass = autoplay = autoplayTimeout = autoplayDirection = autoplayText = autoplayHoverPause = autoplayButton = autoplayButtonHTML = autoplayResetOnVisibility = autoplayHtmlStrings = autoplayTimer = animating = autoplayHoverPaused = autoplayUserPaused = autoplayVisibilityPaused = initPosition = lastPosition = translateInit = disX = disY = panStart = rafIndex = getDist = touch = mouseDrag = null;
    // check variables
    // [animateIn, animateOut, animateDelay, animateNormal, horizontal, outerWrapper, innerWrapper, container, containerParent, containerHTML, slideItems, slideCount, breakpointZone, windowWidth, autoWidth, fixedWidth, edgePadding, gutter, viewport, items, slideBy, viewportMax, arrowKeys, speed, rewind, loop, autoHeight, sheet, lazyload, slidePositions, slideItemsOut, cloneCount, slideCountNew, hasRightDeadZone, rightBoundary, updateIndexBeforeTransform, transformAttr, transformPrefix, transformPostfix, getIndexMax, index, indexCached, indexMin, indexMax, resizeTimer, swipeAngle, moveDirectionExpected, running, onInit, events, newContainerClasses, slideId, disable, disabled, freezable, freeze, frozen, controlsEvents, navEvents, hoverEvents, visibilityEvent, docmentKeydownEvent, touchEvents, dragEvents, hasControls, hasNav, navAsThumbnails, hasAutoplay, hasTouch, hasMouseDrag, slideActiveClass, imgCompleteClass, imgEvents, imgsComplete, controls, controlsText, controlsContainer, controlsContainerHTML, prevButton, nextButton, prevIsButton, nextIsButton, nav, navContainer, navContainerHTML, navItems, visibleNavIndexes, visibleNavIndexesCached, navClicked, navCurrentIndex, navCurrentIndexCached, navActiveClass, autoplay, autoplayTimeout, autoplayDirection, autoplayText, autoplayHoverPause, autoplayButton, autoplayButtonHTML, autoplayResetOnVisibility, autoplayHtmlStrings, autoplayTimer, animating, autoplayHoverPaused, autoplayUserPaused, autoplayVisibilityPaused, initPosition, lastPosition, translateInit, disX, disY, panStart, rafIndex, getDist, touch, mouseDrag ].forEach(function(item) { if (item !== null) { console.log(item); } });

    for (var a in this) {
      if (a !== 'rebuild') {
        this[a] = null;
      }
    }
    isOn = false;
  }

  // === ON RESIZE ===
  // responsive || fixedWidth || autoWidth || !horizontal
  function onResize(e) {
    raf(function () {
      resizeTasks(getEvent(e));
    });
  }

  function resizeTasks(e) {
    if (!isOn) {
      return;
    }
    if (nested === 'outer') {
      events.emit('outerResized', info(e));
    }
    windowWidth = getWindowWidth();
    var bpChanged,
        breakpointZoneTem = breakpointZone,
        needContainerTransform = false;

    if (responsive) {
      setBreakpointZone();
      bpChanged = breakpointZoneTem !== breakpointZone;
      // if (hasRightDeadZone) { needContainerTransform = true; } // *?
      if (bpChanged) {
        events.emit('newBreakpointStart', info(e));
      }
    }

    var indChanged,
        itemsChanged,
        itemsTem = items,
        disableTem = disable,
        freezeTem = freeze,
        arrowKeysTem = arrowKeys,
        controlsTem = controls,
        navTem = nav,
        touchTem = touch,
        mouseDragTem = mouseDrag,
        autoplayTem = autoplay,
        autoplayHoverPauseTem = autoplayHoverPause,
        autoplayResetOnVisibilityTem = autoplayResetOnVisibility,
        indexTem = index;

    if (bpChanged) {
      var fixedWidthTem = fixedWidth,
          autoHeightTem = autoHeight,
          controlsTextTem = controlsText,
          autoplayTextTem = autoplayText;

      if (!CSSMQ) {
        var gutterTem = gutter,
            edgePaddingTem = edgePadding;
      }
    }

    // get option:
    // fixed width: viewport, fixedWidth, gutter => items
    // others: window width => all variables
    // all: items => slideBy
    arrowKeys = getOption('arrowKeys');
    controls = getOption('controls');
    nav = getOption('nav');
    touch = getOption('touch');
    mouseDrag = getOption('mouseDrag');
    autoplay = getOption('autoplay');
    autoplayHoverPause = getOption('autoplayHoverPause');
    autoplayResetOnVisibility = getOption('autoplayResetOnVisibility');

    if (bpChanged) {
      disable = getOption('disable');
      fixedWidth = getOption('fixedWidth');
      speed = getOption('speed');
      autoHeight = getOption('autoHeight');
      controlsText = getOption('controlsText');
      autoplayText = getOption('autoplayText');
      autoplayTimeout = getOption('autoplayTimeout');

      if (!CSSMQ) {
        edgePadding = getOption('edgePadding');
        gutter = getOption('gutter');
      }
    }
    // update options
    resetVariblesWhenDisable(disable);

    viewport = getViewportWidth(); // <= edgePadding, gutter
    if ((!horizontal || autoWidth) && !disable) {
      getSlidePositions();
      if (!horizontal) {
        updateContentWrapperHeight(); // <= getSlidePositions
        needContainerTransform = true;
      }
    }
    if (fixedWidth || autoWidth) {
      rightBoundary = getRightBoundary(); // autoWidth: <= viewport, slidePositions, gutter
      // fixedWidth: <= viewport, fixedWidth, gutter
      indexMax = getIndexMax(); // autoWidth: <= rightBoundary, slidePositions
      // fixedWidth: <= rightBoundary, fixedWidth, gutter
    }

    if (bpChanged || fixedWidth) {
      items = getOption('items');
      slideBy = getOption('slideBy');
      itemsChanged = items !== itemsTem;

      if (itemsChanged) {
        if (!fixedWidth && !autoWidth) {
          indexMax = getIndexMax();
        } // <= items
        // check index before transform in case
        // slider reach the right edge then items become bigger
        updateIndex();
      }
    }

    if (bpChanged) {
      if (disable !== disableTem) {
        if (disable) {
          disableSlider();
        } else {
          enableSlider(); // <= slidePositions, rightBoundary, indexMax
        }
      }
    }

    if (freezable && (bpChanged || fixedWidth || autoWidth)) {
      freeze = getFreeze(); // <= autoWidth: slidePositions, gutter, viewport, rightBoundary
      // <= fixedWidth: fixedWidth, gutter, rightBoundary
      // <= others: items

      if (freeze !== freezeTem) {
        if (freeze) {
          doContainerTransform(getContainerTransformValue(getStartIndex(0)));
          freezeSlider();
        } else {
          unfreezeSlider();
          needContainerTransform = true;
        }
      }
    }

    resetVariblesWhenDisable(disable || freeze); // controls, nav, touch, mouseDrag, arrowKeys, autoplay, autoplayHoverPause, autoplayResetOnVisibility
    if (!autoplay) {
      autoplayHoverPause = autoplayResetOnVisibility = false;
    }

    if (arrowKeys !== arrowKeysTem) {
      arrowKeys ? addEvents(doc, docmentKeydownEvent) : removeEvents(doc, docmentKeydownEvent);
    }
    if (controls !== controlsTem) {
      if (controls) {
        if (controlsContainer) {
          showElement(controlsContainer);
        } else {
          if (prevButton) {
            showElement(prevButton);
          }
          if (nextButton) {
            showElement(nextButton);
          }
        }
      } else {
        if (controlsContainer) {
          hideElement(controlsContainer);
        } else {
          if (prevButton) {
            hideElement(prevButton);
          }
          if (nextButton) {
            hideElement(nextButton);
          }
        }
      }
    }
    if (nav !== navTem) {
      if (nav) {
        showElement(navContainer);
        updateNavVisibility();
      } else {
        hideElement(navContainer);
      }
    }
    if (touch !== touchTem) {
      touch ? addEvents(container, touchEvents) : removeEvents(container, touchEvents);
    }
    if (mouseDrag !== mouseDragTem) {
      mouseDrag ? addEvents(container, dragEvents) : removeEvents(container, dragEvents);
    }
    if (autoplay !== autoplayTem) {
      if (autoplay) {
        if (autoplayButton) {
          showElement(autoplayButton);
        }
        if (!animating && !autoplayUserPaused) {
          startAutoplay();
        }
      } else {
        if (autoplayButton) {
          hideElement(autoplayButton);
        }
        if (animating) {
          stopAutoplay();
        }
      }
    }
    if (autoplayHoverPause !== autoplayHoverPauseTem) {
      autoplayHoverPause ? addEvents(container, hoverEvents) : removeEvents(container, hoverEvents);
    }
    if (autoplayResetOnVisibility !== autoplayResetOnVisibilityTem) {
      autoplayResetOnVisibility ? addEvents(doc, visibilityEvent) : removeEvents(doc, visibilityEvent);
    }

    if (bpChanged) {
      if (fixedWidth !== fixedWidthTem) {
        needContainerTransform = true;
      }

      if (autoHeight !== autoHeightTem) {
        if (!autoHeight) {
          innerWrapper.style.height = '';
        }
      }

      if (controls && controlsText !== controlsTextTem) {
        prevButton.innerHTML = controlsText[0];
        nextButton.innerHTML = controlsText[1];
      }

      if (autoplayButton && autoplayText !== autoplayTextTem) {
        var i = autoplay ? 1 : 0,
            html = autoplayButton.innerHTML,
            len = html.length - autoplayTextTem[i].length;
        if (html.substring(len) === autoplayTextTem[i]) {
          autoplayButton.innerHTML = html.substring(0, len) + autoplayText[i];
        }
      }
    }

    indChanged = index !== indexTem;
    if (indChanged) {
      events.emit('indexChanged', info());
      needContainerTransform = true;
    }

    if (itemsChanged) {
      if (!indChanged) {
        additionalUpdates();
      }
      if (!carousel) {
        updateGallerySlidePositions();
      }
    }

    if (!disable && !freeze) {
      // non-meduaqueries: IE8
      if (bpChanged && !CSSMQ) {
        // inner wrapper styles
        if (edgePadding !== edgePaddingTem || gutter !== gutterTem) {
          innerWrapper.style.cssText = getInnerWrapperStyles(edgePadding, gutter, fixedWidth);
        }

        if (horizontal) {
          // container styles
          if (carousel) {
            container.style.width = getContainerWidth(fixedWidth, gutter, items);
          }

          // slide styles
          var str = getSlideWidthStyle(fixedWidth, gutter, items) + getSlideGutterStyle(gutter);

          // remove the last line and
          // add new styles
          removeCSSRule(sheet, getCssRulesLength(sheet) - 1);
          addCSSRule(sheet, '#' + slideId + ' > .tns-item', str, getCssRulesLength(sheet));
        }
      }

      // auto height
      if (autoHeight) {
        runAutoHeight();
      }

      if (needContainerTransform) {
        doContainerTransformSilent();
        indexCached = index;
      }
    }

    if (bpChanged) {
      events.emit('newBreakpointEnd', info(e));
    }
  }

  // === INITIALIZATION FUNCTIONS === //
  function getFreeze() {
    if (!fixedWidth && !autoWidth) {
      return slideCount <= items;
    }

    if (fixedWidth) {
      return (fixedWidth + gutter) * slideCount <= viewport + edgePadding * 2;
    } else {
      var width = loop ? slidePositions[slideCount] : getSliderWidth();
      return width <= viewport + edgePadding * 2;
    }
  }

  function setBreakpointZone() {
    breakpointZone = 0;
    for (var bp in responsive) {
      bp = parseInt(bp); // convert string to number
      if (windowWidth >= bp) {
        breakpointZone = bp;
      }
    }
  }

  // (slideBy, indexMin, indexMax) => index
  var updateIndex = function () {
    return loop ? carousel ?
    // loop + carousel
    function () {
      var leftEdge = indexMin,
          rightEdge = indexMax;

      leftEdge += slideBy;
      rightEdge -= slideBy;

      // adjust edges when has edge padding
      // or fixed-width slider with extra space on the right side
      if (edgePadding) {
        leftEdge += 1;
        rightEdge -= 1;
      } else if (fixedWidth) {
        if (viewport % (fixedWidth + gutter)) {
          rightEdge -= 1;
        }
      }

      if (cloneCount) {
        if (index > rightEdge) {
          index -= slideCount;
        } else if (index < leftEdge) {
          index += slideCount;
        }
      }
    } :
    // loop + gallery
    function () {
      if (index > indexMax) {
        while (index >= indexMin + slideCount) {
          index -= slideCount;
        }
      } else if (index < indexMin) {
        while (index <= indexMax - slideCount) {
          index += slideCount;
        }
      }
    } :
    // non-loop
    function () {
      index = Math.max(indexMin, Math.min(indexMax, index));
    };
  }();

  function disableUI() {
    if (!autoplay && autoplayButton) {
      hideElement(autoplayButton);
    }
    if (!nav && navContainer) {
      hideElement(navContainer);
    }
    if (!controls) {
      if (controlsContainer) {
        hideElement(controlsContainer);
      } else {
        if (prevButton) {
          hideElement(prevButton);
        }
        if (nextButton) {
          hideElement(nextButton);
        }
      }
    }
  }

  function enableUI() {
    if (autoplay && autoplayButton) {
      showElement(autoplayButton);
    }
    if (nav && navContainer) {
      showElement(navContainer);
    }
    if (controls) {
      if (controlsContainer) {
        showElement(controlsContainer);
      } else {
        if (prevButton) {
          showElement(prevButton);
        }
        if (nextButton) {
          showElement(nextButton);
        }
      }
    }
  }

  function freezeSlider() {
    if (frozen) {
      return;
    }

    // remove edge padding from inner wrapper
    if (edgePadding) {
      innerWrapper.style.margin = '0px';
    }

    // add class tns-transparent to cloned slides
    if (cloneCount) {
      var str = 'tns-transparent';
      for (var i = cloneCount; i--;) {
        if (carousel) {
          addClass(slideItems[i], str);
        }
        addClass(slideItems[slideCountNew - i - 1], str);
      }
    }

    // update tools
    disableUI();

    frozen = true;
  }

  function unfreezeSlider() {
    if (!frozen) {
      return;
    }

    // restore edge padding for inner wrapper
    // for mordern browsers
    if (edgePadding && CSSMQ) {
      innerWrapper.style.margin = '';
    }

    // remove class tns-transparent to cloned slides
    if (cloneCount) {
      var str = 'tns-transparent';
      for (var i = cloneCount; i--;) {
        if (carousel) {
          removeClass(slideItems[i], str);
        }
        removeClass(slideItems[slideCountNew - i - 1], str);
      }
    }

    // update tools
    enableUI();

    frozen = false;
  }

  function disableSlider() {
    if (disabled) {
      return;
    }

    sheet.disabled = true;
    container.className = container.className.replace(newContainerClasses.substring(1), '');
    removeAttrs(container, ['style']);
    if (loop) {
      for (var j = cloneCount; j--;) {
        if (carousel) {
          hideElement(slideItems[j]);
        }
        hideElement(slideItems[slideCountNew - j - 1]);
      }
    }

    // vertical slider
    if (!horizontal || !carousel) {
      removeAttrs(innerWrapper, ['style']);
    }

    // gallery
    if (!carousel) {
      for (var i = index, l = index + slideCount; i < l; i++) {
        var item = slideItems[i];
        removeAttrs(item, ['style']);
        removeClass(item, animateIn);
        removeClass(item, animateNormal);
      }
    }

    // update tools
    disableUI();

    disabled = true;
  }

  function enableSlider() {
    if (!disabled) {
      return;
    }

    sheet.disabled = false;
    container.className += newContainerClasses;
    doContainerTransformSilent();

    if (loop) {
      for (var j = cloneCount; j--;) {
        if (carousel) {
          showElement(slideItems[j]);
        }
        showElement(slideItems[slideCountNew - j - 1]);
      }
    }

    // gallery
    if (!carousel) {
      for (var i = index, l = index + slideCount; i < l; i++) {
        var item = slideItems[i],
            classN = i < index + items ? animateIn : animateNormal;
        item.style.left = (i - index) * 100 / items + '%';
        addClass(item, classN);
      }
    }

    // update tools
    enableUI();

    disabled = false;
  }

  function lazyLoad() {
    if (lazyload && !disable) {
      var i = index,
          len;

      if (!autoWidth) {
        len = index + items;
      } else {
        var a = index + 1,
            len = a,
            edge = slidePositions[index] + viewport + edgePadding - gutter;
        while (slidePositions[a] < edge) {
          a++;
          len = a;
        }
      }

      if (edgePadding) {
        i -= 1;
        if (!autoWidth) {
          len += 1;
        }
      }

      i = Math.floor(Math.max(i, 0));
      len = Math.ceil(Math.min(len, slideCountNew));

      for (; i < len; i++) {
        forEachNodeList(slideItems[i].querySelectorAll('.tns-lazy-img'), function (img) {
          // stop propagationl transitionend event to container
          var eve = {};
          eve[TRANSITIONEND] = function (e) {
            e.stopPropagation();
          };
          addEvents(img, eve);

          if (!hasClass(img, 'loaded')) {
            img.src = getAttr(img, 'data-src');
            addClass(img, 'loaded');
          }
        });
      }
    }
  }

  function imgLoadedOrError(e) {
    var img = getTarget(e);
    addClass(img, imgCompleteClass);
    removeEvents(img, imgEvents);
  }

  function getImageArray(slideStart, slideRange) {
    var imgs = [];
    for (var i = slideStart, l = Math.min(slideStart + slideRange, slideCountNew); i < l; i++) {
      forEachNodeList(slideItems[i].querySelectorAll('img'), function (img) {
        imgs.push(img);
      });
    }

    return imgs;
  }

  // check if all visible images are loaded
  // and update container height if it's done
  function runAutoHeight() {
    var imgs = autoHeight ? getImageArray(index, items) : getImageArray(cloneCount, slideCount);

    raf(function () {
      imageLoaded(imgs, updateInnerWrapperHeight);
    });
  }

  function imageLoaded(imgs, cb) {
    // directly execute callback function if all images are complete
    if (imgsComplete) {
      return cb();
    }

    // check selected image classes otherwise
    imgs.forEach(function (img, index) {
      if (hasClass(img, imgCompleteClass)) {
        imgs.splice(index, 1);
      }
    });

    // execute callback function if selected images are all complete
    if (!imgs.length) {
      return cb();
    }

    // otherwise execute this functiona again
    raf(function () {
      imageLoaded(imgs, cb);
    });
  }

  function additionalUpdates() {
    lazyLoad();
    updateSlideStatus();
    updateControlsStatus();
    updateNavVisibility();
    updateNavStatus();
  }

  function getMaxSlideHeight(slideStart, slideRange) {
    var heights = [];
    for (var i = slideStart, l = Math.min(slideStart + slideRange, slideCountNew); i < l; i++) {
      heights.push(slideItems[i].offsetHeight);
    }

    return Math.max.apply(null, heights);
  }

  // update inner wrapper height
  // 1. get the max-height of the visible slides
  // 2. set transitionDuration to speed
  // 3. update inner wrapper height to max-height
  // 4. set transitionDuration to 0s after transition done
  function updateInnerWrapperHeight() {
    var maxHeight = autoHeight ? getMaxSlideHeight(index, items) : getMaxSlideHeight(cloneCount, slideCount);

    if (innerWrapper.style.height !== maxHeight) {
      innerWrapper.style.height = maxHeight + 'px';
    }
  }

  // get the distance from the top edge of the first slide to each slide
  // (init) => slidePositions
  function getSlidePositions() {
    slidePositions = [0];
    var attr = horizontal ? 'left' : 'top',
        first = slideItems[0].getBoundingClientRect()[attr],
        position;
    for (var i = 1; i < slideCountNew; i++) {
      position = slideItems[i].getBoundingClientRect()[attr];
      slidePositions.push(position - first);
    }
  }

  // update slide
  function updateSlideStatus() {
    var l = index + Math.min(slideCount, items);
    for (var i = slideCountNew; i--;) {
      var item = slideItems[i];

      // visible slides
      if (i >= index && i < l) {
        if (hasAttr(item, 'tabindex')) {
          setAttrs(item, { 'aria-hidden': 'false' });
          removeAttrs(item, ['tabindex']);
          addClass(item, slideActiveClass);
        }
        // hidden slides
      } else {
        if (!hasAttr(item, 'tabindex')) {
          setAttrs(item, {
            'aria-hidden': 'true',
            'tabindex': '-1'
          });
        }
        if (hasClass(item, slideActiveClass)) {
          removeClass(item, slideActiveClass);
        }
      }
    }
  }

  // gallery: update slide position
  function updateGallerySlidePositions() {
    var l = index + Math.min(slideCount, items);
    for (var i = slideCountNew; i--;) {
      var item = slideItems[i];

      if (i >= index && i < l) {
        // add transitions to visible slides when adjusting their positions
        addClass(item, 'tns-moving');

        item.style.left = (i - index) * 100 / items + '%';
        addClass(item, animateIn);
        removeClass(item, animateNormal);
      } else if (item.style.left) {
        item.style.left = '';
        addClass(item, animateNormal);
        removeClass(item, animateIn);
      }

      // remove outlet animation
      removeClass(item, animateOut);
    }

    // removing '.tns-moving'
    setTimeout(function () {
      forEachNodeList(slideItems, function (el) {
        removeClass(el, 'tns-moving');
      });
    }, 300);
  }

  // set tabindex & aria-selected on Nav
  function updateNavStatus() {
    // get current nav
    if (nav) {
      navCurrentIndex = navClicked !== -1 ? navClicked : getAbsIndex();
      navClicked = -1;

      if (navCurrentIndex !== navCurrentIndexCached) {
        var navPrev = navItems[navCurrentIndexCached],
            navCurrent = navItems[navCurrentIndex];

        setAttrs(navPrev, {
          'tabindex': '-1',
          'aria-selected': 'false'
        });
        setAttrs(navCurrent, {
          'tabindex': '0',
          'aria-selected': 'true'
        });
        removeClass(navPrev, navActiveClass);
        addClass(navCurrent, navActiveClass);

        navCurrentIndexCached = navCurrentIndex;
      }
    }
  }

  function getLowerCaseNodeName(el) {
    return el.nodeName.toLowerCase();
  }

  function isButton(el) {
    return getLowerCaseNodeName(el) === 'button';
  }

  function isAriaDisabled(el) {
    return el.getAttribute('aria-disabled') === 'true';
  }

  function disEnableElement(isButton, el, val) {
    if (isButton) {
      el.disabled = val;
    } else {
      el.setAttribute('aria-disabled', val.toString());
    }
  }

  // set 'disabled' to true on controls when reach the edges
  function updateControlsStatus() {
    if (!controls || rewind || loop) {
      return;
    }

    var prevDisabled = prevIsButton ? prevButton.disabled : isAriaDisabled(prevButton),
        nextDisabled = nextIsButton ? nextButton.disabled : isAriaDisabled(nextButton),
        disablePrev = index <= indexMin ? true : false,
        disableNext = !rewind && index >= indexMax ? true : false;

    if (disablePrev && !prevDisabled) {
      disEnableElement(prevIsButton, prevButton, true);
    }
    if (!disablePrev && prevDisabled) {
      disEnableElement(prevIsButton, prevButton, false);
    }
    if (disableNext && !nextDisabled) {
      disEnableElement(nextIsButton, nextButton, true);
    }
    if (!disableNext && nextDisabled) {
      disEnableElement(nextIsButton, nextButton, false);
    }
  }

  // set duration
  function resetDuration(el, str) {
    if (TRANSITIONDURATION) {
      el.style[TRANSITIONDURATION] = str;
    }
  }

  function getSliderWidth() {
    return fixedWidth ? (fixedWidth + gutter) * slideCountNew : slidePositions[slideCountNew - 1] + slideItems[slideCountNew - 1].getBoundingClientRect().width;
  }

  function getRightBoundary() {
    var result = viewport - (getSliderWidth() - gutter);
    if (edgePadding) {
      result += edgePadding - gutter;
    }
    if (result > 0) {
      result = 0;
    }
    return result;
  }

  function getContainerTransformValue(num) {
    if (num == null) {
      num = index;
    }

    var val;
    if (horizontal && !autoWidth) {
      if (fixedWidth) {
        val = -(fixedWidth + gutter) * num;
      } else {
        var denominator = TRANSFORM ? slideCountNew : items;
        val = -num * 100 / denominator;
      }
    } else {
      val = -slidePositions[num];
    }

    if (hasRightDeadZone) {
      val = Math.max(val, rightBoundary);
    }
    // // remove edge padding for non-loop
    // if (horizontal && !loop && edgePadding) {
    //   var gap = edgePadding;

    //   if (!autoWidth && !fixedWidth) {
    //     gap = TRANSFORM ? gap * 100 / (viewport * slideCountNew / items) : gap / viewport;
    //   }

    //   if (num <= 0) {
    //     val -= gap;
    //   } else if (num >= indexMax && !autoWidth && !fixedWidth) {
    //     val += gap;
    //   }
    // }

    val += horizontal && !autoWidth && !fixedWidth ? '%' : 'px';

    return val;
  }

  function doContainerTransformSilent(val) {
    resetDuration(container, '0s');
    doContainerTransform(val);
  }

  function doContainerTransform(val) {
    if (val == null) {
      val = getContainerTransformValue();
    }
    container.style[transformAttr] = transformPrefix + val + transformPostfix;
  }

  function animateSlide(number, classOut, classIn, isOut) {
    var l = number + items;
    if (!loop) {
      l = Math.min(l, slideCountNew);
    }

    for (var i = number; i < l; i++) {
      var item = slideItems[i];

      // set item positions
      if (!isOut) {
        item.style.left = (i - index) * 100 / items + '%';
      }

      if (animateDelay && TRANSITIONDELAY) {
        item.style[TRANSITIONDELAY] = item.style[ANIMATIONDELAY] = animateDelay * (i - number) / 1000 + 's';
      }
      removeClass(item, classOut);
      addClass(item, classIn);

      if (isOut) {
        slideItemsOut.push(item);
      }
    }
  }

  // make transfer after click/drag:
  // 1. change 'transform' property for mordern browsers
  // 2. change 'left' property for legacy browsers
  var transformCore = function () {
    return carousel ? function () {
      resetDuration(container, '');
      if (TRANSITIONDURATION || !speed) {
        // for morden browsers with non-zero duration or 
        // zero duration for all browsers
        doContainerTransform();
        // run fallback function manually 
        // when duration is 0 / container is hidden
        if (!speed || !isVisible(container)) {
          onTransitionEnd();
        }
      } else {
        // for old browser with non-zero duration
        jsTransform(container, transformAttr, transformPrefix, transformPostfix, getContainerTransformValue(), speed, onTransitionEnd);
      }

      if (!horizontal) {
        updateContentWrapperHeight();
      }
    } : function () {
      slideItemsOut = [];

      var eve = {};
      eve[TRANSITIONEND] = eve[ANIMATIONEND] = onTransitionEnd;
      removeEvents(slideItems[indexCached], eve);
      addEvents(slideItems[index], eve);

      animateSlide(indexCached, animateIn, animateOut, true);
      animateSlide(index, animateNormal, animateIn);

      // run fallback function manually 
      // when transition or animation not supported / duration is 0
      if (!TRANSITIONEND || !ANIMATIONEND || !speed || !isVisible(container)) {
        onTransitionEnd();
      }
    };
  }();

  function render(e, sliderMoved) {
    if (updateIndexBeforeTransform) {
      updateIndex();
    }

    // render when slider was moved (touch or drag) even though index may not change
    if (index !== indexCached || sliderMoved) {
      // events
      events.emit('indexChanged', info());
      events.emit('transitionStart', info());
      if (autoHeight) {
        runAutoHeight();
      }

      // pause autoplay when click or keydown from user
      if (animating && e && ['click', 'keydown'].indexOf(e.type) >= 0) {
        stopAutoplay();
      }

      running = true;
      transformCore();
    }
  }

  /*
   * Transfer prefixed properties to the same format
   * CSS: -Webkit-Transform => webkittransform
   * JS: WebkitTransform => webkittransform
   * @param {string} str - property
   *
   */
  function strTrans(str) {
    return str.toLowerCase().replace(/-/g, '');
  }

  // AFTER TRANSFORM
  // Things need to be done after a transfer:
  // 1. check index
  // 2. add classes to visible slide
  // 3. disable controls buttons when reach the first/last slide in non-loop slider
  // 4. update nav status
  // 5. lazyload images
  // 6. update container height
  function onTransitionEnd(event) {
    // check running on gallery mode
    // make sure trantionend/animationend events run only once
    if (carousel || running) {
      events.emit('transitionEnd', info(event));

      if (!carousel && slideItemsOut.length > 0) {
        for (var i = 0; i < slideItemsOut.length; i++) {
          var item = slideItemsOut[i];
          // set item positions
          item.style.left = '';

          if (ANIMATIONDELAY && TRANSITIONDELAY) {
            item.style[ANIMATIONDELAY] = '';
            item.style[TRANSITIONDELAY] = '';
          }
          removeClass(item, animateOut);
          addClass(item, animateNormal);
        }
      }

      /* update slides, nav, controls after checking ...
       * => legacy browsers who don't support 'event' 
       *    have to check event first, otherwise event.target will cause an error 
       * => or 'gallery' mode: 
       *   + event target is slide item
       * => or 'carousel' mode: 
       *   + event target is container, 
       *   + event.property is the same with transform attribute
       */
      if (!event || !carousel && event.target.parentNode === container || event.target === container && strTrans(event.propertyName) === strTrans(transformAttr)) {

        if (!updateIndexBeforeTransform) {
          var indexTem = index;
          updateIndex();
          if (index !== indexTem) {
            events.emit('indexChanged', info());

            doContainerTransformSilent();
          }
        }

        if (nested === 'inner') {
          events.emit('innerLoaded', info());
        }
        running = false;
        indexCached = index;
      }
    }
  }

  // # ACTIONS
  function goTo(targetIndex, e) {
    if (freeze) {
      return;
    }

    // prev slideBy
    if (targetIndex === 'prev') {
      onControlsClick(e, -1);

      // next slideBy
    } else if (targetIndex === 'next') {
      onControlsClick(e, 1);

      // go to exact slide
    } else {
      if (running) {
        onTransitionEnd();
      }

      var absIndex = getAbsIndex(),
          indexGap = 0;

      if (targetIndex === 'first') {
        indexGap = -absIndex;
      } else if (targetIndex === 'last') {
        indexGap = carousel ? slideCount - items - absIndex : slideCount - 1 - absIndex;
      } else {
        if (typeof targetIndex !== 'number') {
          targetIndex = parseInt(targetIndex);
        }

        if (!isNaN(targetIndex)) {
          // from directly called goTo function
          if (!e) {
            targetIndex = Math.max(0, Math.min(slideCount - 1, targetIndex));
          }

          indexGap = targetIndex - absIndex;
        }
      }

      // gallery: make sure new page won't overlap with current page
      if (!carousel && indexGap && Math.abs(indexGap) < items) {
        var factor = indexGap > 0 ? 1 : -1;
        indexGap += index + indexGap - slideCount >= indexMin ? slideCount * factor : slideCount * 2 * factor * -1;
      }

      index += indexGap;

      // make sure index is in range
      if (carousel && loop) {
        if (index < indexMin) {
          index += slideCount;
        }
        if (index > indexMax) {
          index -= slideCount;
        }
      }

      // if index is changed, start rendering
      if (getAbsIndex(index) !== getAbsIndex(indexCached)) {
        render(e);
      }
    }
  }

  // on controls click
  function onControlsClick(e, dir) {
    if (running) {
      onTransitionEnd();
    }

    var passEventObject;

    if (!dir) {
      e = getEvent(e);
      var target = e.target || e.srcElement;

      while (target !== controlsContainer && [prevButton, nextButton].indexOf(target) < 0) {
        target = target.parentNode;
      }

      var targetIn = [prevButton, nextButton].indexOf(target);
      if (targetIn >= 0) {
        passEventObject = true;
        dir = targetIn === 0 ? -1 : 1;
      }
    }

    if (rewind) {
      if (index === indexMin && dir === -1) {
        goTo('last', e);
        return;
      } else if (index === indexMax && dir === 1) {
        goTo('first', e);
        return;
      }
    }

    if (dir) {
      index += slideBy * dir;
      if (autoWidth) {
        index = Math.floor(index);
      }
      // pass e when click control buttons or keydown
      render(passEventObject || e && e.type === 'keydown' ? e : null);
    }
  }

  // on nav click
  function onNavClick(e) {
    if (running) {
      onTransitionEnd();
    }

    e = getEvent(e);
    var target = e.target || e.srcElement,
        navIndex;

    // find the clicked nav item
    while (target !== navContainer && !hasAttr(target, 'data-nav')) {
      target = target.parentNode;
    }
    if (hasAttr(target, 'data-nav')) {
      navIndex = navClicked = [].indexOf.call(navItems, target);
      goTo(navIndex, e);
    }
  }

  // autoplay functions
  function setAutoplayTimer() {
    autoplayTimer = setInterval(function () {
      onControlsClick(null, autoplayDirection);
    }, autoplayTimeout);

    animating = true;
  }

  function stopAutoplayTimer() {
    clearInterval(autoplayTimer);
    animating = false;
  }

  function updateAutoplayButton(action, txt) {
    setAttrs(autoplayButton, { 'data-action': action });
    autoplayButton.innerHTML = autoplayHtmlStrings[0] + action + autoplayHtmlStrings[1] + txt;
  }

  function startAutoplay() {
    setAutoplayTimer();
    if (autoplayButton) {
      updateAutoplayButton('stop', autoplayText[1]);
    }
  }

  function stopAutoplay() {
    stopAutoplayTimer();
    if (autoplayButton) {
      updateAutoplayButton('start', autoplayText[0]);
    }
  }

  // programaitcally play/pause the slider
  function play() {
    if (autoplay && !animating) {
      startAutoplay();
      autoplayUserPaused = false;
    }
  }
  function pause() {
    if (animating) {
      stopAutoplay();
      autoplayUserPaused = true;
    }
  }

  function toggleAutoplay() {
    if (animating) {
      stopAutoplay();
      autoplayUserPaused = true;
    } else {
      startAutoplay();
      autoplayUserPaused = false;
    }
  }

  function onVisibilityChange() {
    if (doc.hidden) {
      if (animating) {
        stopAutoplayTimer();
        autoplayVisibilityPaused = true;
      }
    } else if (autoplayVisibilityPaused) {
      setAutoplayTimer();
      autoplayVisibilityPaused = false;
    }
  }

  function mouseoverPause() {
    if (animating) {
      stopAutoplayTimer();
      autoplayHoverPaused = true;
    }
  }

  function mouseoutRestart() {
    if (autoplayHoverPaused) {
      setAutoplayTimer();
      autoplayHoverPaused = false;
    }
  }

  // keydown events on document 
  function onDocumentKeydown(e) {
    e = getEvent(e);
    switch (e.keyCode) {
      case KEYS.LEFT:
        onControlsClick(e, -1);
        break;
      case KEYS.RIGHT:
        onControlsClick(e, 1);
    }
  }

  // on key control
  function onControlsKeydown(e) {
    e = getEvent(e);
    var code = e.keyCode;

    switch (code) {
      case KEYS.LEFT:
      case KEYS.UP:
      case KEYS.PAGEUP:
        if (!prevButton.disabled) {
          onControlsClick(e, -1);
        }
        break;
      case KEYS.RIGHT:
      case KEYS.DOWN:
      case KEYS.PAGEDOWN:
        if (!nextButton.disabled) {
          onControlsClick(e, 1);
        }
        break;
      case KEYS.HOME:
        goTo('first', e);
        break;
      case KEYS.END:
        goTo('last', e);
        break;
    }
  }

  // set focus
  function setFocus(focus) {
    focus.focus();
  }

  // on key nav
  function onNavKeydown(e) {
    var curElement = doc.activeElement;
    if (!hasAttr(curElement, 'data-nav')) {
      return;
    }

    e = getEvent(e);
    var code = e.keyCode,
        navIndex = [].indexOf.call(navItems, curElement),
        len = visibleNavIndexes.length,
        current = visibleNavIndexes.indexOf(navIndex);

    if (options.navContainer) {
      len = slideCount;
      current = navIndex;
    }

    function getNavIndex(num) {
      return options.navContainer ? num : visibleNavIndexes[num];
    }

    switch (code) {
      case KEYS.LEFT:
      case KEYS.PAGEUP:
        if (current > 0) {
          setFocus(navItems[getNavIndex(current - 1)]);
        }
        break;

      case KEYS.UP:
      case KEYS.HOME:
        if (current > 0) {
          setFocus(navItems[getNavIndex(0)]);
        }
        break;

      case KEYS.RIGHT:
      case KEYS.PAGEDOWN:
        if (current < len - 1) {
          setFocus(navItems[getNavIndex(current + 1)]);
        }
        break;

      case KEYS.DOWN:
      case KEYS.END:
        if (current < len - 1) {
          setFocus(navItems[getNavIndex(len - 1)]);
        }
        break;

      // Can't use onNavClick here,
      // Because onNavClick require event.target as nav items
      case KEYS.ENTER:
      case KEYS.SPACE:
        navClicked = navIndex;
        goTo(navIndex, e);
        break;
    }
  }

  function getEvent(e) {
    e = e || win.event;
    return isTouchEvent(e) ? e.changedTouches[0] : e;
  }
  function getTarget(e) {
    return e.target || win.event.srcElement;
  }

  function isTouchEvent(e) {
    return e.type.indexOf('touch') >= 0;
  }

  function preventDefaultBehavior(e) {
    e.preventDefault ? e.preventDefault() : e.returnValue = false;
  }

  function onPanStart(e) {
    if (running) {
      onTransitionEnd();
    }

    panStart = true;
    if (carousel) {
      caf(rafIndex);
      rafIndex = 0;
    }

    var $ = getEvent(e);
    events.emit(isTouchEvent(e) ? 'touchStart' : 'dragStart', info(e));

    if (!isTouchEvent(e) && ['img', 'a'].indexOf(getLowerCaseNodeName(getTarget(e))) >= 0) {
      preventDefaultBehavior(e);
    }

    lastPosition.x = initPosition.x = parseInt($.clientX);
    lastPosition.y = initPosition.y = parseInt($.clientY);
    if (carousel) {
      translateInit = parseFloat(container.style[transformAttr].replace(transformPrefix, '').replace(transformPostfix, ''));
      resetDuration(container, '0s');
    }
  }

  function onPanMove(e) {
    if (panStart) {
      var $ = getEvent(e);
      lastPosition.x = parseInt($.clientX);
      lastPosition.y = parseInt($.clientY);

      if (carousel && !rafIndex) {
        rafIndex = raf(function () {
          panUpdate(e);
        });
      }
    }
  }

  function updateMoveDirectionExpected() {
    if (moveDirectionExpected === '?' && lastPosition.x !== initPosition.x && lastPosition.y !== initPosition.y) {
      moveDirectionExpected = getTouchDirection(toDegree(lastPosition.y - initPosition.y, lastPosition.x - initPosition.x), swipeAngle) === options.axis;
    }
  }

  function panUpdate(e) {
    if (!moveDirectionExpected) {
      panStart = false;
      return;
    }
    caf(rafIndex);
    if (panStart) {
      rafIndex = raf(function () {
        panUpdate(e);
      });
    }

    updateMoveDirectionExpected();
    if (moveDirectionExpected) {
      try {
        if (e.type) {
          events.emit(isTouchEvent(e) ? 'touchMove' : 'dragMove', info(e));
        }
      } catch (err) {}

      var x = translateInit,
          dist = getDist(lastPosition, initPosition);
      if (!horizontal || fixedWidth || autoWidth) {
        x += dist;
        x += 'px';
      } else {
        var percentageX = TRANSFORM ? dist * items * 100 / (viewport * slideCountNew) : dist * 100 / viewport;
        x += percentageX;
        x += '%';
      }

      container.style[transformAttr] = transformPrefix + x + transformPostfix;
    }
  }

  function onPanEnd(e) {
    if (panStart) {
      if (carousel) {
        caf(rafIndex);
        resetDuration(container, '');
      }
      panStart = false;

      var $ = getEvent(e);
      lastPosition.x = parseInt($.clientX);
      lastPosition.y = parseInt($.clientY);
      var dist = getDist(lastPosition, initPosition);

      if (Math.abs(dist) >= 5) {
        // drag vs click
        if (!isTouchEvent(e)) {
          // prevent "click"
          var target = getTarget(e);
          addEvents(target, { 'click': function preventClick(e) {
              preventDefaultBehavior(e);
              removeEvents(target, { 'click': preventClick });
            } });
        }

        if (carousel) {
          rafIndex = raf(function () {
            if (horizontal && !autoWidth) {
              var indexMoved = -dist * items / viewport;
              indexMoved = dist > 0 ? Math.floor(indexMoved) : Math.ceil(indexMoved);
              index += indexMoved;
            } else {
              var moved = -(translateInit + dist);
              if (moved <= 0) {
                index = indexMin;
              } else if (moved >= slidePositions[slidePositions.length - 1]) {
                index = indexMax;
              } else {
                var i = 0;
                while (i < slideCountNew && moved >= slidePositions[i]) {
                  index = i;
                  if (moved > slidePositions[i] && dist < 0) {
                    index += 1;
                  }
                  i++;
                }
              }
            }

            render(e, dist);
            events.emit(isTouchEvent(e) ? 'touchEnd' : 'dragEnd', info(e));
          });
        } else {
          updateMoveDirectionExpected();
          if (moveDirectionExpected) {
            onControlsClick(e, dist > 0 ? -1 : 1);
          }
        }
      }
    }

    if (swipeAngle) {
      moveDirectionExpected = '?';
    } // reset
  }

  // === RESIZE FUNCTIONS === //
  // (slidePositions, index, items) => vertical_conentWrapper.height
  function updateContentWrapperHeight() {
    innerWrapper.style.height = slidePositions[index + items] - slidePositions[index] + 'px';
  }

  /*
   * get nav item indexes per items
   * add 1 more if the nav items cann't cover all slides
   * [0, 1, 2, 3, 4] / 3 => [0, 3]
   */
  function getVisibleNavIndex() {
    // reset visibleNavIndexes
    visibleNavIndexes = [];

    var absIndexMin = getAbsIndex() % items;
    while (absIndexMin < slideCount) {
      if (carousel && !loop && absIndexMin + items > slideCount) {
        absIndexMin = slideCount - items;
      }
      visibleNavIndexes.push(absIndexMin);
      absIndexMin += items;
    }

    // nav count * items < slide count means
    // some slides can not be displayed only by nav clicking
    if (loop && visibleNavIndexes.length * items < slideCount || !loop && visibleNavIndexes[0] > 0) {
      visibleNavIndexes.unshift(0);
    }
  }

  /*
   * 1. update visible nav items list
   * 2. add "hidden" attributes to previous visible nav items
   * 3. remove "hidden" attrubutes to new visible nav items
   */
  function updateNavVisibility() {
    if (!nav || navAsThumbnails) {
      return;
    }
    getVisibleNavIndex();

    if (visibleNavIndexes !== visibleNavIndexesCached) {
      forEachNodeList(navItems, function (el, i) {
        visibleNavIndexes.indexOf(i) < 0 ? hideElement(el) : showElement(el);
      });

      // cache visible nav indexes
      visibleNavIndexesCached = visibleNavIndexes;
    }
  }

  function info(e) {
    return {
      container: container,
      slideItems: slideItems,
      navContainer: navContainer,
      navItems: navItems,
      controlsContainer: controlsContainer,
      hasControls: hasControls,
      prevButton: prevButton,
      nextButton: nextButton,
      items: items,
      slideBy: slideBy,
      cloneCount: cloneCount,
      slideCount: slideCount,
      slideCountNew: slideCountNew,
      index: index,
      indexCached: indexCached,
      navCurrentIndex: navCurrentIndex,
      navCurrentIndexCached: navCurrentIndexCached,
      visibleNavIndexes: visibleNavIndexes,
      visibleNavIndexesCached: visibleNavIndexesCached,
      sheet: sheet,
      event: e || {}
    };
  }

  return {
    version: '2.8.6',
    getInfo: info,
    events: events,
    goTo: goTo,
    play: play,
    pause: pause,
    isOn: isOn,
    updateSliderHeight: updateInnerWrapperHeight,
    refresh: initSliderTransform,
    destroy: destroy,
    rebuild: function rebuild() {
      return tns(extend(options, optionsElements));
    }
  };
};

var ProjectsTopicsCarouselComponent = function (_Component) {
    _inherits(ProjectsTopicsCarouselComponent, _Component);

    _createClass(ProjectsTopicsCarouselComponent, null, [{
        key: 'selector',
        value: function selector() {
            return '.projects-topics-carousel';
        }
    }]);

    function ProjectsTopicsCarouselComponent(opts) {
        _classCallCheck(this, ProjectsTopicsCarouselComponent);

        var _this = _possibleConstructorReturn(this, (ProjectsTopicsCarouselComponent.__proto__ || Object.getPrototypeOf(ProjectsTopicsCarouselComponent)).call(this, opts));

        _this.state.set({
            topic: _this.getActiveTopicFromNavBtn()
        });

        _this.renderTopicsNavSlider();

        _this.onTopicsChange = _this.onTopicsChange.bind(_this);
        _this.onHighlightsChange = _this.onHighlightsChange.bind(_this);
        _this.onTopicsBtnClick = _this.onTopicsBtnClick.bind(_this);
        _this.onProjectsTabsClick = _this.onProjectsTabsClick.bind(_this);

        _this.listen();

        if (_this.getActiveProjectsHighlights()) _this.onHighlightsChange({
            target: _this.getActiveProjectsHighlights().querySelector('select')
        });
        return _this;
    }

    _createClass(ProjectsTopicsCarouselComponent, [{
        key: 'listen',
        value: function listen() {
            var _this2 = this;

            this.state.on('update', this.onTopicsChange);

            this.getTopicsBtns().forEach(function (el) {
                el.addEventListener('click', _this2.onTopicsBtnClick);
            });

            this.getProjectsTabs().forEach(function (el) {
                el.addEventListener('click', _this2.onProjectsTabsClick);
            });

            this.getProjectsTabpanelsSelect().forEach(function (el) {
                return el.addEventListener('change', _this2.onHighlightsChange);
            });

            this.on('resize', function () {
                return _this2.renderTopicsNavSlider();
            });
        }
    }, {
        key: 'onTopicsChange',
        value: function onTopicsChange(e) {
            if (!e.data.previousData.topic || e.data.previousData.topic === e.data.currentData.topic) return;

            Array.from(this.el.querySelectorAll('[aria-expanded="true"][data-topic]')).forEach(function (el) {
                return el.setAttribute('aria-expanded', false);
            });

            Array.from(this.el.querySelectorAll('[aria-hidden="false"][data-topic]')).forEach(function (el) {
                return el.setAttribute('aria-hidden', true);
            });

            Array.from(this.el.querySelectorAll('[data-topic="' + e.data.currentData.topic + '"]')).forEach(function (el) {
                return el.getAttribute('aria-expanded') ? el.setAttribute('aria-expanded', true) : el.setAttribute('aria-hidden', false);
            });

            Array.from(this.el.querySelectorAll('iframe[src]')).forEach(function (el) {
                el.setAttribute('data-src', el.getAttribute('src'));
                el.removeAttribute('src');
            });

            if (this.getActiveProjectsHighlights()) this.onHighlightsChange({
                target: this.getActiveProjectsHighlights().querySelector('select')
            });
        }
    }, {
        key: 'onTopicsBtnClick',
        value: function onTopicsBtnClick(e) {
            var target = e.target.getAttribute('role') === 'button' ? e.target : e.target.parentNode;

            if (!target.getAttribute('data-topic')) return;

            this.state.set({
                topic: target.getAttribute('data-topic')
            });
        }
    }, {
        key: 'onProjectsTabsClick',
        value: function onProjectsTabsClick(e) {
            var _this3 = this;

            if (e.target.getAttribute('aria-selected') === 'true') return;

            this.getActiveProjectsTabs().forEach(function (el) {
                el.setAttribute('aria-selected', el === e.target);

                var tabpanel = _this3.el.querySelector('#' + el.getAttribute('aria-controls'));

                if (!tabpanel) return;

                var isActive = tabpanel.id === e.target.getAttribute('aria-controls');

                tabpanel.setAttribute('aria-hidden', !isActive);

                if (!isActive && tabpanel.querySelector('iframe[src]')) Array.from(tabpanel.querySelectorAll('iframe[src]')).forEach(function (el) {
                    el.setAttribute('data-src', el.getAttribute('src'));
                    el.removeAttribute('src');
                });
            });

            if (this.getActiveProjectsHighlights()) this.onHighlightsChange({
                target: this.getActiveProjectsHighlights().querySelector('select')
            });
        }
    }, {
        key: 'onHighlightsChange',
        value: function onHighlightsChange(e) {
            if (!e.target) return;

            Array.from(this.getActiveProjectsHighlights().querySelectorAll('[id][aria-hidden]')).forEach(function (el) {
                el.setAttribute('aria-hidden', Boolean(!el.id.match(new RegExp('^(' + e.target.value + ')(?:-media)*$'))));

                var iframe = el.querySelector('iframe');

                if (!iframe) return;

                if (el.getAttribute('aria-hidden') === 'true' && iframe.getAttribute('src')) {
                    iframe.setAttribute('data-src', iframe.getAttribute('src'));
                    return iframe.removeAttribute('src');
                }

                if (el.getAttribute('aria-hidden') === 'false' && !iframe.getAttribute('src') && iframe.getAttribute('data-src')) iframe.setAttribute('src', iframe.getAttribute('data-src'));
            });
        }
    }, {
        key: 'getActiveTopicFromNavBtn',
        value: function getActiveTopicFromNavBtn() {
            var btn = this.el.querySelector('[aria-expanded="true"][data-topic]');

            return btn ? btn.getAttribute('data-topic') : null;
        }
    }, {
        key: 'getActiveProjectsHighlights',
        value: function getActiveProjectsHighlights() {
            return this.getActiveProjectsTabpanel() ? this.getActiveProjectsTabpanel().querySelector('.projects-topics-carousel-tabpanel-highlights') : null;
        }
    }, {
        key: 'getActiveProjectsTabs',
        value: function getActiveProjectsTabs() {
            return Array.from(this.el.querySelectorAll('[data-topic="' + this.state.get('topic') + '"] .projects-topics-carousel-tab[role="tab"]'));
        }
    }, {
        key: 'getActiveProjectsTabpanel',
        value: function getActiveProjectsTabpanel() {
            return this.el.querySelector('[data-topic="' + this.state.get('topic') + '"] .projects-topics-carousel-tabpanel[aria-hidden="false"]');
        }
    }, {
        key: 'getTopicsBtns',
        value: function getTopicsBtns() {
            return Array.from(this.el.querySelectorAll('.projects-topics-carousel-nav a[data-topic]'));
        }
    }, {
        key: 'getTopicsNav',
        value: function getTopicsNav() {
            return this.el.querySelector('.projects-topics-carousel-nav');
        }
    }, {
        key: 'getProjectsTabs',
        value: function getProjectsTabs() {
            return Array.from(this.el.querySelectorAll('.projects-topics-carousel-tab[role="tab"]'));
        }
    }, {
        key: 'getProjectsTabpanelsSelect',
        value: function getProjectsTabpanelsSelect() {
            return Array.from(this.el.querySelectorAll('.projects-topics-carousel-tabpanel select'));
        }
    }, {
        key: 'getTopicsNavSlider',
        value: function getTopicsNavSlider() {
            return this.el.querySelector('.projects-topics-carousel-nav-slider');
        }
    }, {
        key: 'getTopicsNavSliderResizer',
        value: function getTopicsNavSliderResizer() {
            return this.el.querySelector('.projects-topics-carousel-nav-slider-resizer');
        }
    }, {
        key: 'renderTopicsNavSlider',
        value: function renderTopicsNavSlider() {
            var _this4 = this;

            if (!this.getTopicsNav() || !this.getTopicsNavSlider() || !this.getTopicsNavSlider().children || !this.getTopicsNavSlider().children[0] || !this.getTopicsNavSliderResizer()) return;

            if (!this.getTopicsNavSlider().classList.contains('flex-nowrap')) this.getTopicsNavSlider().classList.add('flex-nowrap');

            var navWidth = this.getTopicsNav().clientWidth || 0;
            var isFullWidth = this.el.clientWidth === navWidth;
            var colMaxItems = isFullWidth ? 3 : 10;

            var itemClass = 'projects-topics-carousel-nav-slider-item';
            var firstChild = this.getTopicsNavSlider().children[0];
            var isUpdate = !firstChild.classList.contains(itemClass) || firstChild.classList.contains(itemClass) && (isFullWidth && firstChild.children.length > colMaxItems || !isFullWidth && firstChild.children.length < colMaxItems && this.getTopicsBtns().length > colMaxItems);

            var setColWidths = function setColWidths() {
                return Array.from(_this4.getTopicsNavSlider().querySelectorAll('.' + itemClass)).forEach(function (el) {
                    var width = void 0;

                    if (_this4.el.clientWidth < 420) width = navWidth;else width = isFullWidth ? navWidth * 0.5 : navWidth - (20 + Number(window.getComputedStyle(_this4.getTopicsNav()).paddingRight.replace(/\D+$/, '')));

                    if (el.clientWidth === width) return;

                    el.style.width = width + 'px';
                    el.style.minWidth = width + 'px';
                });
            };

            if (!isUpdate) return setColWidths();

            if (this.updating) return;

            this.getTopicsBtns().forEach(function (el, idx) {
                if (isUpdate && !idx) _this4.updating = true;

                _this4.getTopicsNavSliderResizer().appendChild(el);
            });

            if (this.topicsNavSlider) this.topicsNavSlider.destroy();

            this.getTopicsNavSlider().innerHTML = '';

            this.getTopicsBtns().forEach(function (el, idx) {
                var col = void 0;

                if (idx % colMaxItems === 0) {
                    col = document.createElement('div');
                    col.className = itemClass + ' col pad-0-r-md-up pad-0-l-md-up';

                    _this4.getTopicsNavSlider().appendChild(col);
                }

                col = col || _this4.getTopicsNavSlider().querySelector('.' + itemClass + ':last-child');

                if (col) col.appendChild(el);
            });

            setColWidths();

            this.topicsNavSlider = this.topicsNavSlider ? this.topicsNavSlider.rebuild() : tns({
                container: this.getTopicsNavSlider(),
                prevButton: this.getTopicsNav().querySelector('.projects-topics-carousel-nav-btn-prev'),
                nextButton: this.getTopicsNav().querySelector('.projects-topics-carousel-nav-btn-next'),
                autoWidth: true,
                loop: false,
                gutter: 0,
                mouseDrag: true,
                nav: false,
                slideBy: 'page',
                responsive: {
                    420: {
                        items: 2
                    },
                    768: {
                        items: 1
                    }
                }
            });

            var setOverflowVisibleAttr = function setOverflowVisibleAttr(e) {
                var container = _this4.getTopicsNav().querySelector('.tns-outer');

                if (isFullWidth && container) return container.removeAttribute('data-overflow-visible');

                var active = e.slideItems[e.index];

                if (!container || !active) return;

                return active.querySelector('[aria-expanded="true"]') ? container.setAttribute('data-overflow-visible', true) : container.removeAttribute('data-overflow-visible');
            };

            this.topicsNavSlider.events.on('indexChanged', function (e) {
                return setOverflowVisibleAttr(e);
            });

            setOverflowVisibleAttr({
                slideItems: this.getTopicsNavSlider().querySelectorAll('.' + itemClass) || [],
                index: 0
            });

            this.updating = false;
        }
    }]);

    return ProjectsTopicsCarouselComponent;
}(Component);

var QueryFilterComponent = function (_Component) {
    _inherits(QueryFilterComponent, _Component);

    _createClass(QueryFilterComponent, null, [{
        key: 'selector',
        value: function selector() {
            return '.query-filter';
        }
    }]);

    function QueryFilterComponent(opts) {
        _classCallCheck(this, QueryFilterComponent);

        var _this = _possibleConstructorReturn(this, (QueryFilterComponent.__proto__ || Object.getPrototypeOf(QueryFilterComponent)).call(this, opts));

        _this.state.set({
            filterDropdownState: 'collapsed',
            filterActiveID: null
        });

        _this.onChange = _this.onChange.bind(_this);
        _this.onDocumentClick = _this.onDocumentClick.bind(_this);
        _this.onFilterBtnClick = _this.onFilterBtnClick.bind(_this);
        _this.onFilterBtnKeydown = _this.onFilterBtnKeydown.bind(_this);
        _this.onFilterDropdownRadioChange = _this.onFilterDropdownRadioChange.bind(_this);
        _this.onFilterDropdownRadioAllClick = _this.onFilterDropdownRadioAllClick.bind(_this);
        _this.onFilterDropdownRadioAllKeyup = _this.onFilterDropdownRadioAllKeyup.bind(_this);

        _this.render();
        _this.listen();
        return _this;
    }

    _createClass(QueryFilterComponent, [{
        key: 'listen',
        value: function listen() {
            var _this2 = this;

            this.state.on('update', this.onChange);

            document.body.addEventListener('click', this.onDocumentClick, false);

            this.on('resize', function () {
                return _this2.renderFilterDropdown();
            });

            this.getFilterDropdownRadios().forEach(function (el) {
                return el.addEventListener('change', _this2.onFilterDropdownRadioChange);
            });

            if (this.getFilterDropdownRadioAll()) {
                this.getFilterDropdownRadioAll().onclick = this.onFilterDropdownRadioAllClick;
                this.getFilterDropdownRadioAll().onkeyup = this.onFilterDropdownRadioAllKeyup;
            }

            if (this.getFilterBtn()) {
                this.getFilterBtn().onclick = this.onFilterBtnClick;
                this.getFilterBtn().onkeydown = this.onFilterBtnKeydown;
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(e) {
            if (this.props.filterDropdownState !== e.data.currentData.filterDropdownState) this.props.filterDropdownState = e.data.currentData.filterDropdownState;

            this.render();
        }
    }, {
        key: 'onDocumentClick',
        value: function onDocumentClick(e) {
            var eventPath = e.path || [];

            // Build path array for other browsers
            if (!eventPath.length) {
                var node = e.target;

                while (node !== document.body) {
                    eventPath.push(node);
                    node = node.parentNode;
                }
            }

            if (eventPath.indexOf(this.el) < 0 && this.props.filterDropdownState === 'expanded') this.state.set('filterDropdownState', 'collapsed');
        }
    }, {
        key: 'onFilterDropdownRadioChange',
        value: function onFilterDropdownRadioChange(e) {
            if (this.getFilterDropdownRadioAll() && this.getFilterDropdownRadioAll().checked) this.getFilterDropdownRadioAll().checked = false;

            this.getFilterDropdownRadios().filter(function (el) {
                return el !== e.target && el.checked;
            }).forEach(function (el) {
                el.checked = false;
            });

            this.state.set('filterActiveID', e.target.id);
        }
    }, {
        key: 'onFilterDropdownRadioAllClick',
        value: function onFilterDropdownRadioAllClick(e) {
            this.getFilterDropdownRadios().filter(function (el) {
                return el.checked;
            }).forEach(function (el) {
                el.checked = false;
            });

            this.state.set('filterActiveID', e.target.id);
        }
    }, {
        key: 'onFilterDropdownRadioAllKeyup',
        value: function onFilterDropdownRadioAllKeyup(e) {
            if (e.target.checked) this.onFilterDropdownRadioAllClick(e);
        }
    }, {
        key: 'onFilterBtnClick',
        value: function onFilterBtnClick() {
            this.state.set('filterDropdownState', this.props.filterDropdownState === 'expanded' ? 'collapsed' : 'expanded');
        }
    }, {
        key: 'onFilterBtnKeydown',
        value: function onFilterBtnKeydown(e) {
            if (e.keyCode === 32 || (e.keyIdentifier || e.key || '').match(/^(enter)$/i)) this.onFilterBtnClick(e);
        }
    }, {
        key: 'getFilterBtn',
        value: function getFilterBtn() {
            return this.el.querySelector('.query-filter-btn');
        }
    }, {
        key: 'getFilterDropdown',
        value: function getFilterDropdown() {
            return this.el.querySelector('.query-filter-dropdown');
        }
    }, {
        key: 'getFilterDropdownRadios',
        value: function getFilterDropdownRadios() {
            return Array.from(this.el.querySelectorAll('.query-filter-dropdown input[name][type="radio"]'));
        }
    }, {
        key: 'getFilterDropdownRadioAll',
        value: function getFilterDropdownRadioAll() {
            return this.el.querySelector('.query-filter-dropdown input[data-name="all"][type="radio"]');
        }
    }, {
        key: 'getContentContainer',
        value: function getContentContainer() {
            return this.props.contentContainer ? document.querySelector(this.props.contentContainer) : null;
        }
    }, {
        key: 'renderFilterDropdown',
        value: function renderFilterDropdown() {
            if (!this.getFilterDropdown() || !this.getContentContainer()) return;

            var isAbsolute = window.getComputedStyle(this.getFilterDropdown()).position === 'absolute';

            if ((!isAbsolute || this.props.filterDropdownState !== 'expanded') && this.getContentContainer().style.minHeight !== '0px') {
                this.getContentContainer().style.minHeight = '0px';
                return;
            }

            this.getContentContainer().style.minHeight = this.getFilterDropdown().clientHeight + 'px';
        }
    }, {
        key: 'renderFilterBtnText',
        value: function renderFilterBtnText() {
            var activeFilterLabel = this.state.get('filterActiveID') ? this.el.querySelector('label[for="' + this.state.get('filterActiveID') + '"]') : null;
            var filterBtnLabel = this.getFilterBtn().querySelector('.query-filter-btn-label');

            if (!activeFilterLabel || !filterBtnLabel || filterBtnLabel.innerHTML === activeFilterLabel.innerHTML) return;

            filterBtnLabel.innerHTML = activeFilterLabel.innerHTML;
        }
    }, {
        key: 'renderFilterBtnAriaLabel',
        value: function renderFilterBtnAriaLabel() {
            if (!this.getFilterBtn()) return;

            if (!this.getFilterBtn().getAttribute('tabindex')) this.getFilterBtn().setAttribute('tabindex', 0);

            var isExpanded = this.props.filterDropdownState === 'expanded';

            var label = void 0;

            if (this.getFilterBtn().getAttribute('data-aria-label-collapsed') && !isExpanded) label = this.getFilterBtn().getAttribute('data-aria-label-collapsed');else if (this.getFilterBtn().getAttribute('data-aria-label-expanded') && isExpanded) label = this.getFilterBtn().getAttribute('data-aria-label-expanded');

            if (label) this.getFilterBtn().setAttribute('aria-label', label);
        }
    }, {
        key: 'render',
        value: function render() {
            this.renderFilterBtnAriaLabel();
            this.renderFilterBtnText();
            this.renderFilterDropdown();
        }
    }]);

    return QueryFilterComponent;
}(Component);

var SelectComponent = function (_Component) {
    _inherits(SelectComponent, _Component);

    _createClass(SelectComponent, null, [{
        key: 'selector',
        value: function selector() {
            return '.select';
        }
    }]);

    function SelectComponent(opts) {
        _classCallCheck(this, SelectComponent);

        var _this = _possibleConstructorReturn(this, (SelectComponent.__proto__ || Object.getPrototypeOf(SelectComponent)).call(this, opts));

        if (!_this.el) return _possibleConstructorReturn(_this);

        _this.els = {
            select: _this.el.querySelector('select'),
            selectBtn: null,
            selectContainer: null,
            optionsList: null
        };

        if (!_this.els.select || _this.els.select.multiple || _this.getFeature('touch')) return _possibleConstructorReturn(_this);

        _this.onDocumentClick = _this.onDocumentClick.bind(_this);
        _this.onLabelKeydown = _this.onLabelKeydown.bind(_this);
        _this.onLabelClick = _this.onLabelClick.bind(_this);

        _this.onListboxKeydown = _this.onListboxKeydown.bind(_this);
        _this.onListboxClick = _this.onListboxClick.bind(_this);
        _this.onListboxFocus = _this.onListboxFocus.bind(_this);

        _this.render();
        _this.renderSelectLabel();
        _this.renderOptionsList();

        _this.listen();
        return _this;
    }

    _createClass(SelectComponent, [{
        key: 'listen',
        value: function listen() {
            var _this2 = this;

            if (!this.els.select) return;

            this.els.selectBtn.onclick = this.onLabelClick;
            this.els.selectBtn.onkeydown = this.onLabelKeydown;

            this.els.optionsList.onkeydown = this.onListboxKeydown;
            this.els.optionsList.onclick = this.onListboxClick;
            this.els.optionsList.onfocus = this.onListboxFocus;

            document.body.addEventListener('click', this.onDocumentClick, false);

            this.observer = new window.MutationObserver(function (mutations) {
                _this2.renderOptionsList();
            });

            this.observer.observe(this.els.select, { childList: true });
        }
    }, {
        key: 'onLabelClick',
        value: function onLabelClick(e) {
            if (this.els.select.disabled) return this.el.classList.add('disabled');

            this.el.classList.remove('disabled');
            this.el.classList.toggle('active');

            if (!this.el.classList.contains('active')) return;

            this.els.optionsList.focus();

            if ((e.keyIdentifier || e.key || '').match(/down/i)) this.setSelectedOption();
        }
    }, {
        key: 'onLabelKeydown',
        value: function onLabelKeydown(e) {
            if (e.which === 27) {
                this.el.classList.remove('active');
                return this.els.selectBtn.focus();
            }

            var key = e.keyIdentifier || e.key || '';

            if (e.keyCode === 27 || key.match(/enter/i) || key.match(/(down|up)/i) && !this.el.classList.contains('active')) this.onLabelClick(e);
        }
    }, {
        key: 'onListboxFocus',
        value: function onListboxFocus(e) {
            // TODO: optimize focusing across all components
            // e.preventDefault()
            // e.stopPropagation()
        }
    }, {
        key: 'onListboxClick',
        value: function onListboxClick(e) {
            this.setSelectedOption(e.target);
            this.el.classList.remove('active');
            return this.els.selectBtn.focus();
        }
    }, {
        key: 'onListboxKeydown',
        value: function onListboxKeydown(e) {
            var _this3 = this;

            var key = e.keyIdentifier || e.key || '';

            if (e.which === 27 || key.match(/enter/i)) {
                this.el.classList.remove('active');
                return this.els.selectBtn.focus();
            }

            var items = this.getOptionsListItems();

            if (!items.length) return;

            var selectOption = function selectOption(el) {
                e.preventDefault();
                e.stopPropagation();

                _this3.setSelectedOption(el);
            };

            if (key.match(/(home|end)/i)) return selectOption(key.match(/home/i) ? items[0] : items[items.length - 1]);

            var selected = this.els.optionsList.querySelector('[aria-selected="true"][role=option]');

            var selectedIdx = items.indexOf(selected);

            if (key.match(/(up|down)/i)) {
                if (selectedIdx < 0) return;

                var next = key.match(/down/i) ? items[selectedIdx + 1] : items[selectedIdx - 1];

                if (next) return selectOption(next);
            }

            if (!key.match(/(\d|\w)/)) return;

            var jumpTo = items.slice(selectedIdx + 1).find(function (el) {
                return el.innerText.toLowerCase().charAt(0) === key.toLowerCase();
            });

            if (jumpTo) selectOption(jumpTo);
        }
    }, {
        key: 'onDocumentClick',
        value: function onDocumentClick(e) {
            var eventPath = e.path || [];

            // Build path array for other browsers
            if (!eventPath.length) {
                var node = e.target;

                while (node !== document.body) {
                    eventPath.push(node);
                    node = node.parentNode;
                }
            }

            if (eventPath.indexOf(this.el) < 0) this.el.classList.remove('active');
        }
    }, {
        key: 'setSelectedText',
        value: function setSelectedText(str) {
            this.els.selectBtn.querySelector('span').innerText = (str || (this.getSelectedOptionDefault() || {}).innerText || '').trim();
        }
    }, {
        key: 'getSelectedOptionDefault',
        value: function getSelectedOptionDefault() {
            return this.els.optionsList.querySelector('[aria-selected="true"]') || this.getOptionsListItems().filter(function (el) {
                return el.getAttribute('aria-disabled') !== 'true';
            })[0];
        }
    }, {
        key: 'setSelectedOption',
        value: function setSelectedOption(el) {
            if (!this.getOptionsListItems().length) return;

            el = el || this.getSelectedOptionDefault();

            if (!el || el.getAttribute('aria-disabled') === 'true') return;

            if (el.getAttribute('aria-selected') !== 'true') this.getOptionsListItems().filter(function (node) {
                return node.getAttribute('aria-selected');
            }).forEach(function (node) {
                return node.removeAttribute('aria-selected');
            });

            var option = this.els.select.querySelector('option[data-id="' + el.id + '"]');

            if (!option) return;

            el.setAttribute('aria-selected', true);

            this.els.optionsList.setAttribute('aria-activedescendant', el.id);

            this.els.optionsList.scrollTop = el.offsetTop;
            this.setSelectedText();

            if (option === this.getSelectedOption()) return;

            this.els.select.selectedIndex = Array.from(this.els.select.querySelectorAll('option')).indexOf(option);

            this.els.select.value = option.value;

            var evt = this.getBrowser('name') === 'ie' ? document.createEvent('Event') : new window.Event('change');

            if (this.getBrowser('name') === 'ie') evt.initEvent('change', true, true);

            this.els.select.dispatchEvent(evt);
        }
    }, {
        key: 'getSelectedOption',
        value: function getSelectedOption() {
            return this.els.select.selectedIndex < 0 ? null : this.els.select.querySelectorAll('option')[this.els.select.selectedIndex];
        }
    }, {
        key: 'getOptions',
        value: function getOptions() {
            return Array.from(this.el.querySelectorAll('select option'));
        }
    }, {
        key: 'getOptionsListItems',
        value: function getOptionsListItems() {
            return Array.from(this.els.optionsList.querySelectorAll('[role="option"]')).filter(function (el) {
                return el.getAttribute('aria-disabled') !== 'true';
            });
        }
    }, {
        key: 'renderSelectLabel',
        value: function renderSelectLabel() {
            this.els.selectBtn = document.createElement('a');

            this.els.selectBtn.id = this.els.select.id + '-btn';
            this.els.selectBtn.className = 'select-btn';
            this.els.selectBtn.innerHTML = '<span></span>';

            this.els.selectBtn.setAttribute('role', 'button');
            this.els.selectBtn.setAttribute('tabindex', 0);
            this.els.selectBtn.setAttribute('aria-haspopup', 'listbox');
            this.els.selectBtn.setAttribute('aria-labelledby', this.els.selectBtn.id);

            this.els.selectContainer.appendChild(this.els.selectBtn);
        }
    }, {
        key: 'renderAriaLabel',
        value: function renderAriaLabel(el) {
            if (!el || !el.tagName.match(/label/i)) return el;

            el.id = el.id || this.els.select.id + '-label';
            el.removeAttribute('for');
            el.classList.add('select-label');
            el.outerHTML = el.outerHTML.replace(/(<\/*)(label)(?=>)*/g, '$1span');

            return el;
        }
    }, {
        key: 'renderOptionsList',
        value: function renderOptionsList() {
            var _this4 = this;

            if (!this.els.optionsList) {
                this.els.optionsList = document.createElement('ul');
                this.els.optionsList.className = 'select-options';
                this.els.optionsList.id = this.els.select.id + '-listbox';
                this.els.optionsList.setAttribute('role', 'listbox');
                this.els.optionsList.setAttribute('tabindex', -1);

                var labelledby = Array.from(this.el.querySelectorAll('label[for="' + this.els.select.id + '"]')).map(function (el) {
                    return _this4.renderAriaLabel(el);
                }).map(function (el) {
                    return el.id;
                }).filter(function (str) {
                    return str;
                }).concat((this.els.select.getAttribute('aria-labelledby') || '').split(/\s+/).filter(function (str) {
                    return str.length;
                }).map(function (id) {
                    return _this4.el.querySelector('#' + id);
                }).filter(function (el) {
                    return el;
                })).join(' ');

                if (labelledby) {
                    this.els.optionsList.setAttribute('aria-labelledby', labelledby);

                    this.els.selectBtn.setAttribute('aria-labelledby', (labelledby + ' ' + this.els.selectBtn.getAttribute('aria-labelledby')).trim());
                }
            }

            this.els.optionsList.innerHTML = '';

            this.getOptions().forEach(function (option, idx) {
                if (idx === 0 && option.selected && option.disabled && !option.value) return _this4.setSelectedText(option.innerHTML);

                var id = _this4.els.select.id + '-option-' + idx;
                option.setAttribute('data-id', id);

                _this4.els.optionsList.innerHTML += '<li ' + (option.selected ? 'aria-selected="true" ' : '') + (option.disabled ? 'aria-disabled="true" ' : '') + 'value="' + option.value + '" role="option" id="' + id + '">' + option.innerHTML + '</li>\n                ';
            });

            this.els.selectContainer.appendChild(this.els.optionsList);

            if (!this.els.selectBtn.innerText.length) this.setSelectedOption();
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.els.select) return;

            this.els.select.id = this.els.select.id || 'select-' + this.generateGUID();

            this.els.select.setAttribute('aria-hidden', true);
            this.els.select.setAttribute('tabindex', -1);

            this.els.selectContainer = document.createElement('div');
            this.els.selectContainer.classList.add('select-container');

            this.el.appendChild(this.els.selectContainer);
        }
    }]);

    return SelectComponent;
}(Component);

var StatisticsComponent = function (_Component) {
    _inherits(StatisticsComponent, _Component);

    _createClass(StatisticsComponent, null, [{
        key: 'selector',
        value: function selector() {
            return '.statistics';
        }
    }]);

    function StatisticsComponent(opts) {
        _classCallCheck(this, StatisticsComponent);

        var _this = _possibleConstructorReturn(this, (StatisticsComponent.__proto__ || Object.getPrototypeOf(StatisticsComponent)).call(this, opts));

        _this.state.set({
            index: _this.getActiveItemIndex()
        });

        _this.onChange = _this.onChange.bind(_this);
        _this.onItemsClick = _this.onItemsClick.bind(_this);
        _this.onItemsMouseOver = _this.onItemsMouseOver.bind(_this);

        _this.listen();
        return _this;
    }

    _createClass(StatisticsComponent, [{
        key: 'listen',
        value: function listen() {
            var _this2 = this;

            this.state.on('update', this.onChange);

            this.getItems().forEach(function (el) {
                el.addEventListener('click', _this2.onItemsClick, false);
                el.addEventListener('mouseover', _this2.onItemsClick, false);
            });

            window.objectFitPolyfill();
        }
    }, {
        key: 'onChange',
        value: function onChange(e) {
            if (!e.data.previousData.index || e.data.previousData.index === e.data.currentData.index) return;

            var idx = e.data.currentData.index;

            Array.from(this.el.querySelectorAll('.active[data-idx]')).forEach(function (el) {
                return el.classList.remove('active');
            });

            Array.from(this.el.querySelectorAll('[data-idx="' + idx + '"]')).forEach(function (el) {
                return el.classList.add('active');
            });

            window.objectFitPolyfill();
        }
    }, {
        key: 'onItemsClick',
        value: function onItemsClick(e) {
            var target = e.target.getAttribute('role') === 'button' ? e.target : e.target.parentNode.getAttribute('role') === 'button' ? e.target.parentNode : e.target.parentNode.parentNode;

            if (target.getAttribute('role') !== 'button') return;

            this.state.set({
                index: Number(target.getAttribute('data-idx'))
            });
        }
    }, {
        key: 'onItemsMouseOver',
        value: function onItemsMouseOver(e) {
            var target = e.target.getAttribute('role') === 'button' ? e.target : e.target.parentNode.getAttribute('role') === 'button' ? e.target.parentNode : e.target.parentNode.parentNode;

            if (target.getAttribute('role') !== 'button') return;

            console.log(target);
        }
    }, {
        key: 'getActiveItem',
        value: function getActiveItem() {
            return this.el.querySelector('.statistics-numbers-item.active');
        }
    }, {
        key: 'getActiveItemIndex',
        value: function getActiveItemIndex() {
            return this.getActiveItem() && this.getActiveItem().getAttribute('data-idx') ? Number(this.getActiveItem().getAttribute('data-idx')) : 1;
        }
    }, {
        key: 'getItems',
        value: function getItems() {
            return Array.from(this.el.querySelectorAll('.statistics-numbers-item'));
        }
    }]);

    return StatisticsComponent;
}(Component);

var TransformRotateComponent = function (_Component) {
    _inherits(TransformRotateComponent, _Component);

    _createClass(TransformRotateComponent, null, [{
        key: 'selector',
        value: function selector() {
            return '[data-transform-rotate]';
        }
    }]);

    function TransformRotateComponent(opts) {
        _classCallCheck(this, TransformRotateComponent);

        var _this = _possibleConstructorReturn(this, (TransformRotateComponent.__proto__ || Object.getPrototypeOf(TransformRotateComponent)).call(this, opts));

        _this.render = _this.render.bind(_this);
        _this.state.set({
            breakpoint: _this.getActiveBreakpoint()
        });

        _this.render();
        _this.listen();
        return _this;
    }

    _createClass(TransformRotateComponent, [{
        key: 'listen',
        value: function listen() {
            this.on('resize', this.render);
            this.on('resize:debounced', this.render);
        }
    }, {
        key: 'getTarget',
        value: function getTarget() {
            return this.el.querySelector(this.props.transformRotateTarget);
        }
    }, {
        key: 'getBreakpoints',
        value: function getBreakpoints() {
            var arr = [];

            try {
                arr = JSON.parse(this.props.breakpoints || '[{ "min": 0, "max": null }]');
            } catch (e) {
                console.warn('Error parsing `data-breakpoints`');
            }

            return arr.filter(function (obj) {
                return 'min' in obj && obj.min >= 0;
            });
        }
    }, {
        key: 'getActiveBreakpoint',
        value: function getActiveBreakpoint() {
            return this.getBreakpoints().filter(function (obj) {
                return window.innerWidth >= obj.min && (!obj.max || window.innerWidth <= obj.max);
            })[0];
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.getTarget()) return;

            if (!this.getTarget().getAttribute('data-transform-rotate-el')) this.getTarget().setAttribute('data-transform-rotate-el', true);

            var isDisabled = !this.getActiveBreakpoint() || this.props.transformRotateDisabled;

            var isChanged = this.getActiveBreakpoint() !== this.state.get('breakpoint');

            if ((isDisabled || isChanged) && this.getTarget().style.transform) {
                this.getTarget().style.transform = '';
                this.el.style.whiteSpace = 'auto';
                this.el.style.height = 'auto';
                this.el.style.width = 'auto';
            }

            if (isDisabled) return;

            var targetTransformVal = 'rotate(' + this.props.transformRotate + ')';

            var _getTarget$getBoundin = this.getTarget().getBoundingClientRect(),
                width = _getTarget$getBoundin.width,
                height = _getTarget$getBoundin.height;

            if (this.getTarget().style.transform === targetTransformVal) return;

            this.getTarget().style.transform = targetTransformVal;

            this.el.style.whiteSpace = 'nowrap';
            this.el.style.height = width + 'px';
            this.el.style.width = height + 'px';
        }
    }]);

    return TransformRotateComponent;
}(Component);

var Components = {
    TransformRotateComponent: TransformRotateComponent,
    HeroComponent: HeroComponent,
    GlobalHeaderComponent: GlobalHeaderComponent,
    HashAnchorComponent: HashAnchorComponent,
    CastMembersComponent: CastMembersComponent,
    BtnJSZipComponent: BtnJSZipComponent,
    GlobalFooterComponent: GlobalFooterComponent,
    HighlightsComponent: HighlightsComponent,
    PaginationFetcherComponent: PaginationFetcherComponent,
    ProjectsComponent: ProjectsComponent$1,
    ProjectsTopicsCarouselComponent: ProjectsTopicsCarouselComponent,
    QueryFilterComponent: QueryFilterComponent,
    SelectComponent: SelectComponent,
    StatisticsComponent: StatisticsComponent,
    ModalComponent: ProjectsComponent,
    PressCoverageFormComponent: PressCoverageFormComponent,
    MailchimpFormComponent: MailchimpFormComponent
};

var Scroller = function (_Obj) {
    _inherits(Scroller, _Obj);

    function Scroller() {
        var _ret, _ret2;

        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { el: window };

        _classCallCheck(this, Scroller);

        var _this = _possibleConstructorReturn(this, (Scroller.__proto__ || Object.getPrototypeOf(Scroller)).call(this));

        _this.el = opts.el;
        _this.ticking = false;
        _this.state = new Baobab({
            scrollX: 0,
            scrollY: 0,
            directionY: null,
            directionX: null
        });

        if (typeof _this.el === 'string' && !document.querySelector(_this.el)) return _ret = _this.observe(_this.el), _possibleConstructorReturn(_this, _ret);else if (typeof _this.el === 'string') _this.el = document.querySelector(_this.el);

        return _ret2 = _this.listen(), _possibleConstructorReturn(_this, _ret2);
    }

    _createClass(Scroller, [{
        key: 'observe',
        value: function observe() {
            var _this2 = this;

            var observer = new window.MutationObserver(function () {
                if (typeof _this2.el === 'string' && document.querySelector(_this2.el)) {
                    _this2.el = document.querySelector(_this2.el);
                    observer.disconnect();
                    _this2.listen();
                }
            });

            observer.observe(document.documentElement, {
                childList: true,
                subtree: true
            });

            return this;
        }
    }, {
        key: 'listen',
        value: function listen() {
            var _this3 = this;

            this.el.addEventListener('scroll', function () {
                return _this3.onScroll();
            });

            if ('ontouchstart' in document.documentElement) this.el.addEventListener('touchstart', function () {
                return _this3.onScroll();
            });

            this.onScroll();
            return this;
        }
    }, {
        key: 'onScroll',
        value: function onScroll() {
            var _this4 = this;

            if (this.ticking) return;

            window.requestAnimationFrame(function () {
                _this4.ticking = false;
            });

            var scrollX = this.getScroll('scrollX');
            var scrollY = this.getScroll('scrollY');

            var getScrolledDirection = function getScrolledDirection(axis) {
                var scrollAxis = 'scroll' + axis;
                var directionAxis = 'direction' + axis;

                var scrollDiff = _this4.state.get(scrollAxis) - _this4.getScroll(scrollAxis);

                if (scrollDiff < 0) scrollDiff = scrollDiff * -1;

                var prevScroll = axis === 'Y' ? scrollY : scrollX;

                if (scrollDiff < 0.5) return _this4.state.get(directionAxis) && prevScroll !== _this4.state.get(scrollAxis) ? _this4.state.get(directionAxis) : null;

                return prevScroll < _this4.state.get(scrollAxis) ? axis === 'Y' ? 'up' : 'left' : axis === 'Y' ? 'down' : 'right';
            };

            this.state.set({
                scrollX: scrollX,
                scrollY: scrollY,
                directionX: getScrolledDirection('X'),
                directionY: getScrolledDirection('Y')
            });

            this.ticking = true;
        }
    }, {
        key: 'getScroll',
        value: function getScroll(dir) {
            // Scroll{Y,X} only on window
            if (this.el[dir]) return this.el[dir];

            // Scroll{Y,X} fallback, only on window
            var pageOffset = dir === 'scrollY' ? this.el.pageYOffset : this.el.pageXOffset;

            if (pageOffset) return pageOffset;

            // Update dir to target overflow elements and/or legacy browsers
            dir = dir === 'scrollY' ? 'scrollTop' : 'scrollLeft';

            if (this.el[dir]) return this.el[dir];

            // Legacy browsers only
            return (document.compatMode || '') === 'CSS1Compat' ? document.documentElement[dir] : document.body[dir];
        }
    }, {
        key: 'scrollTo',
        value: function scrollTo() {
            var _this5 = this;

            var coordinates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { x: 0, y: 0 };
            var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.75;

            coordinates.x = coordinates.x || 0;
            coordinates.y = coordinates.y || 0;

            return new Promise(function (resolve) {
                if (!_this5.el) return resolve

                // Fallback scroll
                ();if (!window.TweenLite || !window.ScrollToPlugin) {
                    if (_this5.el === window) window.scrollTo(coordinates.x, coordinates.y);else {
                        _this5.el.scrollLeft = coordinates.x;
                        _this5.el.scrollTop = coordinates.y;
                    }

                    return resolve();
                }

                // Animated scroll flag
                _this5.scrollingTo = true;

                // Animated scroll
                window.TweenLite.to(_this5.el, time, {
                    scrollTo: coordinates,
                    ease: window.Power3.easeOut,
                    onComplete: function onComplete() {
                        _this5.scrollingTo = false;
                        _this5.onScroll();
                        resolve();
                        _this5.emit('scrollingTo:complete');
                    }
                });
            });
        }
    }]);

    return Scroller;
}(Obj);

//* ---------------------------------------

//* ---------------------------------------
//  Create RootComponent

var RootComponent = new Component({
    el: document.body,
    Scroller: new Scroller()
});

//* ---------------------------------------
//  Detect Features like Modernizr

RootComponent.addFeatureTest({
    csspointerevents: function csspointerevents() {
        return RootComponent.detectCSSProp('pointer-events');
    },
    csstouchaction: function csstouchaction() {
        return RootComponent.detectCSSProp('touch-action');
    }
}).addFeaturesToClassName

//* ---------------------------------------
//  Log RootComponent

();console.groupCollapsed('RootComponent');
console.log(RootComponent);
console.groupEnd

//* ---------------------------------------
//  RootComponent on Resize

();RootComponent.on('resize', function () {
    return window.objectFitPolyfill();
}

//* ---------------------------------------
//  RootComponent on Render

);RootComponent.on('render', function () {
    return Object.keys(Components).filter(function (key) {
        return 'selector' in Components[key] && typeof Components[key] === 'function' && document.querySelector(Components[key].selector());
    }).forEach(function (key) {
        return Array.from(document.querySelectorAll(Components[key].selector() + ':not([data-rendered])')).forEach(function (el) {
            console.groupCollapsed(key);

            var component = new Components[key]({
                el: el,
                props: el.dataset
            });

            window.objectFitPolyfill();

            console.log(component);
            console.groupEnd();
        });
    });
}

//* ---------------------------------------
//  RootComponent on Scroll Toggling

);RootComponent.on('scroll:disable', function () {
    return document.documentElement.classList.add('overflow-hidden');
});

RootComponent.on('scroll:enable', function () {
    return document.documentElement.classList.remove('overflow-hidden');
}

//* ---------------------------------------
// RootComponent Init

);RootComponent.emit('render');

export { RootComponent };
